import { TranslationKey } from './fr';

const translationEs: Record<TranslationKey, string> = {
    'metadata.description': 'El back-office de Innovorder',
    'cookies.banner.message':
        'Nuestro sitio web utiliza cookies para mejorar su experiencia. Al continuar navegando, usted acepta el uso de estas cookies. Para obtener más información sobre nuestra política de privacidad y gestionar sus preferencias de cookies, consulte nuestra página dedicada.',
    'cookies.banner.accept': 'Aceptar',
    'cookies.banner.decline': 'Rechazar',
    'legend.DELIVERY': 'Entrega a domicilio',
    'legend.DRIVE': 'Drive',
    'legend.SIT_IN': 'En el local',
    'legend.TAKE_AWAY': 'Para llevar',
    'legend.KIOSK': 'Quiosco',
    'legend.WEB': 'Pedido en línea',
    'legend.RECEPTION': 'Recepción',
    'legend.POS': 'Caja',
    'legend.LOYALTY': 'Fidelización',
    'legend.EWALLET_KIOSK': 'Quiosco ewallet',
    'legend.VENDING_MACHINE': 'Máquinas expendedoras',
    'analyticsPage.needBrandSelection': 'Como usted es administrador, debe seleccionar al menos una enseña.',
    'analyticsPage.notAuthorizedToSeeBrand': 'No está autorizado a ver esta enseña.',
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        'No puede seleccionar simultáneamente enseñas de restauración colectiva y comercial.',
    'analyticsPage.reload': 'Actualizar datos',
    'beta_banner.message': '👋 Esta es una versión <b>beta</b>; numerosas mejoras y correcciones están en camino.',
    'analytics.metabaseError': 'Se ha producido un error, inténtelo de nuevo más tarde.',
    'analytics.noAdmin':
        'Lamentablemente, IO Analytics aún no está disponible en modo administrador… No se preocupe, ¡estará disponible pronto!',
    'analytics.realTime': 'Tiempo real',
    'analytics.ranking': 'Clasificación',
    'analytics.products': 'Productos',
    'analytics.sales': 'Ventas',
    'analytics.salesSummary': 'Síntesis financiera',
    'analytics.demoStaging': 'Demo (Staging)',
    'analytics.attendance': 'Afluencia',
    'analytics.billing': 'Facturación',
    'analytics.dashboard': 'Metabase dashboard',
    'analytics.filter.restaurant': 'Filtrar por restaurante',
    'analytics.filter.group': 'Filtrar por grupo',
    'analytics.filter.consumption': 'Modo de consumo',
    'analytics.filter.channel': 'Canales',
    'analytics.filter.HT': 'Sin IVA',
    'analytics.filter.TTC': 'Con IVA',
    'analytics.filter.takeAway': 'Para llevar',
    'analytics.filter.sitIn': 'En el local',
    'analytics.filter.delivery': 'Entrega a domicilio',
    'analytics.filter.drive': 'Drive',
    'analytics.filter.kiosk': 'Quiosco',
    'analytics.filter.web': 'Pedido en línea',
    'analytics.filter.pos': 'Caja',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': 'Distribución automática',
    'leaderboard.title': 'Clasificación de restaurantes',
    'leaderboard.ranking': 'Posición',
    'leaderboard.restaurantName': 'Restaurantes',
    'leaderboard.revenue': 'Facturación',
    'leaderboard.averageBasket': 'Ticket medio',
    'leaderboard.ordersCount': 'Pedidos',
    'leaderboard.RestaurantSearchPlaceholder': 'Buscar un restaurante',
    'tile.genericErrorMessage': '¡Se ha producido un error!',
    'tile.errorHint': 'Por favor, actualice los datos',
    'random.or': 'o',
    'tooltip.example.label': 'Ejemplo:',
    'iopay.configuration.title': 'Configuración de Adyen',
    'iopay.commissions.online.title': 'Comisiones en línea',
    'iopay.commissions.proximity.title': 'Comisiones de proximidad',
    'iopay.form.name': 'Etiqueta',
    'iopay.form.placeholder.name': 'Etiqueta',
    'iopay.form.accountHolder': 'Identificador del titular de la cuenta',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': 'Identificador de la cuenta financiera',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': 'Identificador del vendedor',
    'iopay.form.placeholder.storeId': 'Identificador del vendedor',
    'iopay.form.transferInstrumentId': 'Identificador del instrumento de transferencia',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': 'Importe de las comisiones fijas (en céntimos de euro)',
    'iopay.form.fixProximityCommissionAmount': 'Importe de las comisiones fijas (en céntimos de euro)',
    'iopay.form.placeholder.fixOnlineCommissionAmount': 'Importe de las comisiones fijas (en céntimos de euro)',
    'iopay.form.placeholder.fixProximityCommissionAmount': 'Importe de las comisiones fijas (en céntimos de euro)',
    'iopay.form.variableOnlineCommissionPercent': 'Porcentaje de comisiones variables',
    'iopay.form.variableProximityCommissionPercent': 'Porcentaje de comisiones variables',
    'iopay.form.placeholder.variableOnlineCommissionPercent': 'Porcentaje de comisiones variables',
    'iopay.form.placeholder.variableProximityCommissionPercent': 'Porcentaje de comisiones variables',
    'edenred.configuration.title': 'Configuración del módulo Edenred',
    'edenred.form.description':
        'Configure la integración de Edenred introduciendo la información necesaria. Una vez guardada, el Merchant ID del restaurante se recuperará automáticamente.',
    'edenred.form.warning.toSend': 'Información guardada y aún modificable antes de enviarla a Edenred.',
    'edenred.form.warning.sent': 'En proceso de tramitación por Edenred.',
    'edenred.form.mid': 'Merchant ID',
    'edenred.form.name': 'Nombre del restaurante',
    'edenred.form.placeholder.name': 'El nombre de mi restaurante',
    'edenred.form.siret': 'Siret',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': 'Dirección',
    'edenred.form.placeholder.address': '5 avenue Anatole France',
    'edenred.form.zipCode': 'Código postal',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': 'Ciudad',
    'edenred.form.placeholder.city': 'París',
    'paygreen.configuration.title': 'Configuración del módulo de Títulos Restaurante',
    'paygreen.form.description':
        'Una vez creada su cuenta mediante el formulario habilitado anteriormente, se le enviarán las claves pública y privada para configurar el módulo.',
    'paygreen.form.ongoing_v3_migration':
        'Se está preparando una migración de la versión de Paygreen; no es necesaria ninguna acción por su parte en el back-office.',
    'paygreen.form.enablePaygreenV3': 'Activar Paygreen V3',
    'paygreen.form.label': 'Nombre de la integración',
    'paygreen.form.publicKey': 'V2 Clave pública (shopId)',
    'paygreen.form.privateKey': 'V2 Clave privada (token)',
    'paygreen.form.secretKey': 'V3 Clave secreta',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.subShopId': 'V3 Sub shop ID (solo si está en modo marketplace)',
    'paygreen.form.supportsLuncheon': 'Pagos con Pass Restaurant (Sodexo) o Chèque Déjeuner (Up)',
    'paygreen.form.supportsSwile': 'Pagos con Swile (antes Lunchr)',
    'paygreen.form.supportsRestoflash': 'Pagos con Resto Flash',
    'paygreen.form.placeholder.enablePaygreenV3': 'Activar Paygreen V3',
    'paygreen.form.placeholder.label': 'Nombre de la integración',
    'paygreen.form.placeholder.publicKey': 'V2 Clave pública (shopId)',
    'paygreen.form.placeholder.privateKey': 'V2 Clave privada (token)',
    'paygreen.form.placeholder.secretKey': 'V3 Clave secreta',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 Sub shop ID (solo si está en modo marketplace)',
    'paygreen.form.placeholder.supportsLuncheon': 'Pagos con Pass Restaurant (Sodexo) o Chèque Déjeuner (Up)',
    'paygreen.form.placeholder.supportsSwile': 'Pagos con Swile (antes Lunchr)',
    'paygreen.form.placeholder.supportsRestoflash': 'Pagos con Resto Flash',
    'ubereats.title': 'Configuración de UberEats',
    'ubereats.description.firstpart':
        'Configure su integración de Ubereats definiendo su referencia UUID disponible en la interfaz de Ubereats de su restaurante. Si no sabe dónde encontrar esta información:',
    'ubereats.description.secondpart': '¿Cómo encontrar el Store ID de mi restaurante?',
    'ubereats.description.thirdpart':
        'Una vez configurado, su caja recibirá automáticamente los pedidos de Ubereats en la sección de entregas.',
    'ubereats.storid': 'ID de la tienda',
    'ubereats.activestorids': 'Store ID activo(s)',
    'deliverect.title': 'Configuración del módulo Deliverect',
    'deliverect.subtitle': '¿Cómo configurar mi integración con Deliverect?',
    'deliverect.description.firstpart':
        'Previamente, debe ponerse en contacto con un account manager para poder crear una cuenta en el entorno de Deliverect.',
    'deliverect.description.secondpart':
        'Una vez activada esta cuenta, podrá habilitar el envío de pedidos en los canales de su elección directamente desde esta interfaz.',
    'deliverect.description.thirdpart': 'También podrá sincronizar sus productos desde la interfaz.',
    'deliverect.contact': 'Contactar con un account manager',
    'deliveroo.title': 'Configuración del módulo Deliveroo',
    'deliveroo.subtitle': '¿Cómo configurar mi integración con Deliveroo?',
    'deliveroo.description.firstpart':
        'Previamente, debe ponerse en contacto con un account manager para poder crear una cuenta en el entorno de Deliveroo.',
    'deliveroo.description.secondpart':
        'Una vez configurada esta cuenta, su caja recibirá automáticamente los pedidos de Deliveroo en la sección de entregas.',
    'deliveroo.description.thirdpart': 'También podrá sincronizar sus productos desde la interfaz de Deliveroo.',
    'deliveroo.contact': 'Contactar con un account manager',
    'crous.title': 'Configuración del módulo de sincronización de catálogo CROUS',
    'crous.description':
        'Elija el restaurante cuyo catálogo desea importar e introduzca el número de caja del CROUS comunicado por el cliente (pos_id).',
    'crous.listcrousrestaurants.label': 'Restaurantes Crous',
    'crous.listcrousrestaurants.placeholder': 'Seleccione un restaurante',
    'crous.numerocaisse.label': 'Número de caja del Crous',
    'crous.numerocaisse.placeholder': 'Introduzca el número de caja del Crous',
    'crous.apikey.label': 'Clave API del Crous',
    'crous.apikey.placeholder': 'Introduzca la clave API del Crous',
    'marketplace.vatdefault.placeholder': 'IVA por defecto (%)',
    'marketplace.vatdefault.message': 'IVA por defecto',
    'marketplace.storid.label': 'ID de sus ubicaciones:',
    'marketplace.storid.placeholder': 'Indique uno o varios IDs de ubicación',
    'marketplace.storid.unknown': 'ID de la tienda desconocido',
    'marketplace.storid.alreadyused': 'Este UUID ya está presente ({name})',
    'marketplace.activestorids.label': 'Marcas virtuales activas:',
    'marketplace.activestorids.emptystate': 'No tiene ninguna marca virtual activa',
    'marketplace.location.title': 'Marca {counter}',
    'marketplace.location.delete': 'Eliminar',
    'status.status': 'Estado',
    'status.active': 'Activo',
    'status.inactive': 'Inactivo',
    'status.disabled': 'No disponible',
    'status.loading': 'Cargando',
    'status.unknown': 'Desconocido',
    'status.new': 'Nuevo',
    'status.file_uploaded': 'Archivo cargado',
    'status.processing': 'Procesando',
    'status.done': 'Finalizado',
    'status.error': 'Error',
    'date.created': 'Fecha de creación',
    'date.updated': 'Fecha de actualización',
    'external_pos.pos_ref.label': 'ID del POS Deliverect:',
    'external_pos.pos_ref.placeholder': 'Indique el ID de su POS Deliverect',
    'external_pos.title': 'Configuración del POS externo Deliverect',
    'external_pos.subtitle': '¿Cómo configurar mi POS externo Deliverect?',
    'external_pos.description.firstpart':
        'Previamente, debe ponerse en contacto con un account manager para poder crear una cuenta en el entorno de Deliverect.',
    'external_pos.description.secondpart':
        'Una vez configurado su POS externo Deliverect, recibirá los pedidos realizados en los canales de Innovorder activados.',
    'external_pos.description.thirdpart':
        'Con esta integración, le recomendamos gestionar y sincronizar sus menús desde Deliverect.',
    'external_pos.contact': 'Contactar con un account manager',
    'external_pos.channels.title': 'Integración POS externo Deliverect:',
    'external_pos.channels.subtitle': 'Canales activos:',
    'webhook_url.label': 'URL del Webhook',
    'webhook_url.placeholder': 'URL del Webhook',
    'webhook_secret.label': 'Clave secreta del Webhook',
    'webhook_secret.placeholder': 'Indique la clave secreta del webhook',
    'webhook.headers.label': 'Cabeceras HTTP adicionales',
    'webhook.headers.name.placeholder': 'Nombre de cabecera',
    'webhook.headers.value.placeholder': 'Valor de cabecera',
    'webhook.channels.title': 'Canales de activación del Webhook',
    'webhook.channels.subtitle': 'Canales disponibles:',
    'webhook.title': 'Configuración del webhook',
    'webhook.firstpart.subtitle': 'Función de este webhook',
    'webhook.firstpart.description':
        'La función de este webhook es notificar que un pedido ha sido realizado por uno de sus comensales en Innovorder.\nSi se produce una venta para un comensal identificado por una tarjeta, se realiza una llamada a este webhook para enviarle la información necesaria sobre dicho pedido.',
    'webhook.secondpart.subtitle': '¿Cómo configurar el webhook?',
    'webhook.secondpart.description':
        'Debe introducir la URL del webhook.\nLa clave secreta del webhook se genera automáticamente.\nSimplemente haga clic en los canales que desea activar para este webhook.\nUna vez configurado, el servicio debe devolver un código de respuesta HTTP 200 con un cuerpo de respuesta vacío para acusar recibo del evento webhook.',
    'webhook.documentationLink': 'Consultar la documentación de este webhook',
    'webhook.modal.warning': 'Atención',
    'webhook.modal.confirmDelete': '¿Está seguro de que desea eliminar?',
    'webhook.channels.kiosk': 'Quiosco',
    'webhook.channels.web': 'CEL',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': 'Escaneo de bandeja',
    'webhook.channels.vendingMachine': 'Distribución\nautomática',
    'webhook.eventTypes.title': 'Tipos de eventos',
    'webhook.eventTypes.subtitle': 'Tipos de eventos disponibles:',
    'webhook.brand.title': 'Configuración de los webhooks',
    'webhook.brand.firstpart.subtitle': 'Función de este webhook',
    'webhook.brand.firstpart.description':
        'Los webhooks le permiten recibir notificaciones en tiempo real cuando se producen eventos específicos en su sistema Innovorder. Puede configurar webhooks para que se activen con distintos eventos, como actualizaciones de datos de clientes, eventos de transacción o notificaciones de pedidos. Cuando se produce un evento, Innovorder enviará una solicitud HTTP POST a su endpoint especificado con los datos pertinentes.',
    'webhook.brand.secondpart.subtitle': '¿Cómo configurar el webhook?',
    'webhook.brand.secondpart.description':
        '1. Proporcione la URL del webhook donde desea recibir las notificaciones.\n2. Seleccione los tipos de eventos que desea supervisar entre las opciones disponibles.\n3. Elija los canales en los que estos eventos deben activar el webhook.\n4. Añada cabeceras HTTP adicionales si su endpoint lo requiere.\n5. La clave secreta del webhook se genera automáticamente por razones de seguridad.\n\nSu endpoint debe devolver un código de estado HTTP 200 para confirmar la recepción del evento webhook.',
    'webhook.system.badge': 'Sistema',
    'webhook.system.readonly': 'Este webhook está gestionado por el sistema y no puede modificarse.',
    'login.panelTitle': 'Bienvenido a su Backoffice',
    'login.login': 'Iniciar sesión',
    'login.password': 'Contraseña',
    'login.ssoChecking': 'Verificando SSO…',
    'login.ssoEnabled': 'El SSO está activado para este correo electrónico.',
    'login.ssoLogin': 'Iniciar sesión con SSO',
    'login.ssoFailed': 'Error al conectar mediante SSO. Por favor, inténtelo de nuevo.',
    'login.ssoLoginRequired': 'Esta cuenta requiere inicio de sesión mediante SSO. Redirigiendo…',
    'login.noBrandsConfigured': 'No hay ninguna enseña configurada para este usuario.',
    'login.guestBrandLoginFailed': 'Error al iniciar sesión. Por favor, inténtelo de nuevo.',
    'login.rememberMe': 'Recordarme',
    'login.forgotPassword': '¿Olvidó su contraseña?',
    'login.accountLocked': 'Cuenta temporalmente bloqueada. Inténtelo de nuevo en {minutes} minutos.',
    'login.captchaRequired': 'Verificación de seguridad requerida.',
    'login.ipNotAllowed': 'Inicio de sesión no permitido desde esta dirección IP.',
    'login.accountDisabled': 'Esta cuenta ha sido desactivada por inactividad.',
    'extendAccount.title': 'Extensión de su cuenta',
    'extendAccount.loadingBody': 'Validando el enlace…',
    'extendAccount.successTitle': 'Cuenta prolongada',
    'extendAccount.successBody': 'Su cuenta ha sido prolongada. Ahora puede volver a iniciar sesión.',
    'extendAccount.invalidTitle': 'Enlace no válido',
    'extendAccount.invalidBody': 'Este enlace de extensión no es válido o ha expirado.',
    'extendAccount.expiredHint': 'Para recuperar el acceso a su cuenta, contacte a su administrador.',
    'extendAccount.missingTokenBody': 'El enlace está incompleto. Vuelva a abrir el enlace desde su correo.',
    'extendAccount.backToLogin': 'Volver al inicio de sesión',
    'forgotPassword.title': 'Contraseña olvidada',
    'forgotPassword.subtitle': 'Introduzca su correo electrónico para recibir un enlace de restablecimiento.',
    'forgotPassword.submit': 'Enviar el enlace',
    'forgotPassword.backToLogin': 'Volver al inicio de sesión',
    'forgotPassword.successTitle': 'Correo enviado',
    'forgotPassword.successMessage':
        'Si existe una cuenta para este correo electrónico, se acaba de enviar un enlace de restablecimiento. Compruebe su bandeja de entrada.',
    'forgotPassword.recaptchaLoading': 'Cargando reCAPTCHA…',
    'forgotPassword.recaptchaFailed': 'La verificación de reCAPTCHA ha fallado. Por favor, inténtelo de nuevo.',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA no disponible. Actualice la página e inténtelo de nuevo.',
    'forgotPassword.recaptchaNotConfigured':
        'Configuración incompleta (REACT_APP_RECAPTCHA_SITE_KEY). Contacte con el administrador.',
    'resetPassword.title': 'Nueva contraseña',
    'resetPassword.subtitle': 'Elija una nueva contraseña para su cuenta.',
    'resetPassword.submit': 'Restablecer',
    'resetPassword.backToLogin': 'Volver al inicio de sesión',
    'resetPassword.successTitle': 'Contraseña actualizada',
    'resetPassword.successMessage': 'Su contraseña se ha actualizado correctamente. Ahora puede iniciar sesión.',
    'resetPassword.invalidLinkTitle': 'Enlace no válido',
    'resetPassword.invalidLink':
        'Este enlace de restablecimiento no es válido o ha expirado. Solicite un nuevo enlace desde la página de inicio de sesión.',
    'resetPassword.passwordTooShort': 'La contraseña debe tener al menos {min} caracteres.',
    'resetPassword.passwordsMismatch': 'Las dos contraseñas no coinciden.',
    'mfa.verify.title': 'Verificación en dos pasos',
    'mfa.verify.subtitle': 'Introduzca el código de 6 dígitos generado por su aplicación de autenticación.',
    'mfa.verify.backupTitle': 'Código de seguridad',
    'mfa.verify.backupSubtitle': 'Introduzca uno de sus códigos de seguridad de un solo uso.',
    'mfa.verify.submit': 'Verificar',
    'mfa.verify.useBackupInstead': 'Usar un código de seguridad',
    'mfa.verify.useTotpInstead': 'Usar la aplicación de autenticación',
    'mfa.verify.useDifferentMethod': 'Usar otro método',
    'mfa.verify.chooser.title': 'Elija un método',
    'mfa.verify.chooser.subtitle': '¿Qué método desea usar para verificar su identidad?',
    'mfa.verify.chooser.webauthnHint': 'Use su clave de seguridad o biometría.',
    'mfa.verify.chooser.totpHint': 'Introduzca el código de su aplicación de autenticación.',
    'mfa.verify.failed': 'Código no válido. Por favor, inténtelo de nuevo.',
    'mfa.verify.tokenExpired': 'La sesión MFA ha expirado. Por favor, vuelva a iniciar sesión.',
    'mfa.verify.tabs.totp': 'Aplicación de autenticación',
    'mfa.verify.tabs.webauthn': 'Clave de seguridad / biometría',
    'mfa.verify.webauthn.title': 'Verificar con su clave de seguridad',
    'mfa.verify.webauthn.subtitle': 'Toque su clave de seguridad, use Touch ID u otro autenticador de plataforma.',
    'mfa.verify.webauthn.authenticate': 'Autenticar',
    'mfa.verify.webauthn.failed': 'Error de autenticación. Pruebe con otro método.',
    'mfa.verify.webauthn.noCredentials': 'No hay ninguna clave de seguridad registrada para esta cuenta.',
    'mfa.verify.webauthn.ceremonyFailed':
        'La autenticación fue cancelada o su navegador la rechazó. Vuelva a intentarlo.',
    'mfa.setup.title': 'Configurar la autenticación de dos factores',
    'mfa.setup.subtitle':
        'Escanee este código QR con su aplicación de autenticación (Google Authenticator, 1Password, etc.) y luego introduzca el código generado.',
    'mfa.setup.loadingQr': 'Cargando el código QR...',
    'mfa.setup.copySecret': 'Copiar la clave secreta',
    'mfa.setup.copied': '¡Copiado!',
    'mfa.setup.confirm': 'Confirmar',
    'mfa.setup.invalidCode': 'Código no válido. Compruebe la sincronización de su aplicación.',
    'mfa.setup.backupTitle': 'Guarde sus códigos de seguridad',
    'mfa.setup.backupSubtitle':
        'Conserve estos códigos en un lugar seguro. Le permitirán iniciar sesión si pierde el acceso a su aplicación de autenticación. Cada código solo puede utilizarse una vez.',
    'mfa.setup.backupAcknowledge': 'He guardado mis códigos, continuar',
    'mfa.setup.tabs.totp': 'Aplicación de autenticación',
    'mfa.setup.tabs.webauthn': 'Clave de seguridad / biometría',
    'mfa.setup.webauthn.title': 'Registrar una clave de seguridad',
    'mfa.setup.webauthn.subtitle':
        'Use una clave física (YubiKey), Touch ID, Windows Hello u otro autenticador de plataforma. Puede nombrar este dispositivo para identificarlo más tarde.',
    'mfa.setup.webauthn.deviceNamePlaceholder': "Nombre del dispositivo (ej. 'Mi portátil')",
    'mfa.setup.webauthn.register': 'Registrar',
    'mfa.setup.webauthn.ceremonyFailed':
        'El registro fue cancelado o su navegador rechazó la solicitud. Vuelva a intentarlo.',
    'mfa.setup.webauthn.finalizing': 'Finalizando su clave de seguridad…',
    'activateAccount.title': 'Activación de cuenta',
    'activateAccount.submit': 'Activar mi cuenta',
    'activateAccount.submitting': 'Activando...',
    'activateAccount.loading': 'Verificando el token...',
    'activateAccount.resend': 'Reenviar el correo de activación',
    'activateAccount.resending': 'Reenviando...',
    'activateAccount.renewSuccess':
        'Se ha enviado un nuevo correo de activación. Por favor, compruebe su bandeja de entrada.',
    'activateAccount.error.missingToken': 'Token no encontrado',
    'activateAccount.error.invalidToken': 'Token expirado',
    'activateAccount.error.password.minLength': 'La contraseña debe tener al menos {min} caracteres',
    'activateAccount.error.password.maxLength': 'La contraseña no debe superar {max} caracteres',
    'activateAccount.error.password.requireUppercase': 'La contraseña debe contener al menos una letra mayúscula',
    'activateAccount.error.password.requireLowercase': 'La contraseña debe contener al menos una letra minúscula',
    'activateAccount.error.password.requireNumbers': 'La contraseña debe contener al menos un número',
    'activateAccount.error.password.requireSpecialCharacters':
        'La contraseña debe contener al menos un carácter especial',
    'activateAccount.password.placeholder': 'Contraseña',
    'activateAccount.confirmPassword.placeholder': 'Confirmar contraseña',
    'sidebar.overview': 'Resumen',
    'sidebar.orders': 'Pedidos',
    'sidebar.customers': 'Clientes',
    'sidebar.brand': 'Enseña',
    'sidebar.brands': 'Enseñas',
    'sidebar.restaurants': 'Restaurantes',
    'sidebar.loyalty': 'Fidelización',
    'sidebar.coupons': 'Códigos promocionales',
    'sidebar.paymentMeans': 'Medios de pago',
    'sidebar.integrations': 'Integraciones',
    'sidebar.reports': 'Informes',
    'sidebar.reportsSales': 'Ventas',
    'sidebar.reportsEwallets': 'Saldos de tarjetas',
    'sidebar.monthly_sales_report': 'Informe de ventas mensuales',
    'sidebar.exports': 'Exportaciones',
    'sidebar.exportsAccounting': 'Contabilidad',
    'sidebar.exportsEwallets': 'E-wallet',
    'sidebar.exportsSales': 'Síntesis financiera',
    'sidebar.salesSummary': 'Síntesis financiera',
    'sidebar.exportsPreInvoicing': 'Prefacturación',
    'sidebar.exportsBadge': 'Movimientos de tarjetas',
    'sidebar.reportGenerationsHistory': 'Historial de generaciones',
    'sidebar.help': '¿Necesita ayuda?',
    'sidebar.languages': 'Idiomas',
    'sidebar.account': 'Mi cuenta',
    'sidebar.media': 'Medios',
    'sidebar.marketplaces': 'Marketplaces',
    'sidebar.urssaf': 'Mínimo Urssaf',
    'sidebar.vatRatesMatrix': 'Referencial de IVA',
    'sidebar.autoBilling': 'Facturación automática',
    'sidebar.logout': 'Cerrar sesión',
    'sidebar.password': 'Mi contraseña',
    'sidebar.security': 'Seguridad',
    'security.title': 'Seguridad',
    'security.loading': 'Cargando…',
    'security.actions.remove': 'Eliminar',
    'security.actions.cancel': 'Cancelar',
    'security.totp.title': 'Aplicación de autenticación',
    'security.totp.subtitle':
        'Códigos de un solo uso generados por una aplicación como Google Authenticator o 1Password.',
    'security.totp.label': 'Aplicación de autenticación',
    'security.totp.added': 'Añadido el {date}',
    'security.totp.empty': 'No hay ninguna aplicación de autenticación configurada.',
    'security.totp.add': 'Añadir una aplicación de autenticación',
    'security.totp.modalTitle': 'Configurar una aplicación de autenticación',
    'security.totp.confirmRemove': '¿Está seguro de que desea eliminar su aplicación de autenticación?',
    'security.passkeys.title': 'Claves de seguridad y passkeys',
    'security.passkeys.subtitle':
        'Claves físicas, Touch ID, Windows Hello y otros autenticadores registrados en esta cuenta.',
    'security.passkeys.empty': 'No hay claves de seguridad registradas.',
    'security.passkeys.unnamedDevice': 'Dispositivo sin nombre',
    'security.passkeys.lastUsed': 'Último uso: {date}',
    'security.passkeys.added': 'Añadida el {date}',
    'security.passkeys.add': 'Añadir una clave de seguridad',
    'security.passkeys.confirmRemove':
        '¿Está seguro de que desea eliminar esta clave? Ya no podrá utilizar este dispositivo para iniciar sesión.',
    'security.passkeys.ceremonyFailed':
        'El registro fue cancelado o su navegador rechazó la solicitud. Vuelva a intentarlo.',
    'security.passkeys.requestFailed': 'Se produjo un error. Vuelva a intentarlo.',
    'security.allowedIps.title': 'Direcciones IP permitidas',
    'security.allowedIps.subtitle':
        'Restrinja su inicio de sesión a una lista de IPs o rangos CIDR. Las IPs permitidas también omiten CAPTCHA y contadores de bloqueo.',
    'security.allowedIps.empty': 'Sin restricción. Puede iniciar sesión desde cualquier dirección IP.',
    'security.allowedIps.add': 'Añadir',
    'security.allowedIps.placeholder': '192.168.1.1 o 10.0.0.0/24',
    'security.allowedIps.invalid': 'Dirección IP o rango CIDR no válido.',
    'security.allowedIps.confirmRemoveTitle': '¿Quitar esta dirección IP?',
    'security.allowedIps.confirmRemove': 'Esta dirección ya no podrá iniciar sesión en su cuenta.',
    'security.allowedIps.cancel': 'Cancelar',
    'security.allowedIps.warning':
        'Atención: mientras la lista contenga al menos una entrada, no podrá iniciar sesión desde otra IP.',
    'sidebar.billing': 'Mi espacio de facturación',
    'sidebar.ioPay': 'Pagos',
    'sidebar.news': 'Novedades',
    'sidebar.analytics': 'Analytics',
    'message.message': 'Mensaje',
    'name.name': 'Nombre',
    'name.firstName': 'Nombre',
    'name.lastName': 'Apellidos',
    'notFound.message': 'Lo sentimos, la página solicitada no existe.',
    'notFound.backToHome': 'Volver al inicio',
    'permissionDenied.title': 'Acceso denegado',
    'permissionDenied.message': 'Lo sentimos, pero no tiene permiso para acceder a esta página.',
    'permissionDenied.backToHome': 'Volver al inicio',
    'errorPage.message':
        'Lo sentimos, estamos experimentando una dificultad técnica. Estamos haciendo todo lo posible para resolver el problema.',
    'errorPage.support': 'Contactar con soporte',
    'file.noFile': 'Ningún archivo',
    'file.cannotProcessJson': 'El archivo JSON no puede procesarse. Verifique su formato.',
    'file.fileNotAllowed': 'Este tipo de archivo no está permitido. Extensiones permitidas: {allowedExtensionsString}',
    'file.fileTemplate': 'plantilla de archivo',
    'file.metabaseLink': 'enlace de metabase',
    'fileInput.placeholder.title': '¡Inserte sus archivos!',
    'fileInput.placeholder.drop': '¡Suelte sus archivos aquí!',
    'fileInput.placeholder': 'Arrastre y suelte uno o varios archivos en la ventana',
    'fileInput.browse': 'Importar desde su ordenador',
    'imageInput.section.modal.title': 'Añadir una imagen',
    'imageInput.section.modal.resize.label': 'Modo imagen de fondo',
    'imageInput.section.modal.resize.details':
        'Utilice esta opción cuando envíe imágenes que se utilizarán como fondo para quioscos o pedidos en línea.',
    'imageInput.section.library.title': 'Desde la galería',
    'imageInput.section.upload.title': 'Desde mi ordenador',
    'languages.fr_FR': 'Francés',
    'languages.en_EN': 'Inglés',
    'languages.it_IT': 'Italiano',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': 'Español',
    'languages.zh-CN_ZH-CN': 'Chino (simplificado)',
    'languages.zh-TW_ZH-TW': 'Chino (tradicional)',
    'languages.ar_AR': 'Árabe',
    'languages.de_DE': 'Alemán',
    'button.add': 'Añadir',
    'button.delete': 'Eliminar',
    'button.edit': 'Modificar',
    'button.configure': 'Configurar',
    'button.cancel': 'Cancelar',
    'button.close': 'Cerrar',
    'button.generate': 'Generar',
    'button.save': 'Guardar',
    'button.import': 'Importar',
    'button.publish': 'Publicar',
    'button.saveAndPublish': 'Guardar y publicar',
    'button.uploadFile': 'Subir un archivo',
    'button.previous': 'Anterior',
    'button.next': 'Siguiente',
    'button.ok': 'OK',
    'button.validate': 'Validar',
    'button.refresh': 'Actualizar',
    'button.confirm': 'Confirmar',
    'button.yes': 'Sí',
    'button.understand': 'Entendido',
    'button.convertToCrossSell': 'Convertir en venta adicional',
    'button.convertToCustomization': 'Convertir en personalización',
    'button.skipStep': 'Omitir este paso',
    'button.block': 'Bloquear',
    'button.unblock': 'Desbloquear',
    'select.selectAll': 'Seleccionar todo',
    'switch.activate': 'Activar',
    'form.preventLeave': 'Tiene cambios sin guardar. ¿Está seguro de que desea salir de esta página?',
    'field.required': 'Este campo es obligatorio',
    'field.optional': '(opcional)',
    'field.greaterThanZero': 'Este campo debe ser mayor que 0',
    'field.invalidEmail': 'Este correo electrónico no es válido',
    'field.invalidURL': 'Esta URL no es válida',
    'field.atLeastOneEventType': 'Debe seleccionarse al menos un tipo de evento',
    'field.unmatchedPassword': 'Las dos contraseñas deben ser idénticas',
    'field.invalidPassword': 'Su contraseña debe tener al menos 8 caracteres',
    'field.invalidPhoneNumber': 'Número de teléfono no válido',
    'field.duplicate_email': 'Este correo electrónico ya existe',
    'field.duplicate_student_number': 'Este N.º de comensal ya existe',
    'field.duplicate_badge_number': 'Este N.º de tarjeta ya existe',
    'field.minTwo': 'Este campo debe tener al menos 2 caracteres',
    'field.ewallet_is_not_null_to_postpayment':
        'Para convertir al comensal en tipo de cuenta pospago, su saldo debe ser obligatoriamente 0 €',
    'select.enabled': 'Activado',
    'select.customised': 'Personalizado',
    'select.disabled': 'Desactivado',
    'table.search': 'Buscar',
    'table.searchColumn': 'Buscar {name}',
    'table.searchColumn.placeholder': 'Buscar un valor',
    'table.searchColumn.placeholder.from': 'Mín',
    'table.searchColumn.placeholder.to': 'Máx',
    'table.searchColumn.clearFilter': 'Eliminar filtros',
    'table.clearAllFilters': 'Eliminar todos los filtros',
    'table.rowsPerPage': 'Filas por página',
    'table.firstPage': 'Primera',
    'table.lastPage': 'Última',
    'table.noRowsAfterFilter': 'Ningún resultado coincide con su búsqueda',
    'table.noRowsAfterFilter.dateRangeHint': '¿Ha intentado cambiar el intervalo de fechas?',
    'table.noRowsAfterFilter.dateRangePresetHint': 'Sin resultados en los últimos {days} días.',
    'table.noRowsAfterFilter.dateRangeCustomHint': 'Sin resultados en el período seleccionado.',
    'table.noRowsAfterFilter.dateRangeAction': 'Modifique el intervalo de fechas para mostrar pedidos.',
    'table.sort': 'Ordenar por {name}',
    'table.columnSelection.button': 'Gestión de columnas',
    'table.columnSelection.buttonFiltered': 'Gestión de columnas ({count})',
    'table.columnSelection.header': 'Filtrar columnas',
    'table.columnSelection.placeholder': 'Buscar una columna',
    'table.columnSelection.allEntries': 'Todas las columnas',
    'table.selection.count':
        '{count} fila{count, plural, =1 {} other {s}} seleccionada{count, plural, =1 {} other {s}}',
    'table.empty': 'No hay datos disponibles',
    'pagination.previous': 'Anterior',
    'pagination.next': 'Siguiente',
    'navigation.back': 'Volver',
    'navigation.next': 'Siguiente',
    'navigation.disabled': 'Volver',
    'navigation.backToV1': 'Volver a la versión anterior',
    'savingBar.changesDone':
        '{changesCount, plural, =0 {} one {# modificación realizada} other {# modificaciones realizadas}}',
    'ticketLabel.name.mismatch.confirmation':
        'Atención: el nombre del producto ha cambiado, pero la etiqueta de producción se ha mantenido igual. ¿Confirma este cambio?',
    'form.validation.integer': 'Este campo debe ser un número entero',
    'form.validation.positive': 'Este campo debe ser positivo',
    'form.validation.positiveOrZero': 'Este campo debe ser positivo o igual a cero',
    'form.validation.length': 'Este campo debe contener {length} caracteres',
    'form.validation.maxLength': 'Este campo supera el tamaño permitido',
    'form.validation.email': 'Este campo debe ser un correo electrónico válido',
    'form.validation.mustMatchValue': 'Este campo debe ser {value1} o {value2 }',
    'form.validation.siret.length': 'El número SIRET debe tener 14 caracteres (sin espacios)',
    'form.validation.siret.invalid': 'El número SIRET no es válido',
    'integrations.section.title': 'Soluciones de pago',
    'integrations.section.subtitle':
        'Las soluciones de pago le permiten ofrecer funcionalidades como el pago en línea con tarjeta bancaria o mediante TPV en el punto de venta.',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription':
        'Integre Stripe en su sitio y permita a sus clientes conectar fácilmente su cuenta para una experiencia de pedido en línea óptima.',
    'integrations.configured': 'Configurado',
    'integrations.notConfigured': 'No configurado',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        'Las distintas integraciones Webhook se listan aquí. Es posible crear un nuevo Webhook haciendo clic en el botón "+" o modificar un Webhook existente haciendo clic sobre él. Un estado permite visualizar la configuración actual.',
    'pricingRule.emptyMessage': 'Ningún régimen tarifario asociado a esta enseña.',
    'pricingRule.tableCard.title': 'Regímenes tarifarios',
    'pricingRule.tableCard.subtitle':
        'Los regímenes tarifarios son conjuntos de una o varias admisiones, subvenciones y componentes fuera de facturación.',
    'pricingRule.tableCard.description':
        'Si el régimen tarifario contiene una subvención en % y una subvención en €, coloque en primera posición la subvención que debe deducirse del importe total del pedido. Las subvenciones siguientes se aplicarán sobre el importe restante a pagar, tras la deducción de las subvenciones anteriores.',
    'pricingRule.tableCard.action': '+ Crear un nuevo régimen',
    'pricingRule.code': 'Código',
    'pricingRule.applyScope': 'Estrategia',
    'pricingRule.strategy': 'Estrategia',
    'pricingRule.labelTicket': 'Etiqueta del tíquet',
    'pricingRule.grants_fees.amount': 'Importe',
    'pricingRule.grants_fees.dailyLimit': 'Límite diario',
    'pricingRule.grants': 'Subvenciones',
    'pricingRule.entranceFees': 'Admisiones',
    'pricingRule.excludedTurnover': 'Fuera de facturación',
    'pricingRule.associatedPricingRules': 'Regímenes tarifarios asociados',
    'pricingRule.action': 'Acción',
    'pricingRule.product': 'Parte alimentaria',
    'pricingRule.fee': 'Gastos incluidos derechos de entrada',
    'pricingRule.modal.warning': 'Atención',
    'pricingRule.modal.required': 'El campo `Régimen tarifario` es obligatorio',
    'pricingRule.modal.confirmDelete': '¿Está seguro de que desea eliminar?',
    'pricingRule.modal.delete.error.detail': 'Este régimen tarifario está vinculado a uno o varios comensales',
    'pricingRule.modal.unassociatedUser': 'el comensal ya no tendrá régimen tarifario',
    'pricingRule.modal.unassociatedUsers': 'los comensales ya no tendrán régimen tarifario',
    'pricingRule.form.title': 'Régimen tarifario',
    'pricingRule.form.description':
        'Configure el régimen tarifario agrupando las subvenciones existentes de su elección.',
    'pricingRule.form.creation': 'Creación de un régimen tarifario',
    'pricingRule.form.update': 'Modificación de un régimen tarifario',
    'pricingRule.form.pricingRuleCode': 'Código de régimen tarifario',
    'pricingRule.form.applyScope': 'Estrategia',
    'pricingRule.form.authorizedChannels': 'Canales autorizados',
    'pricingRule.form.isUrssafEnabled': '¿Aplicar el mínimo URSSAF a este régimen tarifario?',
    'pricingRule.form.composition': 'Defina la composición de este régimen tarifario',
    'pricingRule.form.compositionDescription':
        'Los regímenes tarifarios son conjuntos de una o varias admisiones, subvenciones y componentes fuera de facturación.',
    'pricingRule.emptyGrant': 'Ninguna subvención asociada a este régimen tarifario.',
    'pricingRule.emptyEntranceFee': 'Ninguna admisión asociada a este régimen tarifario.',
    'pricingRule.emptyTurnoverExcluded': 'Ningún componente fuera de facturación asociado a este régimen tarifario.',
    'pricingRule.emptyAssociatedPricingRule': 'Ningún régimen tarifario asociado a este régimen tarifario.',
    'pricingRule.noResult': 'Sin resultados',
    'pricingRule.addGrant': 'Añadir una subvención',
    'pricingRule.addEntranceFee': 'Añadir una admisión',
    'pricingRule.addComponentWithoutTurnover': 'Añadir un componente fuera de facturación',
    'pricingRule.addAssociatedPricingRule': 'Añadir un régimen tarifario asociado',
    'pricingRule.search': 'Buscar un régimen tarifario',
    'pricingRule.channels.kiosk': 'Quiosco',
    'pricingRule.channels.pos': 'Caja',
    'pricingRule.channels.web': 'Pedido en línea',
    'pricingRule.channels.ewalletKiosk': 'Quiosco de recarga',
    'pricingRule.channels.vendingMachine': 'Distribución automática',
    'pricingRule.action.import': 'Importar',
    'pricingRule.action.export': 'Exportar',
    'pricingRule.modal.import.title': 'Importar admisiones, subvenciones y regímenes tarifarios',
    'pricingRule.modal.import.firstPart': 'Descargue la {fileTemplate} en su ordenador',
    'pricingRule.modal.import.secondPart':
        'Rellene la plantilla con la información de sus admisiones, subvenciones y regímenes tarifarios que desea añadir o modificar',
    'pricingRule.modal.import.thirdPart': 'Importe su nuevo archivo haciendo clic en el botón a continuación',
    'pricingRule.modal.import.warning':
        'La eliminación de una admisión, subvención o régimen tarifario se realiza únicamente desde el backoffice de Innovorder',
    'pricingRule.modal.import.secondWarning':
        '⚠️\nLa importación de admisiones o subvenciones elimina DEFINITIVAMENTE los valores personalizados.\n(los valores personalizados por restaurante o por servicio)\n',
    'pricingRule.modal.import.report.title': 'Informe de importación',
    'pricingRule.modal.import.report.result': 'Resultado de la importación',
    'pricingRule.modal.import.report.success': 'Éxito',
    'pricingRule.modal.import.report.error': 'Error',
    'pricingRule.modal.import.report.warning': 'Alerta',
    'pricingRule.modal.import.report.entranceFees': 'Admisiones',
    'pricingRule.modal.import.report.grants': 'Subvenciones',
    'pricingRule.modal.import.report.pricingRules': 'Regímenes tarifarios',
    'pricingRule.modal.import.report.successMessage': '• creación: {created}\n • modificación: {updated}',
    'pricingRule.modal.import.report.errorMessage': '• Línea {line} - {field}: {message}',
    'pricingRule.export.report.entranceFee.entranceFeeId': 'Identificador de la admisión',
    'pricingRule.export.report.entranceFee.code': 'Código de admisión',
    'pricingRule.export.report.entranceFee.labelTicket': 'Etiqueta del tíquet',
    'pricingRule.export.report.entranceFee.amount': 'Importe (en €)',
    'pricingRule.export.report.entranceFee.dailyLimit': 'Límite diario',
    'pricingRule.export.report.entranceFee.strategy':
        'Estrategia (1 para siempre / 2 para límite diario + producto asignado)',
    'pricingRule.export.report.entranceFee.vat': 'IVA',
    'pricingRule.export.report.entranceFee.type': 'Facturación (incluido/excluido)',
    'pricingRule.export.report.entranceFee.type.admissionfee': 'incluido',
    'pricingRule.export.report.entranceFee.type.royaltyfee': 'excluido',
    'pricingRule.export.report.entranceFee.active':
        'Activo en todos los restaurantes por defecto (sí / no) (solo para creación)',
    'pricingRule.export.report.grant.grantId': 'Identificador de la subvención',
    'pricingRule.export.report.grant.code': 'Código de subvención',
    'pricingRule.export.report.grant.labelTicket': 'Etiqueta del tíquet',
    'pricingRule.export.report.grant.threshold': 'Umbral de activación en € (vacío si ninguno)',
    'pricingRule.export.report.grant.type': 'Tipo de importe (Absoluto / Porcentaje)',
    'pricingRule.export.report.grant.type.absolute': 'Absoluto',
    'pricingRule.export.report.grant.type.rate': 'Porcentaje',
    'pricingRule.export.report.grant.ceiling': 'Tope de subvención en € (obligatorio si tipo = Porcentaje)',
    'pricingRule.export.report.grant.amount': 'Importe (en €)',
    'pricingRule.export.report.grant.dailyLimit': 'Límite diario',
    'pricingRule.export.report.grant.strategy':
        'Estrategia (1 para límite diario + importe / 2 para límite diario + importe + productos asignados)',
    'pricingRule.export.report.grant.tag': 'Etiquetas (vacío si no hay aplicación sobre etiqueta)',
    'pricingRule.export.report.grant.active': 'Activo en todos los restaurantes por defecto (sí / no)',
    'pricingRule.export.report.pricingRule.pricingRuleId': 'Identificador del régimen tarifario',
    'pricingRule.export.report.pricingRule.code': 'Código de régimen tarifario',
    'pricingRule.export.report.pricingRule.canals':
        'Canales (caja, quiosco de recarga, distribución automática, quiosco y/o pedido en línea)',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        '¿Aplicar el mínimo URSSAF (solo para la API de cesta)? (sí/no)',
    'pricingRule.export.report.pricingRule.entranceFees':
        'Admisión/es incluida/s (indique el código y, si son varias, sepárelas con coma + espacio)',
    'pricingRule.export.report.pricingRule.grants':
        'Subvención/es incluida/s (indique el código y, si son varias, sepárelas con coma + espacio)',
    'pricingRule.export.report.pricingRule.includeCA': 'Fuera de facturación incluidos',
    'pricingRule.export.report.pricingRule.applyScope':
        'Estrategia (gastos incluidos derechos de entrada y/o parte alimentaria)',
    'pricingRule.export.report.pricingRule.applyScope.product': 'parte alimentaria',
    'pricingRule.export.report.pricingRule.applyScope.fee': 'gastos incluidos derechos de entrada',
    'entranceFee.create': 'Creación de una admisión',
    'entranceFee.title': 'Admisión',
    'entranceFee.description':
        'Indique el nombre, el importe y las reglas de la admisión para todos sus establecimientos.',
    'entranceFee.customUse': 'Aplicaciones particulares de la admisión',
    'entranceFee.descCustomUse': 'Activación y personalización por restaurante de la admisión',
    'entranceFee.warningForm': 'Complete todos los campos de su admisión antes de activarla en sus restaurantes.',
    'entranceFee.default': 'Por defecto',
    'entranceFee.code': 'Código de admisión',
    'entranceFee.codeAlreadyUsed': 'Código de admisión ya utilizado',
    'entranceFee.labelTicket': 'Etiqueta del tíquet',
    'entranceFee.amount': 'Importe',
    'entranceFee.vat': 'IVA',
    'entranceFee.strategy': 'Estrategia',
    'entranceFee.dailyLimit': 'Límite diario',
    'entranceFee.type': 'Facturación',
    'entranceFee.select.always': 'Límite diario',
    'entranceFee.select.daily': 'Límite diario + producto asignado',
    'entranceFee.select.salesExcluded': 'Excluido',
    'entranceFee.select.salesIncluded': 'Incluido',
    'entranceFee.emptyMessage': 'Ningún cargo de admisión asociado a esta enseña.',
    'entranceFee.table.state': 'Estado de activación',
    'entranceFee.table.services': 'Servicios activados',
    'entranceFee.table.state.enabled': 'Activado',
    'entranceFee.table.state.customised': 'Activado con valores personalizados',
    'entranceFee.table.state.disabled': 'Desactivado',
    'entranceFee.tableCard.title': 'Admisiones',
    'entranceFee.tableCard.subtitle':
        'Cree y gestione los diferentes cargos de admisión utilizados en sus restaurantes',
    'entranceFee.tableCard.action': '+ Crear una nueva admisión',
    'entranceFee.restaurants': 'Restaurantes',
    'entranceFee.restaurant': 'Restaurante',
    'entranceFee.action': 'Acción',
    'entranceFee.modal.warning': 'Atención',
    'entranceFee.modal.confirmDelete': '¿Está seguro de que desea eliminar?',
    'entranceFee.search': 'Buscar una admisión',
    'entranceFee.configuration.title': 'Aplicación particular de admisión - {name}',
    'entranceFee.configuration.header.title': 'Gestionar los servicios de este restaurante',
    'entranceFee.configuration.search': 'Buscar un servicio',
    'entranceFee.configuration.table.activation': 'Activación',
    'entranceFee.configuration.table.name': 'Nombre del servicio',
    'entranceFee.configuration.table.time': 'Horarios',
    'entranceFee.configuration.table.days': 'Período',
    'entranceFee.configuration.table.amount': 'Importe',
    'entranceFee.configuration.table.vat': 'IVA',
    'entranceFee.configuration.table.defaultShift': 'Servicio por defecto',
    'entranceFee.warningShifts.title': 'Confirmación de la modificación',
    'entranceFee.warningShifts.shift': 'Servicio: {time} - Importe: {amount} - Diferencia: {variation}',
    'entranceFee.warningShifts.shift.amount': '\nImporte de la admisión: {amount}',
    'entranceFee.warningShifts.confirm': '¿Está seguro de que desea continuar?',
    'grant.create': 'Creación de una subvención',
    'grant.title': 'Subvención',
    'grant.description':
        'Indique el importe y las reglas de aplicación de la subvención para todos sus establecimientos.',
    'grant.description.title1': 'Estrategia 1: Límite diario + importe',
    'grant.customUse': 'Aplicaciones particulares de la subvención',
    'grant.descCustomUse': 'Activación y personalización por restaurante de la subvención',
    'grant.warningLimit': '⚠️ El límite diario personalizado no puede ser superior al definido por defecto.',
    'grant.warningForm': 'Complete todos los campos de su subvención antes de activarla en sus restaurantes.',
    'grant.desc1':
        'La subvención se aplica a todos los productos de la cesta respetando las siguientes reglas:\n        Si se define un umbral, solo el importe de la cesta superior al umbral se ve afectado.\n        Si se define un tope, el importe de la subvención no podrá superar dicho importe.\n        Si se define una etiqueta, solo los productos con esa etiqueta se verán afectados por la subvención.\n        ',
    'grant.description.title2': 'Estrategia 2: Límite diario + importe + productos asignados',
    'grant.desc2':
        'La subvención se aplica según las mismas reglas anteriores, pero además:\n    Si la subvención es en %, solo los productos indicados como subvencionables se verán afectados.\n    Si la subvención es en €, se activa únicamente si la cesta contiene al menos 1 producto indicado como subvencionable.',
    'grant.amount': 'Importe',
    'grant.default': 'Por defecto',
    'grant.code': 'Código de subvención',
    'grant.codeAlreadyUsed': 'Código de subvención ya utilizado',
    'grant.strategy': 'Estrategia',
    'grant.dailyLimit': 'Límite diario',
    'grant.type': 'Tipo de importe',
    'grant.tags': 'Aplicar únicamente a los productos con la siguiente etiqueta:',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': 'Etiqueta del ticket',
    'grant.select.rate': 'Porcentaje',
    'grant.select.absolute': 'Absoluto',
    'grant.select.minimum': 'Límite diario + importe',
    'grant.select.minimumAndProduct': 'Límite diario + importe mínimo + productos afectados',
    'grant.threshold': 'Umbral de activación',
    'grant.ceiling': 'Tope de subvención',
    'grant.restaurants': 'Restaurantes',
    'grant.action': 'Acción',
    'grant.emptyMessage': 'Ninguna subvención asociada a esta enseña.',
    'grant.tableCard.title': 'Subvenciones',
    'grant.tableCard.subtitle': 'Cree y gestione las distintas subvenciones utilizadas en sus restaurantes',
    'grant.tableCard.action': '+ Añadir una nueva subvención',
    'grant.settings.button': 'Ajustes',
    'grant.settings.modal.title': 'Ajustes de subvenciones',
    'grant.settings.modal.subtitle': 'Configure las reglas aplicables a las subvenciones de su marca.',
    'grant.settings.modal.toggle.label': 'Bloquear el pago con vales de comida cuando se aplica una subvención',
    'grant.settings.modal.toggle.description':
        'Si está activada, los métodos de pago con vales de comida (Edenred, Paygreen) no estarán disponibles para los comensales cuyo carrito contenga una subvención, en el pedido en línea (CELV2).',
    'grant.settings.modal.cancel': 'Cancelar',
    'grant.settings.modal.save': 'Guardar',
    'grant.table.enabled': 'Activar',
    'grant.table.state': 'Estado de activación',
    'grant.table.services': 'Servicios activados',
    'grant.table.state.enabled': 'Activado',
    'grant.table.state.customised': 'Activado con valores personalizados',
    'grant.table.state.disabled': 'Desactivado',
    'grant.table.restaurant': 'Restaurante',
    'grant.table.threshold': 'Activación',
    'grant.table.ceiling': 'Tope',
    'grant.table.dailyLimit': 'Límite diario',
    'grant.table.strategy': 'Estrategia',
    'grant.table.action': 'Acción',
    'grant.modal.warning': 'Atención',
    'grant.modal.confirmDelete': '¿Está seguro de que desea eliminar?',
    'grant.search': 'Buscar una subvención',
    'grant.configuration.title': 'Aplicación particular de subvención - {name}',
    'grant.configuration.header.title': 'Gestionar los servicios de este restaurante',
    'grant.configuration.search': 'Buscar un servicio',
    'grant.configuration.table.activation': 'Activación',
    'grant.configuration.table.name': 'Nombre del servicio',
    'grant.configuration.table.time': 'Horarios',
    'grant.configuration.table.days': 'Período',
    'grant.configuration.table.amount': 'Importe',
    'grant.configuration.table.threshold': 'Activación',
    'grant.configuration.table.ceiling': 'Tope',
    'grant.configuration.table.defaultShift': 'Servicio por defecto',
    'grant.warningShifts.title': 'Confirmación de la modificación',
    'grant.warningShifts.shift': '{time} - Importe: {amount} - Diferencia: {variation}',
    'grant.warningShifts.shift.amount': '\nImporte de la subvención: {amount}',
    'grant.warningShifts.confirm': '¿Está seguro de que desea continuar?',
    'group.tableCard.title': 'Grupos',
    'group.tableCard.action': '+ Crear un nuevo grupo',
    'group.tableCard.subtitle':
        'Defina las posibilidades de agrupación de sus comensales por grupo y asocie los distintos regímenes tarifarios.',
    'group.tableCard.subtitle2': 'Defina aquí las distintas posibilidades de organización de sus comensales.',
    'group.emptyMessage': 'Ningún grupo asociado a esta enseña.',
    'group.name': 'Grupo',
    'group.action': 'Acción',
    'group.pricingRules': 'Regímenes tarifarios',
    'group.guestsCount': 'Número de comensal(es)',
    'group.guestsCountLabel': 'comensal(es)',
    'group.modal.warning': 'Atención',
    'group.modal.confirmDelete': '¿Está seguro de que desea eliminar?',
    'group.modal.deleteError': 'No puede eliminar este grupo.',
    'group.modal.deleteErrorReason':
        'Por favor, desasigne el/los comensal(es) asociado(s) para finalizar esta eliminación.',
    'group.warning.group_name_already_exist.message': 'El nombre del grupo ya existe.',
    'group.warning.group_name_already_exist.description':
        'Por favor, proponga un nuevo nombre de grupo o asocie el/los régimen(es) tarifario(s) seleccionado(s) al grupo ya existente.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        'Uno o varios regímenes tarifarios que desea desasociar del grupo actual están asignados a comensales existentes.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        'Por favor, desasigne este o estos regímenes tarifarios de los comensales existentes antes de poder eliminarlos de la lista de regímenes tarifarios disponibles para el grupo',
    'group.modal.import.title': 'Importar Grupos, Secciones, Subsecciones y Regímenes Tarifarios',
    'group.modal.import.firstPart': 'Descargar el {fileTemplate} en su ordenador',
    'group.modal.import.secondPart':
        'Rellenar el archivo modelo con la información de sus grupos, secciones, subsecciones y regímenes tarifarios a añadir o modificar',
    'group.modal.import.thirdPart': 'Importar su nuevo archivo haciendo clic en el botón de abajo',
    'group.modal.import.warning':
        'La eliminación de grupos, secciones, subsecciones y regímenes tarifarios solo se realiza desde el backoffice Innovorder',
    'group.modal.import.report.title': 'Informe de la importación',
    'group.export.group': 'Grupo',
    'group.export.section': 'Sección',
    'group.export.subsection': 'Subsección',
    'group.export.pricingRule': 'Régimen(es) tarifario(s) asociados',
    'group.modal.conflict.error.message': 'No puede modificar este grupo',
    'group.modal.conflict.error.description': 'Por favor, reasigne el/los comensal(es) antes de modificar este grupo',
    'group.modal.conflict.export.button': 'Exportar comensales',
    'group.modal.import.report.groups': 'Grupos',
    'group.modal.import.report.sections': 'Secciones',
    'group.modal.import.report.subsections': 'Subsecciones',
    'group.modal.import.report.successMessage': '• creación: {created}\n • modificación: {updated}',
    'group.modal.import.report.errorMessage': '• Línea {line} - columna {field}: {message}',
    'group.delete.modal.conflict.error.message': 'No puede eliminar este grupo',
    'group.delete.modal.conflict.error.description':
        'Por favor, reasigne el/los comensal(es) antes de eliminar este grupo',
    'group.delete.modal.conflict.export.button': 'Exportar comensales',
    'groups.export.student.customerId': 'Identificador de cliente',
    'groups.export.student.email': 'Correo electrónico',
    'groups.export.student.password': 'Contraseña',
    'groups.export.student.firstName': 'Nombre',
    'groups.export.student.lastName': 'Apellido',
    'groups.export.student.phone': 'Teléfono',
    'groups.export.student.piCode': 'Código PIN',
    'groups.export.student.badgeNumber': 'N.º de credencial',
    'groups.export.student.studentNumber': 'N.º de comensal',
    'groups.export.student.group': 'Grupo',
    'groups.export.student.section': 'Sección',
    'groups.export.student.subSection': 'Subsección',
    'groups.export.student.accountType': 'Tipo de cuenta',
    'groups.export.student.tariffCode': 'Código de tarifa',
    'groups.export.student.grantCode': 'Código de subvención',
    'groups.export.student.entranceFeeCode': 'Código de admisión',
    'groups.export.student.pricingRuleCode': 'Régimen tarifario',
    'groups.export.student.ewalletOverdraftAmount': 'Importe de descubierto personalizado',
    'groups.export.student.exitDate': 'Fecha de archivo',
    'groups.export.student.accessFrom': 'Fecha de llegada',
    'groups.export.student.accessUntil': 'Fecha de salida',
    'groups.export.student.inactive': 'Inactivo',
    'groups.export.student.active': 'Activo',
    'groups.export.student.yes': 'Sí',
    'groups.export.student.no': 'No',
    'section.tableCard.title': 'Secciones',
    'section.tableCard.subtitle':
        'Defina las posibilidades de agrupación de sus comensales por sección y asocie los distintos regímenes tarifarios.',
    'section.tableCard.action': '+ Crear una nueva sección',
    'section.name': 'Sección',
    'group.warning.section_name_already_exist.message': 'El nombre de la sección ya existe.',
    'group.warning.section_name_already_exist.description':
        'Por favor, proponga un nuevo nombre de sección o asocie el/los régimen(es) tarifario(s) seleccionado(s) a la sección ya existente.',
    'section.modal.conflict.error.message': 'No puede modificar esta sección',
    'section.modal.conflict.error.description':
        'Por favor, reasigne el/los comensal(es) antes de modificar esta sección',
    'section.delete.modal.conflict.error.message': 'No puede eliminar esta sección',
    'section.delete.modal.conflict.error.description':
        'Por favor, reasigne el/los comensal(es) antes de eliminar esta sección',
    'subsection.tableCard.title': 'Subsecciones',
    'subsection.tableCard.subtitle':
        'Defina las posibilidades de agrupación de sus comensales por subsección y asocie los distintos regímenes tarifarios.',
    'subsection.tableCard.action': '+ Crear una nueva subsección',
    'subsection.name': 'Subsección',
    'group.warning.sub_section_name_already_exist.message': 'El nombre de la subsección ya existe.',
    'group.warning.sub_section_name_already_exist.description':
        'Por favor, proponga un nuevo nombre de subsección o asocie el/los régimen(es) tarifario(s) seleccionado(s) a la subsección ya existente.',
    'subsection.modal.conflict.error.message': 'No puede modificar esta subsección',
    'subsection.modal.conflict.error.description':
        'Por favor, reasigne el/los comensal(es) antes de modificar esta subsección',
    'subsection.delete.modal.conflict.error.message': 'No puede eliminar esta subsección',
    'subsection.delete.modal.conflict.error.description':
        'Por favor, reasigne el/los comensal(es) antes de eliminar esta subsección',
    'options.main': 'General',
    'options.educationMode': 'Restauración colectiva',
    'options.birthdate': 'Fecha de cumpleaños',
    'options.tripAdvisorUsername': 'Nombre de usuario TripAdvisor',
    'options.advancedSecurityRules': 'Activar contraseña de 12 caracteres',
    'options.optIn': 'Opt-in',
    'options.productionDeclaration': 'Declaración de producción',
    'options.grantsAndEntranceFee': 'Subvenciones y admisiones',
    'options.pinCodeDoubleAuth': 'Usar un código PIN para proteger la autenticación en el terminal',
    'options.charlemagneExport': 'Exportar datos para Charlemagne',
    'options.handleBadgeForChar': 'Gestionar solo los 4 últimos caracteres en las búsquedas de credencial',
    'options.autoBilling': 'Activar el módulo de "facturación automática"',
    'options.linkProductImageBySku':
        'Vincular automáticamente las imágenes cuyos nombres contengan los SKU de los productos (durante la importación)',
    'options.externalIdsMapping': 'Activar la traducción de IDs',
    'options.ewalletAutoReload': 'Activar E-wallet autoreloader (vía Stripe)',
    'options.foodCourt': 'CEL v2 - Food Court',
    'options.foodCourtMode': 'Activar el modo food court',
    'options.shuffleRestaurants': 'Aleatorizar el orden de visualización de los restaurantes',
    'options.enableSodexoDictionary': 'Activar el diccionario Sodexo',
    'options.enableOrderDetailV2': 'Activar order detail V2',
    'options.usePickupPoints': 'Activar los puntos de recogida',
    'options.linkProductSkuToExternalMapping':
        'Vincular automáticamente los SKU de los productos a la traducción de IDs',
    'options.linkStudentNumberToExternalMapping':
        'Vincular automáticamente el número de comensal a la traducción de IDs',
    'options.multiRestaurant': 'Terminal - Multi Restaurante',
    'options.multiRestaurantMode': 'Activar el modo multi-restaurante',
    'options.multiRestaurantModeMainRestaurant': 'Restaurante principal',
    'options.multiRestaurantModeMainUser': 'Usuario del terminal',
    'options.multiRestaurantModeAssignedRestaurants': 'Restaurantes asignados',
    'options.enableLinkingMenuToPosAndWeb': 'Permitir la asociación del menú con una caja y la Web',
    'options.configureSodexoConsumerTransaction': 'Activar los webhooks Sodexo consumerTransactions',
    'options.families': 'Familias',
    'options.families.empty': 'Ninguna familia',
    'options.families.new': 'Nueva familia',
    'options.families.namePlaceholder': 'Nombre',
    'options.families.add': 'Añadir',
    'options.families.delete': 'Eliminar',
    'options.families.deleteTitle': 'Confirmar la eliminación de la familia {name}',
    'options.families.deleteConfirmation': '¿Está seguro de que desea eliminar la familia "{name}"?',
    'brandInfo.title': 'Información',
    'brandInfo.ewalletOverdraft.title': 'Descubierto E-wallet',
    'brandInfo.ewalletOverdraft.description':
        'Permitir a los clientes tener un saldo negativo en su e-wallet hasta el importe especificado.',
    'brandInfo.ewalletOverdraft.enable': 'Activar el descubierto e-wallet',
    'brandInfo.ewalletOverdraft.amount': 'Importe máximo del descubierto',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0,00',
    'brandInfo.ewalletOverdraft.cannotDisable':
        'Imposible desactivar el descubierto: {count} cliente(s) tienen actualmente el pospago activado.',
    'restaurant.search': 'Buscar un restaurante',
    'restaurant.name': 'Nombre del restaurante',
    'restaurant.options.main': 'General',
    'restaurant.options.includeDepositsInTurnover': 'Contabilizar las consignas en el volumen de negocio',
    'adminBanner.message': 'Ha iniciado sesión como',
    'adminBanner.backToAdmin': 'Volver al administrador',
    'auto.billing.buttons.referential': 'Referencial',
    'auto.billing.buttons.billing': 'Solicitud de facturación',
    'auto.billing.request.card.title': 'Solicitud de facturación',
    'auto.billing.request.card.subtitle':
        'El módulo de facturación automática permite agrupar el conjunto de consumos de los comensales asignados a un tercero para calcular (según las reglas configuradas) el volumen de negocio y lo percibido de cada tercero.',
    'auto.billing.request.wizard.validate': 'Finalizar',
    'auto.billing.request.wizard.title': 'Realizar una solicitud de facturación',
    'auto.billing.request.card.action': 'Realizar una solicitud de facturación',
    'auto.billing.request.popup.confirm.title': 'Va a solicitar una facturación automática',
    'auto.billing.request.popup.confirm.text': '¿Puede confirmar esta acción?',
    'auto.billing.request.popup.success.title': 'Su solicitud de facturación ha sido validada',
    'auto.billing.request.popup.fail.title': 'Error',
    'auto.billing.request.popup.pending.title': 'Procesando...',
    'auto.billing.request.popup.success.cancel': 'Cerrar',
    'auto.billing.request.popup.success.text': 'Ha realizado su solicitud de facturación correctamente',
    'auto.billing.request.popup.fail.text': 'Se ha producido un error, por favor inténtelo de nuevo más tarde',
    'auto.billing.request.preview.emptyMessage': 'Ninguna venta durante el período seleccionado',
    'auto.billing.request.preview.errorUndefinedReferential': 'No hay ningún referencial definido para la enseña',
    'auto.billing.request.preview.error': 'Se ha producido un error, por favor inténtelo de nuevo más tarde',
    'auto.billing.request.preview.code': 'Código',
    'auto.billing.request.preview.label': 'Designación',
    'auto.billing.request.preview.quantity': 'CANT.',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': 'Precio unitario sin IVA',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': 'Importe sin IVA',
    'auto.billing.request.preview.totalTax': 'Importe IVA',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': 'Importe con IVA',
    'auto.billing.request.preview.cdpf': 'CDPF emisor',
    'auto.billing.request.preview.clientCode': 'Código de cliente',
    'auto.billing.request.preview.clientLabel': 'Nombre de cliente',
    'auto.billing.request.preview.billingPeriod': 'Período de facturación',
    'auto.billing.request.preview.billingPeriod.from': 'Del',
    'auto.billing.request.preview.billingPeriod.to': 'al',
    'auto.billing.request.preview.invoiceSelector.GROUP': 'Grupo',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': 'Tipo de cuenta',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': 'Régimen tarifario',
    'auto.billing.request.preview.total.amountWithTaxIncluded': 'Total con IVA',
    'auto.billing.request.preview.total.amountWithTaxExcluded': 'Total importe sin IVA',
    'auto.billing.request.preview.total.tax': 'Total IVA',
    'auto.billing.request.filter.title': 'Filtros',
    'auto.billing.request.filter.entities.title': 'ELECCIÓN DE LAS ENTIDADES DE FACTURACIÓN',
    'auto.billing.request.filter.entities.all': 'Todas las entidades',
    'auto.billing.request.filter.restaurants.title': 'ELECCIÓN DE LOS RESTAURANTES',
    'auto.billing.request.filter.dropDown.errorMessage': 'Debe elegir al menos una opción',
    'auto.billing.request.filter.restaurants.all': 'Todos los restaurantes',
    'auto.billing.request.filter.pricingRules.title': 'PERFIL TARIFARIO',
    'auto.billing.request.filter.pricingRules.all': 'Todos los regímenes tarifarios',
    'auto.billing.request.filter.pricingRules.noPricingRules': 'Sin régimen tarifario',
    'auto.billing.request.accountPaymentTypes.title': 'MODO DE GESTIÓN',
    'auto.billing.request.filter.accountPaymentTypes.all': 'Todos los modos de gestión',
    'auto.billing.request.accountPaymentTypes.CASH': 'Contado',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': 'Prepago',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': 'Pospago',
    'auto.billing.request.history.table.emptyMessage': 'Ninguna solicitud de facturación realizada',
    'auto.billing.request.history.table.date': 'Fecha de generación',
    'auto.billing.request.history.table.period': 'Período',
    'auto.billing.request.history.table.user': 'Usuario',
    'auto.billing.request.history.table.previewButton': 'Vista previa',
    'auto.billing.request.history.table.downloadButton': 'Descargar',
    'auto.billing.referential.serviceCodes.card.title': 'Códigos de prestaciones',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': 'Entidades de facturación',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ Añadir una entidad',
    'auto.billing.referential.billingEntities.form.create.title': 'Creación de la entidad de facturación',
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': 'Modo de cálculo',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': 'Etiqueta',
    'auto.billing.referential.billingEntities.table.code': 'Código',
    'auto.billing.referential.billingEntities.table.groups': 'Grupos asociados',
    'auto.billing.referential.billingEntities.table.groupingBy': 'Desglose',
    'auto.billing.referential.billingEntities.table.emptyMessage':
        'No hay ninguna entidad de facturación definida para esta enseña',
    'auto.billing.referential.billingEntities.form.label.title': 'ETIQUETA',
    'auto.billing.referential.billingEntities.form.code.title': 'CÓDIGO',
    'auto.billing.referential.billingEntities.form.code.text': 'CÓDIGO',
    'auto.billing.referential.billingEntities.form.groups.text': 'OBJETIVO',
    'auto.billing.referential.billingEntities.form.groupingBy.title': 'TIPO DE DESGLOSE',
    'auto.billing.referential.billingEntities.form.label.subtitle': 'Creación de la entidad de facturación',
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': 'Régimen tarifario',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': 'Sin desglose',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': 'Grupo',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': 'Modo de gestión',
    'auto.billing.referential.billingEntities.errors.duplicate.code':
        'El código {code} ya está asociado a la entidad de facturación {entity}',
    'auto.billing.referential.billingEntities.errors.duplicate.group':
        'La entidad de facturación {entity} ya tiene como grupo(s): {groups}',
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': 'PERCIBIDO POR CUENTA',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': 'FACTURACIÓN POR TRAMO DE ADMISIÓN',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': 'FACTURACIÓN MASIVA DE COSTES FIJOS',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': 'Percibido por cuenta',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': 'Código',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': 'IVA',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ Añadir un código',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': 'No hay ningún código registrado',
    'auto.billing.referential.accountingCostCompute.constantCost': 'Facturación por masa de costes fijos',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': 'Facturación por tramo',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': 'Facturación por cubierto',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': 'Masa de costes fijos',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': 'Por cubierto',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': 'TRAMO DESDE',
    'auto.billing.referential.accountingCostCompute.modal.to': 'HASTA',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': 'MASA DE COSTES FIJOS',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': 'POR CUBIERTO',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': 'MODO DE FACTURACIÓN',
    'auto.billing.referential.accountingCostCompute.modal.title': 'Añadir un nuevo tramo',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin':
        'El tramo máximo debe ser superior al mínimo',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection':
        'Este tramo se superpone con [{from} - {to}]',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': 'El valor debe ser positivo',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ Añadir un tramo',
    'auto.billing.referential.accountingCostCompute.amount': 'Importe con IVA',
    'auto.billing.filters.entity': 'Entidad de facturación',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX CÓDIGO DEL GRUPO',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': 'Número de cubiertos',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': 'Modo de cálculo',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': 'Valores',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage':
        'Ningún tramo definido para este modo de facturación',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': 'a',
    'route.brands': 'Enseñas',
    'route.brandInfo': 'Información',
    'route.brandInfoV2': 'Información',
    'route.brandMedias': 'Medios',
    'route.configIOPay': 'Configuración Adyen',
    'route.configEdenred': 'Configuración Edenred',
    'route.configPaygreen': 'Configuración Paygreen',
    'route.integrations': 'Integraciones',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': 'Subvenciones y admisiones',
    'route.services': 'Servicios',
    'route.createShift': 'Nuevo servicio',
    'route.editShift': 'Editar servicio',
    'route.options': 'Opciones',
    'route.brandHistory': 'Historial',
    'route.groups': 'Jerarquización',
    'route.brandChannels': 'Canales',
    'route.brandMenus': 'Menús',
    'route.brandMenu': 'Información',
    'route.brandRestaurants': 'Restaurantes',
    'route.brandUsers': 'Usuarios',
    'route.billing': 'Mi espacio de facturación',
    'route.home': 'Inicio',
    'route.pricingRule': 'Régimen tarifario',
    'route.logout': 'Cerrar sesión',
    'route.configUbereats': 'Integración Uber Eats',
    'route.configDeliveroo': 'Integración Deliveroo',
    'route.configDeliverect': 'Integración Deliverect',
    'route.configCrous': 'Integración Crous',
    'route.createGrant': 'Nueva subvención',
    'route.grant': 'Subvenciones',
    'route.createEntranceFee': 'Nueva admisión',
    'route.entranceFee': 'Admisión',
    'route.createPricingRule': 'Nueva regla tarifaria',
    'route.analytics': 'Vista general',
    'route.restaurantIntegration': 'Integración',
    'route.autoBilling': 'Facturación automática',
    'route.autoBilling.referential': 'Referencial',
    'route.autoBilling.request': 'Solicitud de facturación',
    'route.autoBilling.referential.createEntity': 'Creación de una entidad de facturación',
    'route.autoBilling.referential.editEntity': 'Edición de una entidad de facturación',
    'route.orders': 'Pedidos',
    'route.orderDetails': 'Detalle del pedido',
    'route.restaurantInfo': 'Información',
    'route.restaurantChannels': 'Canales',
    'route.restaurantUsers': 'Usuarios',
    'route.restaurantMenus': 'Menús',
    'route.restaurantMenu': 'Información',
    'route.restaurantTickets': 'Tickets',
    'route.restaurantMedias': 'Medios',
    'route.restaurantIntegrations': 'Integraciones',
    'route.restaurantPayments': 'Medios de pago',
    'route.restaurantOptions': 'Opciones',
    'route.restaurantPricingRevaluation': 'Revalorización de precios',
    'route.createGroup': 'Nuevo grupo',
    'route.createSection': 'Nueva sección',
    'route.createSubSection': 'Nueva subsección',
    'route.editGroup': 'Edición de un grupo',
    'route.editSection': 'Edición de una sección',
    'route.editSubSection': 'Edición de una subsección',
    'route.adminTools': 'Herramientas de administración',
    'route.menus': 'Menús',
    'route.menuOperations': 'Operaciones sobre los menús',
    'route.posLayout': 'Diseño de teclado POS',
    'route.categories': 'Categorías',
    'route.products': 'Productos',
    'route.steps': 'Pasos',
    'route.tags': 'Etiquetas',
    'route.functions': 'Funciones',
    'route.brandCustomer': 'Clientes',
    'route.brandOrders': 'Pedidos',
    'route.crossSelling': 'Cross-selling',
    'route.tableLayout': 'Planos de mesas',
    'route.tableLayout.room': 'Salones',
    'route.salesSummary': 'Síntesis financiera',
    'route.tickets': 'Tickets',
    'route.reportStatus': 'Estado del informe',
    'route.pos': 'POS',
    'route.posConfiguration': 'Configuración',
    'route.posDevices': 'Cajas',
    'route.posAccess': 'Roles y permisos',
    'route.posAccess.users': 'Usuarios de caja',
    'route.posAccess.roles': 'Roles de caja',
    'route.posAccess.groups': 'Grupos de caja',
    'route.accessFlags': 'Autorizaciones',
    'route.userRestaurants': 'Restaurantes asociados',
    'route.updateUserPassword': 'Cambiar su contraseña',
    'route.userInfo': 'Información',
    'route.badgeReader': 'Lectores de credencial',
    'route.posDeviceInformation': 'Información',
    'route.posDeviceConfiguration': 'Configuración',
    'route.posDeviceAdditionalDevices': 'Periféricos',
    'route.posDeviceArchives': 'Archivos fiscales',
    'route.posDeviceFeatures': 'Opciones',
    'route.posDevicePreferences': 'Preferencias',
    'route.posDeviceCatalogHistory': 'Historial de catálogos',
    'route.listCustomers': 'Clientes',
    'route.customerSettings': 'Parámetros',
    'route.customerPricingRules': 'Regímenes tarifarios',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': 'Puntos de recogida',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': 'Zona de operación',
    'route.createBrandWebhook': 'Crear un webhook',
    'route.editBrandWebhook': 'Modificar un webhook',
    'operationZones.page.title': 'Zona de operación',
    'operationZones.page.description':
        'Defina los territorios donde su enseña ejerce su actividad. Debe designarse una zona principal para la entidad legal de referencia.',
    'operationZones.emptyState': 'Ninguna zona seleccionada',
    'operationZones.emptyState.description':
        'Seleccione uno o varios territorios de la lista de abajo para definir sus zonas de operación.',
    'operationZones.availableTerritories': 'Territorios disponibles',
    'operationZones.selectedCount': '{count} seleccionado(s)',
    'operationZones.solution': 'Solución',
    'operationZones.warning.title': 'Configuración incompleta',
    'operationZones.warning.description':
        '{count, plural, one {{count} zona seleccionada necesita ser configurada para estar operativa.} other {{count} zonas seleccionadas necesitan ser configuradas para estar operativas.}}',
    'operationZones.warning.hint': 'Por favor, complete la información legal y técnica mediante el botón "Configurar".',
    'operationZones.immutabilityNotice':
        'La zona de operación no puede modificarse después de la creación del restaurante. <supportLink>Contacte con el soporte</supportLink> si es necesario.',
    'operationZones.primaryZone': 'ZONA PRINCIPAL',
    'operationZones.setPrimary.disabled': 'Configure esta zona antes de definirla como principal',
    'operationZones.cannotRemoveLastZone': 'Un restaurante debe tener al menos una zona de operación',
    'operationZones.primaryBadge': 'PRINCIPAL',
    'operationZones.secondaryZonesActive':
        '+ {count} {count, plural, one {ZONA SECUNDARIA ACTIVA} other {ZONAS SECUNDARIAS ACTIVAS}}',
    'operationZones.configure': 'Configurar',
    'operationZones.viewVatRates': 'Ver las tasas',
    'operationZones.toConfigure': 'Por configurar',
    'operationZones.entity': 'Entidad',
    'operationZones.vat': 'IVA',
    'operationZones.posConfig': 'Configuración POS',
    'operationZones.notFilled': 'No especificado',
    'operationZones.pending': 'Pendiente',
    'operationZones.initialized': 'Inicializada',
    'operationZones.configured': 'Configurada',
    'operationZones.noPosDevice': 'Cree un POS antes de configurar esta zona',
    'operationZones.configModal.title': 'Configuración: {zoneName}',
    'operationZones.configModal.subtitle': 'Parámetros legales y fiscales ({code})',
    'operationZones.configModal.entitySection': 'Información de la entidad',
    'operationZones.configModal.socialReason': 'Razón social',
    'operationZones.configModal.address': 'Dirección',
    'operationZones.configModal.postalCode': 'Código postal',
    'operationZones.configModal.city': 'Ciudad',
    'operationZones.configModal.vatNumber': 'Número de IVA',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': 'Guardar',
    'operationZones.configModal.socialReason.placeholder': 'Ej.: Restaurant SARL',
    'operationZones.configModal.address.placeholder': '123 Calle de la...',
    'operationZones.configModal.postalCode.placeholder': '75000',
    'operationZones.configModal.city.placeholder': 'París',
    'operationZones.configModal.vatNumber.placeholder': 'Ej.: FR 12 345678901',
    'operationZones.configModal.siret.placeholder': 'Ej.: 522 296...',
    'operationZones.multiProvider': 'A elegir',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': 'Ej.: B12345678',
    'operationZones.configModal.fiscalRepresentative': 'Representante fiscal',
    'operationZones.configModal.fiscalRepresentative.placeholder': 'Nombre del representante fiscal',
    'operationZones.configModal.fiscalIdCode': 'Código de identificación fiscal',
    'operationZones.configModal.fiscalIdCode.placeholder': 'Ej.: RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': 'Número de IVA (BTW)',
    'operationZones.configModal.vatNumberBtw.placeholder': 'Ej.: BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': 'Número de empresa',
    'operationZones.configModal.enterpriseNumber.placeholder': 'Ej.: 0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': 'Ej.: 12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': 'Ej.: 001234567000045',
    'operationZones.configModal.selectProvider': 'Seleccione el modo de conformidad',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription': 'Middleware de conformidad fiscal para la caja registradora',
    'operationZones.configModal.noIntegration': 'Sin integración',
    'operationZones.configModal.noIntegrationDescription': 'No se configurará ningún middleware de fiscalidad',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': 'Certificación de conformidad fiscal francesa',
    'operationZones.configModal.boiteNoire': 'Boîte Noire',
    'operationZones.configModal.boiteNoireDescription': 'Módulo de conformidad fiscal belga',
    'operationZones.configModal.middlewareSection': 'Configuración Middleware (Fiskaltrust)',
    'operationZones.configModal.cashboxId': 'Cashbox ID',
    'operationZones.configModal.cashboxId.placeholder': 'Ej.: a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'Access Token',
    'operationZones.configModal.accessToken.placeholder': 'Ej.: AZE123...',
    'operationZones.configModal.back': 'Volver',
    'operationZones.deactivate.title': 'Desactivar la zona de operación',
    'operationZones.deactivate.message':
        '¿Está seguro de que desea desactivar esta zona de operación? Toda la información configurada (entidad legal, fiscalidad, configuración POS) se perderá.',
    'adminTools.confirmModal.description': '¿Está seguro de que desea activar esta acción?',
    'brand.adminTools.editCustomerLoyalties.title': 'Añadir/retirar fidelidad IO a un cliente de esta enseña',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'nombre@dominio.com o A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 equivale a 4 euros',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards':
        'Correo electrónico o número de tarjeta de fidelidad del cliente',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': 'Importe',
    'brand.adminTools.editCustomerLoyalties.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editCustomerLoyalties.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.unarchiveCustomer.title': 'Desarchivar un comensal',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': 'CustomerId a desarchivar',
    'brand.adminTools.unarchiveCustomer.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.unarchiveCustomer.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.deleteTransaction.title': 'Eliminar una transacción',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': 'Transacción a eliminar',
    'brand.adminTools.deleteTransaction.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.deleteTransaction.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.addUserToRestaurant.title':
        'Asignar una cuenta de restaurante a otro restaurante de la misma enseña',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'ejemplo@restaurante.com',
    'brand.adminTools.addUserToRestaurant.form.email': 'Correo electrónico de la cuenta',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'RestaurantId del restaurante a asignar',
    'brand.adminTools.addUserToRestaurant.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.addUserToRestaurant.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.deleteUnassignedImages.title': 'Eliminar las imágenes no utilizadas de esta enseña',
    'brand.adminTools.deleteUnassignedImages.description1':
        'Script para borrar todas las imágenes no utilizadas (por ejemplo, por productos/menús que han sido eliminados desde entonces)',
    'brand.adminTools.deleteUnassignedImages.description2':
        'Se recomienda eliminar todos los menús innecesarios de la enseña y de sus restaurantes antes de ejecutar este script, para que la limpieza sea eficaz.',
    'brand.adminTools.deleteUnassignedImages.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.deleteUnassignedImages.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.importGeojsonPolygon.title': 'Importar un geoJson como zona de entrega',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': 'Nombre de la zona de entrega a crear',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': 'Introduzca las coordenadas poligonales del geoJson',
    'brand.adminTools.importGeojsonPolygon.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.importGeojsonPolygon.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.deleteCustomer.title': 'Eliminar un cliente/comensal',
    'brand.adminTools.deleteCustomer.description1':
        'Introduzca el customerId que desea eliminar (puede introducir varios customerIds separándolos por una coma, sin espacio, por ejemplo: 1234567,1234568,1234569)',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': 'CustomerId a eliminar',
    'brand.adminTools.deleteCustomer.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.deleteCustomer.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.razCustomer.title': 'Puesta a cero de un cliente/comensal',
    'brand.adminTools.razCustomer.description1':
        'Introduzca el customerId cuyo saldo E-Wallet desea poner a cero (puede introducir varios customerIds separándolos por una coma, sin espacio, por ejemplo: 1234567,1234568,1234569)',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': 'CustomerId(s) a poner a cero (separados por una coma)',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        'BrandId a poner a cero (si introduce un brandId, todos los clientes de pospago de esta enseña serán puestos a cero; el campo customerId(s) de arriba será ignorado)',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date':
        'Fecha de aplicación de la RAZ (la hora es las 5 de la madrugada); déjelo vacío si la RAZ debe realizarse ahora',
    'brand.adminTools.razCustomer.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.razCustomer.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.copySchedules.title': 'Copia de los horarios de recogida o CEL de un restaurante a otro(s)',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup o cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': 'Tipo de horario a copiar (introduzca pickup o cel)',
    'brand.adminTools.copySchedules.form.idSource': 'RestaurantId de origen',
    'brand.adminTools.copySchedules.form.idsDestination':
        'RestaurantId(s) de destino (puede introducir varios restaurantIds separándolos por una coma, sin espacio, por ejemplo: 901,902,903)',
    'brand.adminTools.copySchedules.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.copySchedules.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.changeOrderDateInReport.title':
        'Editar la fecha de un pedido en los informes (Esto también cambiará la fecha de la transacción)',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId':
        'Número de pedido (orderId), posibilidad de separar por una coma',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': 'Día',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': 'ejemplo: 14',
    'brand.adminTools.changeOrderDateInReport.form.month': 'Mes',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': 'ejemplo: 7',
    'brand.adminTools.changeOrderDateInReport.form.year': 'Año',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': 'ejemplo: 2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': 'Hora',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': 'ejemplo: 10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': 'Minutos',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': 'ejemplo: 35',
    'brand.adminTools.changeOrderDateInReport.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.changeOrderDateInReport.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.editPasswordExpiresAt.title': 'Forzar a una enseña/un comensal a cambiar su contraseña',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force o cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        'Forzar el cambio de contraseña (force) o cancelar el cambio de contraseña (cancel)',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': 'Enseña objetivo',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        'Comensal(es) objetivo(s). Puede introducir varios customerIds separándolos por una coma, sin espacio, por ejemplo: 123456,234567,345678). Déjelo vacío para apuntar a toda la enseña',
    'brand.adminTools.editPasswordExpiresAt.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editPasswordExpiresAt.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.editProductSkuFromProductId.title': 'Editar el SKU de varios productos desde un archivo Excel',
    'brand.adminTools.editProductSkuFromProductId.description': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.editProductSkuFromProductId.form.error':
        'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editProductSkuFromProductId.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.importProductInMenu.title': 'Importar productos en un menú ya existente',
    'brand.adminTools.importProductInMenu.description': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.importProductInMenu.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.importProductInMenu.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.importProductFromSku.title': 'Editar e importar productos basados en su SKU',
    'brand.adminTools.importProductFromSku.description1':
        'Utilice este {metabaseLink} para obtener la lista de productos de su menú; puede editar o añadir nuevos productos (SKU no obligatorio en los nuevos productos).',
    'brand.adminTools.importProductFromSku.description1bis':
        'No edite el SKU de los productos existentes, es el identificador único del producto. No cambie el nombre de las columnas',
    'brand.adminTools.importProductFromSku.description2': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.importProductFromSku.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.importProductFromSku.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': 'menuId del menú de origen',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': 'MenuId del menú de origen',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': 'menuId del menú de destino',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': 'MenuId del menú de destino',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '(opcional)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': 'Filtro Categoría',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '(opcional)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': 'Filtro Etiqueta',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': 'Copiar productos de un menú a otro',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        'Introduzca el menuId del menú de origen y el menuId del menú de destino. También puede filtrar los productos por categoría y/o etiqueta para copiar solo algunos productos.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2':
        'Tenga en cuenta que las referencias externas y los pasos no se copiarán',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        'Las imágenes solo se copiarán si el menú de destino está en el mismo restaurante que el menú de origen, o si el menú de origen está al nivel de enseña y el menú de destino al nivel de restaurante en la misma enseña',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error':
        'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.importBackofficeUsers.title': 'Importar usuarios de backoffice',
    'brand.adminTools.importBackofficeUsers.description': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.importBackofficeUsers.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.importBackofficeUsers.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.editProductInfoFromProductId.title': 'Editar productos desde un archivo Excel',
    'brand.adminTools.editProductInfoFromProductId.description1':
        'Utilice este {metabaseLink} para obtener la lista de productos de su menú, rellene las columnas dedicadas a la edición y cargue el archivo. (No cambie el nombre de las columnas)',
    'brand.adminTools.editProductInfoFromProductId.description2': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.editProductInfoFromProductId.form.error':
        'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editProductInfoFromProductId.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.editStepInfoFromStepId.title': 'Editar pasos desde un archivo Excel',
    'brand.adminTools.editStepInfoFromStepId.description0':
        'Este script permite modificar los nombres, las referencias y las etiquetas de los pasos de forma masiva, no la lista de productos.',
    'brand.adminTools.editStepInfoFromStepId.description1':
        'Utilice este {metabaseLink} para obtener la lista de pasos de su menú, rellene las columnas dedicadas a la edición y cargue el archivo. (No cambie el nombre de las columnas)',
    'brand.adminTools.editStepInfoFromStepId.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editStepInfoFromStepId.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.editProductPriceInAdminTools.title':
        'Editar el precio de los productos (fuera y dentro de los pasos) desde un archivo Excel',
    'brand.adminTools.editProductPriceInAdminTools.description1':
        'Utilice este {metabaseLink} para obtener la lista de productos de su menú, rellene la columna Nuevo Precio y cargue el archivo. (No cambie el nombre de las columnas)',
    'brand.adminTools.editProductPriceInAdminTools.description2': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.editProductPriceInAdminTools.form.error':
        'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editProductPriceInAdminTools.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.editProductTagFromProductId.title':
        'Añadir una o varias etiqueta(s) a varios productos desde un archivo Excel',
    'brand.adminTools.editProductTagFromProductId.description': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.editProductTagFromProductId.form.error':
        'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.editProductTagFromProductId.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.makeEwalletTransaction.title': 'Realizar transacciones E-Wallet desde un archivo Excel',
    'brand.adminTools.makeEwalletTransaction.description': 'Descargar el {fileTemplate} en su ordenador',
    'brand.adminTools.makeEwalletTransaction.form.error': 'Se ha producido un error durante la ejecución del script.',
    'brand.adminTools.makeEwalletTransaction.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.bulkUploadDualScreenImage.title':
        'Subir imagen de doble pantalla en todas las cajas de una enseña',
    'brand.adminTools.bulkUploadDualScreenImage.description':
        'Cargue una imagen (PNG o JPG) e introduzca el brandId. La imagen se aplicará en todas las cajas de la enseña.',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': 'Introduzca el Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': 'La imagen se ha subido en todas las cajas.',
    'brand.adminTools.transformGuestFile.title':
        'Transformar su base de comensales obtenida desde el nuevo sitio al formato Innovorder',
    'brand.adminTools.transformGuestFile.fileFormat': 'Formato de archivo original',
    'brand.adminTools.transformGuestFile.form.success': 'El archivo se ha transformado correctamente',
    'brand.adminTools.transformGuestFile.form.url': 'haga clic aquí para descargar el archivo',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': 'Reporte de ventas IO en SI Sodexo',
    'brand.adminTools.generateSalesReport.description':
        'Sincronizar las ventas IO en SI Sodexo para un restaurante específico (si utiliza un período, las ventas se sincronizarán para el período seleccionado)',
    'brand.adminTools.generateSalesReport.form.checkbox': 'Utilizar un período',
    'brand.adminTools.generateSalesReport.form.restaurant': 'Seleccionar un restaurante',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title':
        'Vincular los SKU de los productos a los mappings de IDs externos',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        'Crea mappings entre los productId internos y los SKU de los productos para un menú específico',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': 'Restaurante',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': 'Menú',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': 'El script se ha ejecutado correctamente.',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error':
        'Se ha producido un error durante la ejecución del script.',
    'spotlight.search.placeholder': '¿Qué desea hacer?',
    'spotlight.section.suggestion': 'Sugerencia',
    'spotlight.section.history': 'Historial',
    'spotlight.context.brand': 'Enseña',
    'spotlight.context.restaurant': 'Restaurante',
    'spotlight.error.noHistory': 'Aún no dispone de ninguna URL elegible en su historial',
    'orderList.title': 'Pedidos',
    'orderList.subtitle': 'Encuentre los pedidos de sus clientes',
    'orderList.filters.allRestaurants': 'Todos los restaurantes',
    'orderList.filters.restaurantHeader': 'Mis restaurantes',
    'orderList.filters.restaurantPlaceholder': 'Buscar un restaurante',
    'orderList.filters.dateRange.lastXdays': '{days} últimos días',
    'orderList.filters.dateRange.custom': 'Personalizado',
    'orderList.generation_history': 'Historial de generaciones',
    'orderList.export': 'Exportar',
    'orderList.generate': 'Generar',
    'orderList.export.title': 'Exportar',
    'orderList.export.selectOneDay': 'Seleccionar un día',
    'orderList.export.selectPeriod': 'Seleccionar un período',
    'orderList.export.format': 'Elija un formato de exportación',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': 'No puede seleccionar más de 31 días',
    'orderList.export.presetDate.currentWeek': 'Semana actual',
    'orderList.export.presetDate.currentMonth': 'Mes actual',
    'orderList.export.presetDate.lastMonth': 'Mes pasado',
    'orderList.export.presetDate.chooseDate': 'Por favor, seleccione un período',
    'orderList.export.includeOrderStates': 'Incluir los distintos estados de los pedidos',
    'order.field.ticketNumber': 'N.° Ticket',
    'order.field.status': 'Estado',
    'order.field.restaurant': 'Restaurante',
    'order.field.channel': 'Canal',
    'order.field.customerName': 'Nombre y apellidos',
    'order.field.customerNameMassCatering': 'Nombre y apellidos del comensal',
    'order.field.badgeNumber': 'N.° Tarjeta',
    'order.field.phone': 'Número de teléfono',
    'order.field.pricingRule': 'Régimen tarifario',
    'order.field.pricingRuleInOrder': 'Régimen tarifario aplicado',
    'order.field.company': 'Empresa',
    'order.field.orderId': 'N.° Pedido',
    'order.field.consumptionMode': 'Modo de consumo',
    'order.field.orderDate': 'Fecha del pedido',
    'order.field.expectedDate': 'Fecha de entrega',
    'order.field.ticketDate': 'Fecha del ticket',
    'order.field.totalWithVat': 'Total con IVA',
    'order.field.turnoverWithVat': 'Facturación con IVA',
    'order.field.paymentMethod': 'Método de pago',
    'order.field.paymentStatus': 'Estado del pago',
    'order.field.paymentAmount': 'Importe del pago',
    'order.status.PAID': 'Pagado',
    'order.status.CANCELLED': 'Cancelado',
    'order.status.VALIDATED': 'Validado',
    'order.status.PAID_CANCELLED': 'Pagado (cancelado)',
    'order.status.CONTRA_ENTRY': 'Contraasiento',
    'order.status.INCOHERENT': 'Pedido incoherente',
    'order.channel.': 'Desconocido',
    'order.channel.1': 'Terminal',
    'order.channel.2': 'CEL',
    'order.channel.5': 'TPV',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': 'Entrega a domicilio',
    'order.consumptionMode.2': 'Para llevar',
    'order.consumptionMode.3': 'En el local',
    'order.consumptionMode.4': 'Drive',
    'order.webPaymentStatus.PAYMENT_OK': 'Pagado',
    'order.webPaymentStatus.PAYMENT_PENDING': 'No pagado',
    'order.webPaymentStatus.PAYMENT_REFUSED': 'Pago rechazado',
    'order.webPaymentStatus.PAYMENT_REFUNDED': 'Reembolsado',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': 'Efectivo',
    'order.paymentMethod.Change': 'Cambio',
    'order.paymentMethod.Check': 'Cheque',
    'order.paymentMethod.CreditCard': 'Tarjeta bancaria',
    'order.paymentMethod.CreditNote': 'Abono',
    'order.paymentMethod.CreditNoteIssued': 'Abono emitido',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': 'E-Ticket Restaurant',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': 'Pago externo',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': 'Cheque Restaurante',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': 'Tarjeta bancaria en línea',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': 'Transferencia',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': 'Otro',
    'order.paymentMethod.Unknown2': 'Otro 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': 'Contacte con el soporte para regularizar el pedido',
    'orderDetail.title.1': 'Terminal',
    'orderDetail.title.2': 'Pedido en línea',
    'orderDetail.title.5': 'TPV',
    'orderDetail.title.8': 'Distribución automática',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': 'Pedido de contraasiento',
    'orderDetail.status.PAID': 'Cobro',
    'orderDetail.status.VALIDATED': 'Adición',
    'orderDetail.status.CANCELLED': 'Cancelado',
    'orderDetail.tabStatus.PAID': 'Venta pagada',
    'orderDetail.tabStatus.VALIDATED': 'Carrito validado',
    'orderDetail.tabStatus.CANCELLED': 'Cancelación',
    'orderDetail.paymentStatus.PAID': 'Pagado',
    'orderDetail.paymentStatus.CANCELLED': 'Cancelado',
    'orderDetail.paymentStatus.REFUNDED': 'Reembolsado',
    'orderDetail.shift.default': 'Servicio por defecto',
    'orderDetail.header.guestNumber': 'Número de comensales:',
    'orderDetail.header.currency': 'Divisa:',
    'orderDetail.header.orderedAt': 'Pedido a las',
    'orderDetail.header.deliverAt': 'Entrega prevista a las',
    'orderDetail.header.deliverAtRange': 'Programado para la franja horaria:',
    'orderDetail.header.status': 'Estado',
    'orderDetail.header.payment': 'Pago',
    'orderDetail.header.table': 'Mesa',
    'orderDetail.kpi.date': 'El {date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': 'de {start, date, ::HHmm} a {end, date, ::HHmm}',
    'orderDetail.ticketInfo': 'Detalles del pedido',
    'orderDetail.comment': 'Comentario',
    'orderDetail.userName': 'Nombre del cliente',
    'orderDetail.taxInfo': 'Detalles del IVA',
    'orderDetail.paymentInfo': 'Métodos de pago',
    'orderDetail.customerInfo': 'Información del cliente',
    'orderDetail.deliveryInfo': 'Entrega',
    'orderDetail.loyaltyInfo': 'Fidelidad',
    'orderDetail.posInfo': 'Información del TPV',
    'orderDetail.transactionInfo': 'Detalles de la transacción',
    'orderDetail.orderPhotos': 'Fotos asociadas al pedido',
    'orderDetail.customer.name': 'Nombre y apellidos',
    'orderDetail.customer.email': 'Email',
    'orderDetail.customer.phone': 'Número de teléfono',
    'orderDetail.customer.badgeNumber': 'Número de tarjeta',
    'orderDetail.customer.pricingRule': 'Régimen tarifario',
    'orderDetail.customer.pricingRuleAssigned': 'Régimen tarifario asignado',
    'orderDetail.customer.group': 'Grupo',
    'orderDetail.customer.section': 'Sección',
    'orderDetail.customer.subSection': 'Subsección',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': 'Saldo anterior E-Wallet',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': 'Nuevo saldo E-Wallet',
    'orderDetail.Pos.restaurant': 'Restaurante',
    'orderDetail.Pos.seller': 'Operador',
    'orderDetail.Pos.deviceName': 'Nombre del TPV',
    'orderDetail.Pos.deviceId': 'ID POS',
    'orderDetail.action.text': 'Acciones del pedido',
    'orderDetail.action.cancel': 'Cancelar',
    'orderDetail.action.refund': 'Reembolsar',
    'orderDetail.action.cancelWithContraEntry': 'Cancelar el pedido (contraasiento)',
    'orderDetail.cancel.title.reason': 'Cancelar el pedido',
    'orderDetail.cancel.title.manualPaymentMethod': 'Método de pago del reembolso',
    'orderDetail.cancel.text1': 'Si fuera necesario, puede cancelar el pedido de un cliente.',
    'orderDetail.cancel.text2': 'Debe seleccionar un motivo de cancelación a continuación.',
    'orderDetail.cancel.text3': 'Si el motivo no se encuentra en la lista, haga clic en «Otro».',
    'orderDetail.cancel.text4': 'El motivo que seleccione será enviado por correo electrónico al cliente.',
    'orderDetail.cancel.text5': 'Las cantidades de productos deducidas volverán al stock.',
    'orderDetail.cancel.text6': 'Puede elegir el método de pago asociado al reembolso.',
    'orderDetail.cancel.text7':
        '⚠️ Es necesario reembolsar al cliente físicamente para evitar discrepancias contables.',
    'orderDetail.cancel.reason.description.label': 'Campo libre (opcional)',
    'orderDetail.cancel.reason.placeholder': 'Elija el motivo de cancelación',
    'orderDetail.cancel.reason.description.placeholder': '250 caracteres máximo',
    'orderDetail.cancel.manualPaymentMethod.placeholder': 'Elija el método de pago',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': 'No puede completar el pedido',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': 'Error en el pedido',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER': 'Cliente insatisfecho (las cantidades no vuelven al stock)',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': 'El cliente no se presentó',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': 'El cliente se ha marchado',
    'orderDetail.cancel.reason.LEARNING_MODE': 'Formación',
    'orderDetail.cancel.reason.TECHNICAL': 'Error técnico',
    'orderDetail.cancel.reason.OTHER': 'Otro...',
    'orderDetail.cancel.manualPaymentMethod.Cash': 'Efectivo',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': 'Tarjeta bancaria',
    'orderDetail.cancel.confirm': 'Cancelar el pedido',
    'orderDetail.cancel.validate': 'Confirmar la cancelación',
    'orderDetail.ticket.itemSum': 'Total artículos',
    'orderDetail.ticket.grantSum': 'Total subvenciones',
    'orderDetail.ticket.entranceFeeSum': 'Total admisiones',
    'orderDetail.ticket.pricingRule': 'Régimen tarifario: ',
    'orderDetail.ticket.discountSum': 'Total descuentos',
    'orderDetail.ticket.tvaSum': 'Total IVA',
    'orderDetail.ticket.finalPrice': 'TOTAL',
    'orderDetail.ticket.discount': 'Código promocional:',
    'orderDetail.tax.taxrate': 'Tipo de IVA',
    'orderDetail.tax.totalExclTax': 'Sin IVA',
    'orderDetail.tax.totalTax': 'IVA',
    'orderDetail.tax.totalInclTax': 'Con IVA',
    'orderDetail.transaction.transactionIds': 'Identificador de la transacción',
    'orderDetail.payment.quantity': 'Cantidad',
    'orderDetail.payment.price': 'Precio',
    'orderDetail.delivery.address': 'Dirección',
    'orderDetail.delivery.apartmentNumber': 'Número de apartamento',
    'orderDetail.delivery.digicode': 'Código de acceso',
    'orderDetail.delivery.phoneNumber': 'Número de teléfono',
    'orderDetail.delivery.additionalInfo': 'Información adicional',
    'orderDetail.linkedOrder.title.origin': 'Vínculo con el pedido de contraasiento',
    'orderDetail.linkedOrder.title.contra_entry': 'Vínculo con el pedido cancelado',
    'orderDetail.linkedOrder.date.origin': 'Fecha del pedido de contraasiento',
    'orderDetail.linkedOrder.date.contra_entry': 'Fecha del pedido cancelado',
    'orderDetail.contraEntryInfo.title': 'Información del contraasiento',
    'orderDetail.contraEntryInfo.validator': 'Validador',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': 'Campo libre',
    'route.ioPayTransactions': 'Transacciones',
    'route.ioPayReports': 'Informes',
    'route.ioPayTransfers': 'Transferencias',
    'route.ioPayConfiguration': 'Configuración',
    'route.ioPayTransferDetail': 'Detalle de la transferencia',
    'route.ioPayTransactionDetail': 'Detalle de la transacción',
    'ioPay.title': 'Adyen',
    'transactions.title': 'Transacciones',
    'transactions.detail.title': 'Ficha de transacción',
    'transactions.subtitle': 'Consulte las transacciones de sus clientes',
    'transaction.field.id': 'Id',
    'transaction.field.type': 'Tipo',
    'transaction.field.brand': 'Enseña',
    'transaction.field.customerEmail': 'Email',
    'transaction.field.date': 'Fecha',
    'transaction.field.paymentMethod': 'Método de pago',
    'transaction.field.paymentStatus': 'Modalidad de pago',
    'transaction.field.paymentAmount': 'Importe del pago',
    'transaction.field.paymentAmount.tooltip': 'Importe pagado por el cliente',
    'transaction.field.reversalAmount': 'Importe abonado por Innovorder',
    'transaction.field.reversalAmount.tooltip':
        'Importe abonado deduciendo únicamente la comisión de pago (el importe puede ser negativo si los fondos no pasan por Innovorder y se abonan directamente en su cuenta bancaria)',
    'transaction.field.amount': 'Importe de la transacción',
    'transaction.field.amount.tooltip': 'Suma de los importes abonados por Innovorder menos los reembolsos',
    'transaction.field.fee': 'Comisión',
    'transaction.field.channel': 'Canal',
    'transaction.field.transfer': 'Transferencia',
    'transaction.field.currency': 'Divisa',
    'transaction.field.status': 'Estado',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': 'Nombre y apellidos',
    'transaction.field.email': 'Email',
    'transaction.field.customerId': 'ID Cliente',
    'transaction.field.badgeNumber': 'N.° tarjeta',
    'transaction.field.lastUpdate': 'Fecha de actualización',
    'transaction.field.source': 'Fuente',
    'transaction.field.orderId': 'Número de pedido',
    'transaction.field.error': 'Error',
    'transaction.field.restaurant': 'Restaurante',
    'transaction.field.paymentMethodType.WEB': 'Tarjeta bancaria en línea',
    'transaction.field.paymentMethodType.PROXIMITY': 'Tarjeta bancaria',
    'transaction.field.paymentMethod.MEAL_VOUCHER': 'TR',
    'transaction.field.paymentMethod.BANK_CARD': 'Tarjeta bancaria',
    'transaction.status.PENDING': 'En curso',
    'transaction.status.PENDING_3DS': '3DS en curso',
    'transaction.status.DONE': 'Exitoso',
    'transaction.status.FAILED': 'Rechazado',
    'transaction.status.ERROR': 'Error',
    'transaction.type.CAPTURE': 'Pago',
    'transaction.type.REFUND': 'Reembolso',
    'transaction.channel.WEB': 'Web',
    'transaction.channel.PROXIMITY': 'Proximidad',
    'transaction.source.WEBORDERING': 'Pedido en línea',
    'transaction.source.EWALLET': 'Recarga E-Wallet',
    'transaction.source.KIOSK': 'Terminal',
    'transaction.source.NOTIFICATION': 'Notificación',
    'transaction.detail.card.main': 'Detalles de la transacción',
    'transaction.detail.card.finance': 'Datos financieros',
    'transaction.detail.card.web': 'Información sobre datos web',
    'transaction.detail.card.customer': 'Información del cliente',
    'transaction.detail.card.order': 'Pedido asociado',
    'transaction.detail.card.paymentMethod': 'Métodos de pago',
    'transfers.title': 'Transferencias',
    'transfers.subtitle': 'Transferencias a su cuenta',
    'configuration.iopay.title': 'Configuración Adyen',
    'configuration.iopay.subtitle':
        'Aquí encontrará todas las entidades legales que ha creado para su empresa. Hemos reunido para usted una visión general clara y concisa de sus restaurantes y e-wallet para facilitar su configuración.',
    'configuration.error.unaccessible': 'No encontrado o permisos insuficientes',
    'transfer.field.id': 'Id',
    'transfer.field.ref': 'Referencia',
    'transfer.field.configurationName': 'Comerciante',
    'transfer.field.amount': 'Importe de la transferencia',
    'transfer.field.transactionCount': 'Número de transacciones',
    'transfer.field.status': 'Estado',
    'transfer.field.executedAt': 'Fecha de ejecución',
    'transfer.status.PENDING': 'En curso',
    'transfer.status.SUCCESS': 'Confirmado',
    'transfer.status.SENT_OUT': 'Enviado',
    'transfer.status.FAILED': 'Fallido',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': 'Detalles de la transferencia',
    'transfer.transactions.title': 'Transacciones de la transferencia',
    'legalEntity.field.entity': 'Entidad legal',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': 'Ciudad',
    'legalEntity.field.status': 'Estado',
    'legalEntity.field.associatedRestaurants': 'Restaurantes asociados',
    'legalEntity.field.actions': 'Acciones',
    'legalEntity.create.title': 'Crear una entidad legal',
    'legalEntity.status.1': 'Error KYC',
    'legalEntity.status.2': 'Por completar',
    'legalEntity.status.3': 'Procesamiento en curso',
    'legalEntity.status.4': 'OK',
    'legalEntity.action.addRestaurant': 'Agregar un restaurante',
    'legalEntity.action.addEwallet': 'Agregar un e-wallet',
    'legalEntity.action.completeKyc': 'Completar el KYC',
    'legalEntity.action.updateKyc': 'Actualizar el KYC',
    'legalEntity.wizard.step1.title': 'Creación de una nueva entidad legal',
    'legalEntity.wizard.step1.legalName': 'Nombre legal de la empresa',
    'legalEntity.wizard.step1.legalName.placeholder':
        'Por favor, introduzca el nombre legal de la empresa exactamente como figura en el SIRET',
    'legalEntity.wizard.step1.legalName.tooltip': 'Nombre legal de la empresa exactamente como figura en el SIRET',
    'legalEntity.wizard.step1.organizationType': 'Tipo de organización',
    'legalEntity.wizard.step1.organizationType.placeholder': 'Por favor, seleccione su tipo de organización',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': 'Por favor, introduzca su SIRET',
    'legalEntity.wizard.step1.siret.tooltip': 'SIRET de la empresa',
    'legalEntity.wizard.step1.addressStreet': 'Dirección de la entidad legal',
    'legalEntity.wizard.step1.addressStreet.placeholder': 'Por favor, introduzca la dirección de la entidad legal',
    'legalEntity.wizard.step1.addressStreet2': 'Información adicional de dirección (opcional)',
    'legalEntity.wizard.step1.addressStreet2.placeholder':
        'Por favor, introduzca la información adicional de dirección si es necesario',
    'legalEntity.wizard.step1.addressZipcode': 'Código postal',
    'legalEntity.wizard.step1.addressZipcode.placeholder': 'Por favor, introduzca su código postal',
    'legalEntity.wizard.step1.addressCity': 'Ciudad',
    'legalEntity.wizard.step1.addressCity.placeholder': 'Por favor, introduzca su ciudad',
    'legalEntity.wizard.step1.industryCode': 'Código de sector',
    'legalEntity.wizard.step1.contactEmail': 'Email de contacto',
    'legalEntity.wizard.step1.contactEmail.placeholder':
        'Por favor, introduzca la dirección de correo electrónico asociada a esta entidad legal',
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': 'Por favor, introduzca el IBAN de la entidad legal',
    'legalEntity.wizard.step1.iban.tooltip': 'IBAN de la entidad legal',
    'legalEntity.wizard.step2.title': 'Adición de un nuevo restaurante',
    'legalEntity.wizard.step2.titleMassCatering': 'Adición de un nuevo restaurante o e-wallet',
    'legalEntity.wizard.step2.chooseRestaurant': 'Seleccionar un restaurante',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'Seleccionar un restaurante o e-wallet',
    'legalEntity.wizard.step2.completeFieldsTitle': 'Campos a completar',
    'legalEntity.wizard.step2.conecsTitle': 'Identificadores CONECS',
    'legalEntity.wizard.step2.conecsTitleOptional': '(opcional)',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'Introduzca los identificadores CONECS (ID) para poder activar el método de pago CONECS en este restaurante para los pagos en proximidad',
    'legalEntity.wizard.step2.ewallet': 'E-wallet',
    'legalEntity.wizard.step2.selectRestaurant': 'Restaurante',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'Restaurante o e-wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'Por favor, seleccione un restaurante',
    'legalEntity.wizard.step2.phoneNumber': 'Número de teléfono',
    'legalEntity.wizard.step2.phoneNumber.placeholder':
        'Por favor, introduzca el número de teléfono a asociar a este restaurante',
    'legalEntity.wizard.step2.shopperStatement': 'Título en el extracto bancario',
    'legalEntity.wizard.step2.shopperStatement.placeholder':
        'Por favor, introduzca el título que aparecerá en el extracto bancario',
    'legalEntity.wizard.step2.shopperStatement.tooltip': 'Texto presente en el extracto bancario del cliente final',
    'legalEntity.wizard.step2.restaurantAddressStreet': 'Dirección del restaurante',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder':
        'Por favor, introduzca la dirección del restaurante',
    'legalEntity.wizard.step2.restaurantAddressStreet2': 'Información adicional de dirección (opcional)',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder':
        'Por favor, introduzca la información adicional de dirección si es necesario',
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'Código postal del restaurante',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder':
        'Por favor, introduzca el código postal del restaurante',
    'legalEntity.wizard.step2.restaurantAddressCity': 'Ciudad',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'Por favor, introduzca la ciudad del restaurante',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder':
        'Por favor, introduzca el IBAN para la transferencia de fondos',
    'legalEntity.wizard.step2.restaurantIban.tooltip':
        'Introduzca los identificadores CONECS (ID) para poder activar el método de pago CONECS en este restaurante para los pagos en proximidad',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder':
        'Por favor, introduzca el MID CONECS que figura en su tarjeta de domiciliación',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'SIRET asociado al contrato CONECS',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder':
        'Por favor, introduzca el SIRET asociado al contrato CONECS',
    'legalEntity.organizationType.1': 'Empresa privada',
    'legalEntity.organizationType.2': 'Empresa pública',
    'legalEntity.organizationType.3': 'Sociedad colectiva constituida',
    'legalEntity.organizationType.4': 'Organización sin ánimo de lucro o asociación benéfica',
    'legalEntity.organizationType.5': 'Organización gubernamental',
    'legalEntity.organizationType.6': 'Asociación constituida como persona jurídica',
    'legalEntity.industryCode.specialFoodServices': 'Servicios de alimentación especializados',
    'legalEntity.industryCode.fullServiceRestaurants': 'Restaurantes de servicio completo',
    'legalEntity.industryCode.limitedServiceRestaurants': 'Restaurantes de servicio limitado (comida rápida)',
    'legalEntity.industryCode.cafeteriasGrillBuffets': 'Cafeterías, parrillas y bufetes',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': 'Aperitivos y bar de bebidas sin alcohol',
    'legalEntity.industryCode.bakeries': 'Panaderías',
    'billing.title': 'Mi espacio de facturación',
    'billing.subtitle': 'Bienvenido/a, este espacio ha sido creado para simplificar la gestión de facturas.',
    'billing.description':
        'Aquí encontrará las facturas organizadas cronológicamente por servicio de pago; ahora es fácil consultar pagos recientes, descargar facturas y hacer un seguimiento del historial de facturas con un solo clic.',
    'billing.information.edit': 'Modificar la información de facturación',
    'billing.noIssuedInvoices': 'No hay facturas emitidas',
    'billing.table.creationDate': 'Fecha de creación',
    'billing.table.amount': 'Importe',
    'billing.table.status': 'Estado',
    'billing.table.service': 'Servicio',
    'billing.table.invoiceNumber': 'N.° de factura',
    'billing.table.invoiceName': 'Nombre de la factura',
    'billing.table.dueDate': 'Fecha de vencimiento',
    'billing.table.downloadPDF': 'Descargar el PDF',
    'billing.editConfiguration.selectEntityStep.title': 'Entidades legales',
    'billing.editConfiguration.selectEntityStep.subtitle':
        'Seleccione una entidad legal en la que modificar la información de facturación',
    'billing.editConfiguration.selectEntityStep.legalEntity': 'Entidades legales',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': 'Por favor, seleccione de la lista',
    'billing.editConfiguration.selectEntityStep.noLabel': 'Entidad legal sin nombre',
    'billing.editConfiguration.configureBillingStep.title': 'Información de facturación',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': 'Nombre del beneficiario',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail':
        'Dirección de correo electrónico asociada a la factura',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': 'Dirección del beneficiario',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': 'Información adicional',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': 'Código postal',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': 'Ciudad',
    'billing.editConfiguration.configureBillingStep.recipients': 'Destinatarios de la factura',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder':
        'Direcciones de correo electrónico de los destinatarios',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel':
        'Añadir la dirección de correo electrónico "{email}" a los destinatarios',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage':
        'Se ha producido un error al crear o modificar la información de configuración',
    'billing.invoices.download': 'Descargar',
    'billing.invoices.status.1': 'Por pagar',
    'billing.invoices.status.2': 'Pagada',
    'billing.invoices.psp.4': 'Stripe',
    'billing.invoices.name.4': 'Factura Stripe unificada',
    'reports.title': 'Informes Adyen',
    'reports.subtitle':
        'Consulte las transacciones transferidas a su cuenta bancaria, con el detalle por transacción para cada transferencia. Este informe le permite asegurar la fiabilidad contable de las transacciones E-wallet con Adyen.',
    'reports.text': 'Genere uno o varios tipo(s) de informe(s)',
    'reports.choosePeriod': 'Elija un período',
    'reports.chooseReport': 'Seleccione uno o varios tipo(s) de informe(s)',
    'reports.outgoingTransfers': 'Transferencias',
    'reports.reportType': 'TIPO(S) DE INFORME(S)',
    'reports.error.missingDates': 'Por favor, elija dos fechas',
    'reports.error.missingReportType': 'Por favor, elija un informe',
    'reports.error.missingBrand': 'No hay enseña vinculada al usuario actual',
    'pricingRevaluation.tableCard.title': 'Revalorización de precios',
    'pricingRevaluation.tableCard.subtitle':
        'Indique la tasa de revalorización deseada, si debe aplicarse a las opciones, a los suplementos, luego seleccione los menús a revalorizar y haga clic en el botón confirmar.',
    'pricingRevaluation.input.placeholder': 'Tasa de revalorización',
    'consumptionMode.MODE_DELIVERY': 'Entrega a domicilio',
    'consumptionMode.MODE_TAKE_AWAY': 'Para llevar',
    'consumptionMode.MODE_SIT_IN': 'En el local',
    'consumptionMode.MODE_DRIVE': 'Drive',
    'paymentMethods.tableCard.title': 'Gestione y configure',
    'paymentMethods.tableCard.subtitle': 'sus métodos de pago',
    'paymentMethods.tab.pos': 'TPV(s)',
    'paymentMethods.tab.web': 'Pedido en línea',
    'paymentMethods.tab.kiosk': 'Terminal(es)',
    'paymentMethods.tab.kiosk.integration.title': 'Pagos inmediatos',
    'paymentMethods.tab.kiosk.integration.desc1':
        'El pago con tarjeta bancaria en los terminales requiere que el restaurante disponga de una cuenta Ingenico.',
    'paymentMethods.tab.kiosk.integration.desc2':
        'Otros métodos de pago inmediato están disponibles si activa la autenticación en los terminales.',
    'paymentMethods.tab.kiosk.payment.title': 'Pagos en la recogida',
    'paymentMethods.tab.kiosk.payment.desc':
        'Indique a los usuarios los métodos de pago aceptados por el restaurante en el mostrador.',
    'paymentMethods.tab.kiosk.payment': 'Pagos',
    'paymentMethods.tab.kiosk.payment.accepted': 'aceptados',
    'paymentMethods.tab.kiosk.payment.refused': 'rechazados',
    'paymentMethods.consumptionMode': 'Seleccionar los modos de consumo',
    'paymentMethods.externalId': 'Código externo',
    'configure.ingenico': 'Configurar Ingenico',
    'configure.nepting': 'Configurar Nepting',
    'configure.stripe': 'Configurar Stripe',
    'configure.edenred': 'Configurar Edenred',
    'configure.iopay': 'Configurar Adyen',
    'configure.paygreen': 'Configurar Paygreen',
    'configure.ewallet': 'Configurar E-Wallet',
    'configure.yavin': 'Configurar IOPay',
    'configure.yavin.neptingConfigured': 'No es posible configurar IOPay porque Nepting está en uso.',
    'configure.nepting.yavinConfigured': 'No es posible configurar Nepting porque IOPay está en uso.',
    'configure.stripe.iopayConfigured': 'No es posible configurar Stripe porque Adyen está en uso.',
    'configure.iopay.stripeConfigured': 'No es posible configurar Adyen porque Stripe está en uso.',
    'customer.form.modalDescription': 'Por favor, rellene los campos obligatorios *',
    'customer.form.firstName': 'Nombre *',
    'customer.form.lastName': 'Apellidos *',
    'customer.form.badgeNumber': 'N.° TARJETA {index} *',
    'customer.form.badgeType': 'Tipo de tarjeta',
    'customer.form.badge.default': 'Establecer como principal',
    'customer.form.badgeType.placeholder': 'Por favor, indique el tipo de tarjeta',
    'customer.form.addBadge': 'Agregar una tarjeta',
    'customer.form.email': 'Dirección de correo electrónico *',
    'customer.form.phoneNumber': 'N.° de teléfono (Opcional)',
    'customer.form.arrivalDate': 'Fecha de llegada (Opcional)',
    'customer.form.departureDate': 'Fecha de salida (Opcional)',
    'customer.form.password': 'Contraseña *',
    'customer.form.confirmPassword': 'Confirme su contraseña *',
    'customer.form.clientInfoSection': 'Información general del comensal',
    'customer.form.pricingRuleSection': 'Configuración de las reglas tarifarias',
    'customer.form.accountPaymentTypeLabel': 'Tipo de cuenta de cliente *',
    'customer.form.accountPaymentTypePlaceHolder': 'Por favor, seleccione un tipo de cuenta de cliente',
    'customer.form.guestGroupIdLabel': 'Grupo *',
    'customer.form.guestGroupIdPlaceHolder': 'Por favor, seleccione un grupo',
    'customer.form.pricingRuleCodeLabel': 'Código de régimen tarifario *',
    'customer.form.pricingRuleCodePlaceHolder': 'Por favor, seleccione un régimen tarifario',
    'customer.form.tariffCode': 'CÓDIGO TARIFARIO (OPCIONAL)',
    'customer.form.studentNumber': 'N.° COMENSAL (OPCIONAL)',
    'customer.form.pricingRuleInfo': '¿Su código de régimen tarifario no aparece en la lista? Por favor, créelo ',
    'customer.form.groupInfo': 'Para definir sus grupos, vaya a la página Enseña > Jerarquización ',
    'customer.form.sectionInfo': 'Para definir sus secciones, vaya a la página Enseña > Jerarquización ',
    'customer.form.subSectionInfo': 'Para definir sus subsecciones, vaya a la página Enseña > Jerarquización ',
    'customer.form.here': 'aquí',
    'customer.form.section': 'SECCIÓN (OPCIONAL)',
    'customer.form.subSection': 'SUBSECCIÓN (OPCIONAL)',
    'customer.form.selectOptions.cash': 'Contado',
    'customer.form.selectOptions.prepayment': 'Prepago',
    'customer.form.selectOptions.postpayment_bankdebit': 'Postpago: descuento en nómina',
    'customer.form.selectOptions.postpayment_guest': 'Postpago: invitados',
    'brand.customers.action.import': 'Importar',
    'brand.customers.action.export': 'Exportar',
    'brand.customers.page.title': 'Clientes',
    'brand.customers.page.description': 'Aquí encontrará la lista completa de clientes registrados en su enseña.',
    'customer.modal.import.title': 'Importar clientes',
    'customer.modal.import.firstPart': 'Descargue el {fileTemplate} en su ordenador',
    'customer.modal.import.secondPart': 'Rellene el archivo con los datos de sus clientes',
    'customer.modal.import.thirdPart': 'Suba el archivo para importar sus clientes',
    'customer.modal.import.report.title': 'Informe de importación',
    'customer.modal.import.report.result': 'Resultado',
    'customer.modal.import.report.success': 'Éxito',
    'customer.modal.import.report.error': 'Error',
    'customer.modal.import.report.message': '{created} creados, {updated} actualizados, {unchanged} sin cambios',
    'customer.modal.import.warning':
        "¡Atención! Las columnas 'Código tarifario', 'Código de subvención', 'Código de admisión' y 'Código de régimen tarifario' están obsoletas y serán ignoradas durante la importación. Por favor, utilice la tabla de regímenes tarifarios para configurar esta información.",
    'customer.modal.import.addNew.title': 'Agregar nuevos clientes',
    'customer.modal.import.addNew.step1': 'Descargue el {link} en su ordenador',
    'customer.modal.import.addNew.step1.link': 'archivo modelo',
    'customer.modal.import.addNew.step2': 'Rellene el archivo con los datos de sus nuevos clientes',
    'customer.modal.import.addNew.step3': 'Suba el archivo completado a continuación',
    'customer.modal.import.update.title': 'Actualizar clientes existentes',
    'customer.modal.import.update.step1': 'Descargue {link} en su ordenador',
    'customer.modal.import.update.step1.link': 'la base de clientes actual',
    'customer.modal.import.update.step1.loading': 'Cargando...',
    'customer.modal.import.update.step2': 'Modifique los datos de los clientes que desea actualizar',
    'customer.modal.import.update.step3': 'Suba el archivo modificado a continuación',
    'customer.modal.import.update.warning':
        'Nota: El identificador de cliente debe corresponder a un cliente existente para que la actualización sea efectiva.',
    'customer.modal.import.options.title': 'Opciones de importación',
    'customer.modal.import.options.multiBadge': 'Importación multi-tarjeta',
    'customer.modal.import.options.autoImportGuestHierarchy':
        'Importación automática de la jerarquía (grupos, secciones, subsecciones)',
    'customer.modal.import.error.noResponse': 'La importación ha fallado: sin respuesta del servidor',
    'customer.modal.import.error.invalidResponse': 'Respuesta inválida del servidor',
    'customer.modal.import.error.fileTooLarge': 'El archivo es demasiado grande (máx. 20 MB)',
    'customer.modal.import.loading.reading': 'Leyendo el archivo...',
    'customer.modal.import.loading.importing': 'Importación en curso...',
    'customer.modal.import.result.lineError': 'Línea {lineNumber}{nameDisplay}: {error}',
    'customer.modal.import.result.fieldError': 'Los campos ({fields}) no han sido modificados (línea {line})',
    'customer.modal.import.result.genericError': 'Se ha producido un error',
    'customer.modal.import.result.created': 'Clientes creados: {count}',
    'customer.modal.import.result.updated': 'Clientes actualizados: {count}',
    'customer.modal.import.result.unchanged': 'Clientes no modificados/no creados: {count}',
    'customer.modal.import.result.errors': 'Errores',
    'customer.modal.import.result.warnings': 'Advertencias',
    'customer.modal.import.result.otherWarning.PRICING_RULE': 'Algunas reglas tarifarias no existen en el sistema: ',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': 'Algunas admisiones no existen en el sistema: ',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': 'Algunos comensales tienen un grupo vacío (líneas: ',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP':
        'Algunos grupos de comensales no existen (líneas: ',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE':
        'Algunas reglas tarifarias no están autorizadas para el grupo (líneas: ',
    'customer.modal.import.result.restrictedFieldsInfo':
        'Los campos "Contraseña", "Código PIN" y "Saldo" solo pueden actualizarse si el cliente aún no ha realizado ninguna transacción.',
    'customer.create.modalTitle': 'Crear un nuevo comensal',
    'customer.update.modalTitle': 'Modificación del comensal',
    'customer.tab.info': 'Información',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': 'Restauración colectiva',
    'customer.tab.orders': 'Historial de pedidos',
    'route.customerPricingPolicy': 'Política tarifaria',
    'customer.pricingPolicy.defaultTitle': 'Política predeterminada',
    'customer.pricingPolicy.defaultDescription':
        'La política tarifaria predeterminada se aplicará a cualquier cliente que cree su cuenta a través del módulo de pedido web.',
    'customer.pricingPolicy.customTitle': 'Política personalizada',
    'customer.pricingPolicy.entranceFee': 'Cuota de admisión',
    'customer.pricingPolicy.pricingPolicy': 'Régimen tarifario',
    'customer.pricingPolicy.group': 'Grupo',
    'customer.pricingPolicy.groupPlaceholder': 'MI GRUPO',
    'customer.pricingPolicy.domainName': 'Nombre de dominio',
    'customer.pricingPolicy.delete': 'Eliminar',
    'customer.pricingPolicy.noEntranceFee': 'Sin admisión',
    'customer.pricingPolicy.noPricingRule': 'Sin regla tarifaria',
    'customer.pricingPolicy.noGroup': 'Sin grupo',
    'customer.pricingPolicy.enableWhitelisting': 'Restringir el registro a los dominios declarados',
    'customer.pricingPolicy.enableWhitelistingInfo':
        'Al activar esta opción, el registro en línea solo estará permitido para los dominios declarados',
    'customer.pricingPolicy.save': 'Guardar',
    'customer.student.info.title': 'Información',
    'customer.student.info.desctiption': 'La información relativa al modo Restauración Colectiva.',
    'customer.student.info.account.type': 'Tipo de tarjeta',
    'customer.student.info.group': 'Grupo',
    'customer.student.info.section': 'Sección',
    'customer.student.info.sub.section': 'Subsección',
    'customer.student.info.badge.number': 'N.° Tarjeta',
    'customer.student.info.pricing.code': 'Código tarifario',
    'customer.student.info.student.number': 'N.° Comensal',
    'customer.student.pricing.rules.title': 'Reglas tarifarias',
    'customer.student.pricing.rules.desctiption':
        'Puede asignar a cada cliente reglas tarifarias específicas. Un cliente puede tener un código de subvención y/o admisión O un código de régimen tarifario (un conjunto de cuotas de admisión y/o subvenciones).',
    'customer.student.pricing.rules.deprecated':
        '⚠️ Los campos de código de admisión y código de subvención están ahora obsoletos, en favor del campo Código de régimen tarifario (que agrupa admisiones y subvenciones). {moreInfo}',
    'customer.student.pricing.rules.more_info': 'Más información',
    'customer.student.pricing.rules.grant.code': 'Código de subvención',
    'customer.student.pricing.rules.entrance.fee.code': 'Código de admisión',
    'customer.student.pricing.rules.code': 'Código de régimen tarifario',
    'customer.student.overdraft.title': 'Descubierto E-Wallet autorizado',
    'customer.student.overdraft.desctiption':
        'Puede personalizar el descubierto máximo autorizado de un cliente para el uso de su E-wallet.',
    'customer.student.overdraft.price.label': 'Descubierto E-Wallet autorizado',
    'customer.student.overdraft.disabled': 'El descubierto E-wallet predeterminado está asignado a este cliente.',
    'customer.student.badge.title': 'Bloqueo de la tarjeta principal del comensal',
    'customer.student.badge.description': 'Puede bloquear temporalmente el funcionamiento de la tarjeta principal.',
    'customer.student.badge.table.default': 'Principal',
    'customer.student.badge.table.number': 'Número de tarjeta',
    'customer.student.badge.table.type': 'Tipo',
    'customer.student.badge.table.status': 'Estado',
    'customer.student.badge.table.action': 'Acción',
    'customer.student.badge.table.status.active': '✓ Activado',
    'customer.student.badge.table.status.blocked': '✕ Bloqueado',
    'customer.student.add.badge': '+ Agregar una tarjeta',
    'customer.student.badge.form.add': 'Agregar una tarjeta',
    'customer.student.badge.form.update': 'Editar una tarjeta',
    'customer.student.badge.form.default': 'Establecer como principal',
    'customer.ordersList.title': 'Pedidos',
    'customer.ordersList.subtitle': 'Consulte los pedidos de su cliente',
    'customer.ordersList.downloadTickets': 'Descargar los tickets',
    'customer.ordersList.exportStarted': 'Exportación de tickets en curso. Por favor, espere...',
    'customer.ordersList.exportSuccess': '¡Tickets exportados con éxito!',
    'customer.ordersList.exportFailed': 'La exportación de los tickets ha fallado. Por favor, inténtelo de nuevo.',
    'customer.ordersList.exportNoTicketsForDates': 'No hay tickets para las fechas seleccionadas.',
    'customer.ordersList.downloadChoice.all': 'Todos los tickets',
    'customer.ordersList.downloadChoice.selectedRange': 'Solo las fechas seleccionadas',
    'order.field.downloadTicket': 'Descargar',
    'pricingRevaluation.options.exceeding': 'Aplicar a los excesos',
    'pricingRevaluation.options.options': 'Aplicar a las opciones',
    'pricingRevaluation.options.updateInPlace': 'Menú frigorífico conectado/escáner de bandeja',
    'pricingRevaluation.options.updateInPlace.tooltip':
        'Si la casilla está marcada, la revalorización se aplicará directamente sobre el menú original para conservar los id (se creará una copia del menú sin revalorización). \nSi la casilla no está marcada, la revalorización se aplicará sobre una copia del menú (nuevos ids) y el menú original no se modificará.',
    'pricingRevaluation.table.menu.name': 'Nombre del menú',
    'pricingRevaluation.table.menu.isActive': 'Menú activo',
    'pricingRevaluation.table.menu.channels': 'Canales',
    'pricingRevaluation.table.menu.selected': 'Seleccionado',
    'pricingRevaluation.table.emptyMessage': 'No se encontraron menús para este restaurante',
    'pricingRevaluation.table.search': 'Buscar menús',
    'pos_layout.name': 'Plano de teclas POS',
    'pos_layout.page.title': 'Plano de teclas POS',
    'pos_layout.page.description': 'Organice su plano de teclas y luego despliéguelo en el o los POS asociados.',
    'pos_layout.sort': 'Reorganizar',
    'pos_layout.sort.random': 'Aleatorio',
    'pos_layout.sort.by_name': 'Por nombre',
    'pos_layout.sort.by_price': 'Por precio',
    'pos_layout.tabletSize': 'Tamaño de la tableta',
    'pos_layout.inches': 'Pulgadas',
    'pos_layout.publishDescription':
        '¿Está seguro/a de que desea guardar y publicar el menú y el plano de teclas en el o los POS asociados?',
    'pos_layout.assignPos': 'Asociar POS',
    'pos_layout.modal.warning': 'Atención',
    'pos_layout.modal.publish.description':
        'Las siguientes categorías del plano de teclas no tienen ningún producto asociado: \n• {categories} \n¿Desea confirmar la publicación de este plano de teclas?',
    'pos_layout.modal.save.description':
        'Las siguientes categorías del plano de teclas no tienen ningún producto asociado: \n• {categories} \n¿Desea confirmar el guardado de este plano de teclas?',
    'pos_layout.customPrice': 'Precio libre',
    'pos_layout.functions.create.title': 'Agregar una tecla de función',
    'pos_layout.functions.edit.title': 'Modificar la tecla de función',
    'pos_layout.functions.type': 'Tipo de tecla',
    'pos_layout.functions.type.placeholder': 'Seleccionar un tipo',
    'pos_layout.functions.type.webview': 'Enlace Web / URL',
    'pos_layout.functions.name': 'Nombre de la tecla',
    'pos_layout.functions.url': 'Enlace Web/URL destino',
    'pos_layout.functions.submit': 'Guardar',
    'pos_layout.functions.verifyLink': 'Verificar el enlace',
    'pos_layout.functions.widthPercent': 'Anchura',
    'pos_layout.functions.heightPercent': 'Altura',
    'pos_device.role.independent': 'Independiente',
    'pos_device.role.master': 'Principal',
    'pos_device.role.slave': 'Dependiente',
    'pos_device.role.independent.plural': 'Independientes',
    'pos_device.role.master.plural': 'Principales',
    'pos_device.role.slave.plural': 'Dependientes',
    'action.action': 'Acción',
    'action.edit': 'Editar',
    'action.duplicate': 'Duplicar',
    'action.copy': 'Copiar',
    'action.export': 'Exportar',
    'action.publish': 'Publicar',
    'action.delete': 'Eliminar',
    'action.hide': 'Ocultar',
    'customers.page.title': 'Clientes',
    'customers.page.description': 'Consulte sus clientes',
    'customers.id': 'ID',
    'customers.name': 'Cliente',
    'customers.email': 'Email',
    'customers.phone': 'Número de teléfono',
    'customers.totalSpentAmount': 'Total gastado',
    'customers.orderCount': 'Número de pedidos',
    'customers.averageCart': 'Ticket medio',
    'customers.lastOrder': 'Último pedido',
    'customers.frequency': 'Frecuencia',
    'customers.status': 'Estado',
    'customers.ewalletBalance': 'Saldo E-Wallet',
    'customers.archivedAt': 'Archivado el',
    'customers.disabledAt': 'Desactivado el',
    'customers.showArchivedCustomers': 'Mostrar clientes archivados',
    'customers.showDisabledCustomers': 'Mostrar clientes desactivados',
    'customers.options': 'Opciones',
    'customers.domainNames': 'Nombres de dominio',
    'customers.selectDomainNames': 'Seleccionar nombres de dominio',
    'customers.groups': 'Grupos',
    'customers.selectGroups': 'Seleccionar grupos',
    'menu.name': 'Nombre del menú',
    'menu.categories': 'Categorías',
    'menu.products': 'Productos',
    'menu.functions': 'Funciones',
    'menu.page.title': 'Menús',
    'menu.page.description': 'Cree y gestione sus menús',
    'menu.table.associatedChannels': 'Canales asociados',
    'menu.action.newMenu': '+ Nuevo menú',
    'menu.action.manualImportCrous': 'Forzar importación Crous',
    'menu.action.seeOperations': 'Ver las operaciones',
    'menu.action.changeColor': 'Cambiar el color',
    'menu.action.editProduct': 'Modificar el producto',
    'menu.action.editCategory': 'Modificar la categoría',
    'menu.action.editFunction': 'Modificar la función',
    'menu.action.import': 'Importar un menú',
    'menu.action.noImport': 'No deseo importar ningún archivo',
    'menu.modal.manualImportCrous.title': 'Importación manual del catálogo CROUS',
    'menu.modal.manualImportCrous.description':
        '¿Está seguro de que desea lanzar una importación manual del catálogo del CROUS para este restaurante?',
    'menu.action.aiMenuScan': 'IA Scan (beta)',
    'menu.modal.aiMenuScan.title': 'Digitalice su nuevo menú (beta)',
    'menu.modal.aiMenuScan.description.part1': 'Importe su nuevo menú en formato PDF o imagen',
    'menu.modal.aiMenuScan.description.part2': 'Haga clic en generar el menú Excel',
    'menu.modal.aiMenuScan.description.part3':
        'Descargue automáticamente el archivo Excel del nuevo menú con la información disponible',
    'menu.modal.aiMenuScan.action.cancel': 'Cancelar',
    'menu.modal.aiMenuScan.action.generate': 'Generar el menú excel',
    'menu.modal.bannersDeactivated':
        '{count, plural, one {# banner promocional ha sido desactivado} other {# banners promocionales han sido desactivados}}',
    'menu.modal.create.importMenu': 'Importar un menú',
    'menu.modal.create.createMenu': 'Crear un menú',
    'menu.modal.error.wrongName': 'Introduzca un nombre válido',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': 'Caja',
    'menu.modal.create.import.excel.title': 'Añadir un nuevo menú',
    'menu.modal.create.import.excel.description.firstPart': 'Descargue la {fileTemplate} en su ordenador',
    'menu.modal.create.import.excel.description.secondPart':
        'Rellene el archivo plantilla con la información de sus productos que componen el nuevo menú',
    'menu.modal.create.import.excel.description.thirdPart':
        'Importe su nuevo archivo haciendo clic en el botón de abajo',
    'menu.modal.create.import.pos.title': 'Importar un menú existente',
    'menu.modal.create.import.pos.description.firstPart': 'Elija una caja innovorder de la que desea importar el menú',
    'menu.modal.create.import.json.title': 'Importar un menú existente',
    'menu.modal.create.import.json.description.firstPart': 'Verifique que su archivo esté en formato JSON',
    'menu.modal.create.import.json.description.secondPart':
        'Importe su nuevo archivo haciendo clic en el botón de abajo',
    'menu.modal.duplicate.title': 'Duplicar un menú',
    'menu.modal.delete.title': 'Eliminar un menú',
    'menu.modal.delete.description': '¿Está seguro de que desea eliminar el menú: "{menuName}" ?',
    'menu.modal.copy.title': 'Copiar un menú',
    'menu.modal.publish.title': 'Publicar el menú',
    'menu.modal.publish.autoPublish': 'Recargar los terminales tras la validación',
    'menu.modal.publish.devicePublish': 'Publicar los menús en los siguientes POS:',
    'menu.modal.publish.deliverooPublish': 'Publicar los menús en las siguientes marcas de Deliveroo:',
    'menu.modal.publish.ubereatsPublish': 'Publicar los menús en las siguientes marcas de UberEats:',
    'menu.modal.publish.duplicateBarCode':
        '\n- El código de barras {barCode} está duplicado para los siguientes productos: {products}',
    'menu.modal.error.name': 'Introduzca un nombre en el campo correspondiente',
    'menu.modal.error.channels': 'Debe desactivar la opción de sincronización con las cajas asociadas',
    'menu.modal.menu.name': 'Nombre del menú',
    'menu.modal.message.defaultIncompatibleDisclaimer':
        'Solo puede asociar cajas maestras o independientes con una versión 7.0 como mínimo',
    'menu.modal.message.versionIncompatibleDisclaimer': 'Solo puede asociar cajas con una versión {values} como mínimo',
    'menu.modal.message.roleIncompatibleDisclaimer': 'No puede asociar cajas {values}',
    'menu.modal.channels.shouldSyncPos': 'Sincronización con las cajas',
    'menu.modal.channels.isSyncFromPosEnabled':
        'Actualizar el menú cuando se realicen modificaciones desde las cajas asociadas',
    'menu.modal.channels.selectActive': 'Activar el menú en los siguientes canales',
    'menu.modal.channels.associatedChannels': 'Canales asociados',
    'menu.modal.channels.pos.selectActive': 'Seleccionar las cajas a asociar al menú',
    'menu.modal.channels.deliveroo.selectActive': 'Seleccionar las marcas de Deliveroo a asociar al menú',
    'menu.modal.channels.ubereats.selectActive': 'Seleccionar las marcas de UberEats a asociar al menú',
    'menu.modal.channels.pos.notFound': 'No se ha encontrado ninguna caja.',
    'menu.modal.channels.associatePos': 'Asociar cajas',
    'menu.modal.channels.associateDeliveroo': 'Asociar las marcas de Deliveroo',
    'menu.modal.channels.associateUberEats': 'Asociar las marcas de UberEats',
    'menu.modal.channels.editMenu': 'Edición del menú',
    'menu.modal.channels.createMenu': 'Creación del menú',
    'menu.modal.channels.selectPos': 'Selección de cajas',
    'menu.modal.channels.selectDeliveroo': 'Selección de marcas de Deliveroo',
    'menu.modal.channels.selectUberEats': 'Selección de marcas de UberEats',
    'menu.modal.externalId': 'Código externo',
    'menu.modal.warn.shift.title': 'Operación peligrosa',
    'menu.modal.warn.shift.text':
        'La edición de un menú durante un servicio puede perturbar la experiencia del cliente en los terminales asociados.',
    'menu.modal.warn.shift.button': 'OK',
    'menu.importPOS.cancel': 'Ahora no',
    'menu.importPOS.title': 'Importación de los menús de caja faltantes en el backoffice',
    'menu.importPOS.step1.title': 'Nuevo: ¡Añada los menús de sus cajas aquí con un solo clic!',
    'menu.importPOS.step1.bullet.1': 'Una gestión más sencilla y completa del plan de teclado y los menús',
    'menu.importPOS.step1.bullet.2':
        'La posibilidad de preparar el plan de teclado con antelación y activarlo con un solo clic',
    'menu.importPOS.step1.bullet.3':
        'La posibilidad de usar el mismo menú para la caja, el terminal y el pedido en línea',
    'menu.importPOS.step1.info':
        'Solo las cajas de una versión superior a 7 y de categoría independiente o maestra pueden tener su menú en el back-office',
    'menu.importPOS.step2.pos': 'Cajas importadas en el back-office',
    'menu.importPOS.step2.switch': 'Actualizar el menú en futuras modificaciones desde la caja asociada',
    'menu.importPOS.step3.title': '¡Todo listo!',
    'menu.importPOS.step3.subtitle': '¡Ahora puede gestionar sus cajas directamente desde el back-office!',
    'menu.importPOS.step3.link': 'Acceder a la documentación',
    'menu.importPOS.step3.info1': 'Haga clic en el menú de su elección para consultarlo y modificarlo',
    'menu.importPOS.step3.info2':
        'Puede duplicar un menú para preparar su próxima carta o modificar para cada menú las cajas y demás modos de consumo asociados',
    'menu.importPOS.step3.info3':
        'Mientras no publique un menú, permanecerá sin cambios en las cajas asociadas.\n<strong>Por lo tanto, debe realizar la acción de publicar para que los cambios realizados en el menú en el back-office se actualicen en las cajas.</strong>\nEsto puede hacerse en las opciones de cada menú en la página de menús o desde la página del plan de teclado.',
    'menuoperation.page.title': 'Operaciones sobre los menús',
    'menuoperation.page.description': 'Encuentre las operaciones sobre los menús de su restaurante',
    'menuoperation.type': 'Tipo',
    'menuoperation.type.update': 'Actualización',
    'menuoperation.type.publish': 'Publicación',
    'menuoperation.type.propagation': 'Propagación',
    'menuoperation.message.from': 'Desde',
    'menuoperation.message.from.brandMenu': 'Desde menú marca:',
    'menuoperation.message.to': 'Hacia',
    'menuoperation.errorModal.title': 'Informe de publicación',
    'menuoperation.errorModal.message': 'La publicación no ha podido completarse.',
    'menuoperation.errorModal.checklist.intro': 'Verifique los siguientes puntos antes de validar de nuevo:',
    'menuoperation.errorModal.checklist.requiredFields': 'Todos los campos obligatorios del producto están completados',
    'menuoperation.errorModal.checklist.requiredMenuImage': 'El menú dispone de una imagen',
    'menuoperation.errorModal.checklist.noSubCategories': 'El menú no tiene subcategorías',
    'menuoperation.errorModal.checklist.imageFormats':
        'Las imágenes respetan los formatos requeridos (entre 320x320px y 6000x6000px)',
    'menuoperation.errorModal.checklist.syncSettings':
        'Los parámetros de sincronización están correctamente configurados',
    'menuoperation.errorModal.checklist.stepDepthLimit':
        'El límite de profundidad de los pasos no se ha superado (máximo 2 niveles para Deliveroo).',
    'menuoperation.actions': 'Acciones',
    'menuoperation.action.download': 'Menú anterior',
    'menuoperation.action.download.before': 'Menú inicial',
    'menuoperation.action.download.after': 'Menú final',
    'menuoperation.download.error.title': 'Error de descarga',
    'menuoperation.download.error': 'No se puede descargar el menú archivado. Por favor, inténtelo de nuevo más tarde.',
    'menu.tags.title': 'Etiquetas',
    'menu.tags.table.name': 'Nombre',
    'menu.tags.create.link': 'Crear una nueva etiqueta',
    'menu.tags.create.error.alreadyTaken': 'Esta etiqueta ya existe',
    'menu.tags.edit.title': 'Editar una etiqueta',
    'menu.tags.create.title': 'Crear una etiqueta',
    'menu.tags.form.color.label': 'Color',
    'menu.tags.delete.confirm': '¿Está seguro de que desea eliminar {count} etiqueta(s)?',
    'menu.functions.title': 'Funciones',
    'menu.functions.subtitle': 'Añada, modifique y asigne funciones a su plan de teclado',
    'menu.functions.table.name': 'Nombre',
    'menu.functions.table.type': 'Tipo',
    'menu.functions.table.status': 'Estado',
    'menu.functions.table.action': 'Acción',
    'menu.functions.status.active': 'Activa',
    'menu.functions.status.inactive': 'Inactiva',
    'menu.functions.noData': 'No se ha creado ninguna función',
    'menu.functions.delete.confirm': '¿Está seguro de que desea eliminar {count} función(es)?',
    'menu.steps.title': 'Pasos',
    'menu.steps.add.title': 'Nuevo paso',
    'menu.steps.duplicate': 'Duplicar',
    'menu.steps.convert': 'Convertir',
    'menu.steps.delete.confirm': '¿Está seguro de que desea eliminar {count} paso(s)?',
    'menu.steps.convert.toCustomization.confirm':
        'Tras la conversión, será necesario configurar los detalles y opciones de su paso de personalización, ¿desea continuar?',
    'menu.steps.convert.toCrossSelling.confirm':
        'Al convertir el paso, la información sobre las opciones mínimas/máximas y las opciones activadas no se conservará, ¿desea continuar?',
    'menu.steps.bulkConvertError':
        'Para poder convertir de forma agrupada, todos los pasos deben ser del mismo tipo (venta adicional o personalización)',
    'menu.steps.column.name': 'Nombre',
    'menu.steps.column.choices': 'Opciones posibles',
    'menu.steps.column.min': 'Mín',
    'menu.steps.column.max': 'Máx',
    'menu.steps.column.stepRef': 'Referencia',
    'menu.steps.column.parentsProducts': 'Número de productos padres',
    'menu.steps.edit.title': 'Editar un paso',
    'menu.steps.editCustomization.title': 'Editar un paso de personalización',
    'menu.steps.editCrossSelling.title': 'Editar un paso de venta adicional',
    'menu.steps.createCustomization.title': 'Crear una personalización',
    'menu.steps.createCrossSelling.title': 'Crear una venta adicional',
    'menu.steps.convert.title': 'Atención',
    'menu.steps.column.type': 'Tipo',
    'menu.steps.typeName.1': 'Personalización',
    'menu.steps.typeName.2': 'Venta adicional',
    'menu.steps.form.ticketLabel': 'Etiqueta del ticket',
    'menu.steps.form.minChoice': 'Opción mínima',
    'menu.steps.form.maxChoice': 'Opción máxima',
    'menu.steps.form.stepRef': 'Referencia',
    'menu.steps.form.maxChoice.error.greaterThanMin': 'Debe ser superior al mínimo',
    'menu.steps.form.isDescriptionDisplayEnabled': 'Mostrar las descripciones',
    'menu.steps.form.options': 'Opciones',
    'menu.steps.form.isExcessAllowed': 'Excedente',
    'menu.steps.form.isGroupEnabled': 'Agrupación',
    'menu.steps.form.isImageDisplayEnabled': 'Mostrar las imágenes',
    'menu.steps.form.isQuantitySelectionEnabled': 'Cantidad',
    'menu.steps.form.isWeightStrategyEnabled': 'Usar los pesos',
    'menu.steps.form.stepProduct': 'Lista de opciones',
    'menu.steps.form.stepProduct.add': 'Añadir una opción',
    'menu.steps.form.stepProduct.orderByName': 'Ordenar por nombre',
    'menu.steps.form.stepProduct.orderByPrice': 'Ordenar por precio',
    'menu.steps.form.stepProduct.setForAllOption': 'Propagar los valores',
    'menu.steps.form.stepProduct.name': 'Nombre',
    'menu.steps.form.stepProduct.price': 'Precio',
    'menu.steps.form.stepProduct.excessPrice': 'Precio en excedente',
    'menu.steps.form.stepProduct.weight': 'Peso unitario',
    'menu.steps.form.stepProduct.group': 'Grupo',
    'menu.steps.form.stepProduct.maxQuantity': 'Cantidad máxima',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': 'Seleccionado por defecto (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': 'Cantidad mínima (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': 'Cantidad por defecto (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': 'Mostrar los atributos POS',
    'menu.steps.form.stepProduct.import': 'Importar',
    'menu.steps.form.stepProduct.importWithPrice': 'Importar con el precio',
    'menu.steps.form.stepProduct.importWithoutPrice': 'Importar sin el precio',
    'menu.steps.propagate.title': 'Propagar pasos',
    'menu.categories.title': 'Categorías',
    'menu.categories.subtitle': 'Edite las categorías de su menú',
    'menu.categories.addCategory': 'Crear una categoría',
    'menu.categories.noData': 'No hay ninguna categoría en el menú.',
    'menu.categories.addProduct': 'Añadir un producto',
    'menu.categories.createProduct': 'Crear un producto',
    'menu.categories.deleteCategory': 'Eliminar',
    'menu.categories.removeProduct': 'Retirar',
    'menu.categories.deleteCategory.confirm':
        '¿Está seguro de que desea eliminar esta categoría?\nDejará de estar disponible y sus elementos secundarios (productos y subcategorías) quedarán huérfanos.',
    'menu.categories.create.title': 'Crear una categoría',
    'menu.categories.edit.title': 'Editar una categoría',
    'menu.categories.products': '{productCount, plural, =0 {ningún producto} one {# producto} other {# productos}}',
    'menu.categories.create.error.alreadyTaken': 'Esta categoría ya existe',
    'menu.products.title': 'Productos',
    'menu.products.table.image': 'Imagen',
    'menu.products.table.name': 'Nombre',
    'menu.products.table.categories': 'Categorías',
    'menu.products.table.price': 'Precio',
    'menu.products.table.vat': 'IVA',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': 'Etiquetas',
    'menu.products.reload.kiosk': 'Recargar',
    'menu.products.create.link': 'Crear un producto',
    'menu.products.massEdit': 'Edición agrupada',
    'menu.products.duplicate': 'Duplicar',
    'menu.products.copy': 'Propagar',
    'menu.products.copy.title': 'Propagar los productos',
    'menu.products.copy.form.restaurants.title': 'Selecciono mis restaurantes de destino',
    'menu.products.copy.form.restaurants.label': 'Destinos',
    'menu.products.copy.form.restaurants.tooltip':
        'Elija los restaurantes de la marca que recibirán la propagación del producto y/o de sus pasos.',
    'menu.products.copy.form.restaurants.tooltip.title': 'Selecciono mis restaurantes de destino',
    'menu.products.copy.form.restaurants.tooltip.example':
        'Desde el menú de la marca, decide propagar el postre Brownie únicamente hacia los restaurantes A y B → solo estos restaurantes tendrán este nuevo producto.',
    'menu.products.copy.form.updateIgnoreAttributes.title':
        'Durante la propagación, no deseo sobreescribir las siguientes propiedades en:',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        'Durante la propagación de un producto de la marca hacia un restaurante donde ya existe (individualmente o a través de un paso), puede elegir conservar ciertas propiedades de dicho producto individual: etiqueta, categoría padre, imagen, precio, IVA, nombre y descripción.',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title':
        'Conservar ciertas propiedades durante la propagación de un producto ya existente',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        'El producto individual Cookie ya existe en el restaurante con una imagen personalizada y un precio específico → si marca "Imagen" y "Precio", estos valores se conservarán, incluso tras la propagación desde la marca.\n\n👉 Para los nuevos productos, todas las propiedades de la marca se propagan automáticamente.',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products':
        'Productos ya presentes en los menús de los restaurantes de destino',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps':
        'Pasos ya presentes en los menús de los restaurantes de destino',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title':
        'Conservar ciertas propiedades durante la propagación de un paso ya existente',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        'Durante la propagación de un paso de la marca hacia un restaurante donde ya existe, puede elegir conservar ciertas propiedades de dicho paso: precio del producto en el paso, cantidad máxima por producto (si la opción Cantidad está activada) y precio en excedente.',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        'En el restaurante, el paso Elegir un postre tiene un Cookie a 2 € con una cantidad máxima de 3.\nLa marca propaga en el paso un Cookie a 1 € con una cantidad máxima de 1.\n→ Si conserva "Precio producto" y "Cantidad máx", el restaurante mantiene Cookie a 2 € y cantidad máx de 3.\n\n👉 Para los nuevos pasos, todas las propiedades de la marca se propagan automáticamente.',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder':
        'Durante la propagación, no deseo sobreescribir las siguientes propiedades',
    'menu.products.copy.form.attribute.price': 'Precio',
    'menu.products.copy.form.attribute.vat': 'IVA',
    'menu.products.copy.form.attribute.name': 'Nombre',
    'menu.products.copy.form.attribute.description': 'Descripción',
    'menu.products.copy.form.attribute.categories': 'Categorías padres',
    'menu.products.copy.form.attribute.tags': 'Etiquetas',
    'menu.products.copy.form.attribute.imageId': 'Imagen',
    'menu.products.copy.form.attribute.exceedPrice': 'Precio en excedente',
    'menu.products.copy.form.attribute.maxProductQuantity': 'Cantidad máxima',
    'menu.products.copy.form.publishAfterCopy.title': 'Durante la propagación, deseo:',
    'menu.products.copy.form.publishAfterCopy.tooltip': 'Publicar automáticamente los menús en las cajas asociadas',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': 'Publicación automática',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        'Si está activado, los menús se publicarán automáticamente en todas las cajas asociadas a los restaurantes de destino.',
    'menu.products.copy.form.publishAfterCopy': 'Publicar automáticamente los menús en las cajas asociadas',
    'menu.products.copy.form.publishAfterCopy.disclaimer':
        '⚠️ Atención, es necesario añadir en el plan de teclado los nuevos productos propagados',
    'menu.products.copy.form.strategy.title':
        'Estrategia de propagación para los pasos ya existentes en los menús de destino',
    'menu.products.copy.form.strategy.tooltip':
        'Los pasos ya presentes en el restaurante son reemplazados por los configurados en el menú de la marca (productos y precios incluidos).',
    'menu.products.copy.form.strategy.tooltip.title': 'Estrategia: Actualizar los pasos existentes',
    'menu.products.copy.form.strategy.tooltip.example':
        'El restaurante A tiene el paso "Elegir un postre" con Pain perdu, Frutas, Cookie (2€).\nLa marca lo propaga con Cookie (1€), Brownie (2€) → El restaurante A tendrá Cookie (1€), Brownie (2€).\n\n👉 El producto individual Cookie se actualiza, el producto individual Brownie se crea y el producto Pain perdu se retira del paso.',
    'menu.products.copy.form.strategy.replace':
        'Actualizar los pasos existentes del(los) menú(s) del(los) restaurante(s) con los propagados del menú de la marca',
    'menu.products.copy.form.strategy.replace.tooltip.title': 'Estrategia: Actualizar los pasos existentes',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        'Los pasos ya presentes en el restaurante son reemplazados por los configurados en el menú de la marca (productos y precios incluidos).',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        'El restaurante A tiene el paso "Elegir un postre" con Pain perdu, Frutas, Cookie (2€).\nLa marca lo propaga con Cookie (1€), Brownie (2€) → El restaurante A tendrá Cookie (1€), Brownie (2€).\n\n👉 El producto individual Cookie se actualiza, el producto individual Brownie se crea y el producto Pain perdu se retira del paso.',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        'Actualizar los pasos existentes del(los) menú(s) del(los) restaurante(s) y conservar los productos existentes no presentes en el paso del menú de la marca',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title':
        'Estrategia: Actualizar y conservar los productos existentes',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        'Los pasos del restaurante se actualizan con los de la marca, pero los productos ya presentes y ausentes del menú de la marca se conservan.',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        'El restaurante A tiene el paso "Elegir un postre" con Pain perdu (1€), Frutas (2€), Cookie (2€).\nLa marca lo propaga con Cookie (1€), Brownie (2€) → El restaurante A tendrá Pain perdu (1€), Frutas (2€), Cookie (1€), Brownie (2€).\n\n👉 El producto individual Cookie se actualiza, el producto individual Brownie se crea y el producto Pain perdu se conserva en el paso.',
    'menu.products.copy.form.strategy.keep_existing': 'No modificar los pasos ya existentes en los menús de destino',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': 'Estrategia: No modificar los pasos existentes',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description':
        'Los pasos ya presentes en el restaurante no se modifican durante la propagación.',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        'El restaurante A tiene el paso "Elegir un postre" con Pain perdu (1€), Frutas (2€), Cookie (2€).\nLa marca lo propaga con Cookie (1€), Brownie (2€) → El restaurante A conserva Pain perdu (1€), Frutas (2€), Cookie (2€).\n\n👉 El producto individual Cookie se actualiza y el producto individual Brownie se crea.',
    'menu.products.copy.form.channel.title': 'Selecciono mis canales de destino',
    'menu.products.copy.form.channel.tooltip':
        'Elija los canales (p. ej.: Caja, Pedido En Línea (CEL), Terminal) en los que se aplicará la propagación del producto y/o de sus pasos.',
    'menu.products.copy.form.channel.tooltip.title': 'Selecciono mis canales de destino',
    'menu.products.copy.form.channel.tooltip.example':
        'Propaga el postre Brownie pero elige solo Terminal → el producto será visible únicamente en los menús de terminal de los restaurantes seleccionados.',
    'menu.products.copy.form.channel.web': 'Pedido en línea o en mesa',
    'menu.products.copy.form.channel.kiosk': 'Terminal',
    'menu.products.copy.form.channel.pos': 'Cajas',
    'menu.products.copy.form.channel.marketplace': 'Marketplace (UberEats/Deliveroo)',
    'menu.products.copy.form.channel.null': 'No asociado',
    'menu.products.copy.form.other.strategies.title': 'Creación de nuevos productos',
    'menu.products.copy.form.other.strategies.tooltip':
        'Durante la propagación de nuevos productos, la marca propaga en el paso un Cookie a 2 € con una cantidad máxima de 3. Si conserva "Precio producto" y "Cantidad máx", el restaurante mantiene Cookie a 2 € y cantidad máx de 3. → Si conserva "Precio producto" y "Cantidad máx", el restaurante mantiene Cookie a 2 € y cantidad máx de 3.',
    'menu.products.copy.form.other.strategies.tooltip.title': 'Creación de nuevos productos',
    'menu.products.copy.form.other.strategies.tooltip.example':
        'Durante la propagación de nuevos productos, la marca propaga en el paso un Cookie a 2 € con una cantidad máxima de 3. Si conserva "Precio producto" y "Cantidad máx", el restaurante mantiene Cookie a 2 € y cantidad máx de 3.\n→ Si conserva "Precio producto" y "Cantidad máx", el restaurante mantiene Cookie a 2 € y cantidad máx de 3.',
    'menu.products.copy.form.other.strategies.tags': 'Crear sobre la marcha las etiquetas faltantes de los productos',
    'menu.products.copy.form.other.strategies.categories':
        'Crear sobre la marcha las categorías faltantes de los productos',
    'menu.products.copy.form.posMenus.title': 'Menús activos de la Caja',
    'menu.products.copy.form.posMenus.description':
        'Esta tabla muestra únicamente los restaurantes donde hay varios menús de caja activos. Si solo hay un menú de caja activo, la propagación se realiza por defecto en ese menú.',
    'menu.products.copy.form.posMenus.tooltip':
        'Seleccione los menús de Caja en los que desea propagar los productos para cada restaurante.',
    'menu.products.copy.form.posMenus.tooltip.title': 'Selección de los menús de Caja',
    'menu.products.copy.form.posMenus.tooltip.example':
        'Si un restaurante tiene varios menús de Caja, puede elegir propagar en uno o varios menús específicos.',
    'menu.products.copy.form.posMenus.column.restaurant': 'Nombre del restaurante',
    'menu.products.copy.form.posMenus.column.menus': 'Menú(s) activo(s)',
    'menu.products.copy.form.posMenus.empty':
        'No hay ningún menú de Caja disponible para los restaurantes seleccionados',
    'menu.products.copy.form.posMenus.placeholder': 'Seleccionar los menús...',
    'menu.products.copy.form.posMenus.warning':
        '⚠️ Atención, por defecto, todos los menús activos de un restaurante están seleccionados para la propagación de los productos.',
    'menu.products.copy.form.marketplaceMenus.title': 'Menús activos de los Marketplaces',
    'menu.products.copy.form.marketplaceMenus.description':
        'Esta tabla muestra únicamente los restaurantes donde hay varios menús de marketplace activos. Si solo hay un menú de marketplace activo, la propagación se realiza por defecto en ese menú.',
    'menu.products.copy.form.marketplaceMenus.tooltip':
        'Seleccione los menús de marketplace en los que desea propagar los productos para cada restaurante.',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': 'Selección de los menús de Marketplace',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        'Si un restaurante tiene varios menús de marketplace, puede elegir propagar en uno o varios menús específicos.',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': 'Nombre del restaurante',
    'menu.products.copy.form.marketplaceMenus.column.menus': 'Menú(s) activo(s)',
    'menu.products.copy.form.marketplaceMenus.empty':
        'No hay ningún menú de marketplace disponible para los restaurantes seleccionados',
    'menu.products.copy.form.marketplaceMenus.placeholder': 'Seleccionar los menús...',
    'menu.products.copy.form.marketplaceMenus.warning':
        '⚠️ Atención, por defecto, todos los menús activos de un restaurante están seleccionados para la propagación de los productos.',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': 'Durante la propagación, deseo:',
    'menu.products.copy.form.publishAfterCopy.marketplace':
        'Publicar automáticamente los menús en los marketplaces asociados',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer':
        'Los menús serán publicados en los marketplaces asociados a los restaurantes.',
    'menu.products.copy.form.disclaimer':
        '⚠️ Atención, este(os) producto(s) se copiará(n) en todos los restaurantes seleccionados, en todos sus menús. Antes de guardar, verifique su nombre, descripción, imagen, IVA, precio.',
    'menu.copy.validate.title': 'Verificación de los productos / pasos a propagar',
    'menu.copy.validate.success':
        'Todos los productos / pasos a propagar tienen un SKU / referencia de paso configurado',
    'menu.copy.validate.warning': 'SKU no indicado en la ficha del producto del menú de la marca',
    'menu.copy.validate.error': 'SKU duplicado o referencia de paso no indicada en el menú de la marca',
    'menu.copy.validate.step.missing.identifier.detail': 'Referencia de paso no indicada en el paso',
    'menu.copy.validate.product.missing.identifier.detail': 'SKU no indicado en el producto',
    'menu.copy.validate.step.duplicate.identifier.detail':
        'Conflicto en la referencia <b>{identifier}</b> entre los pasos',
    'menu.copy.validate.product.duplicate.identifier.detail':
        'Conflicto en el SKU <b>{identifier}</b> entre los productos',
    'menu.products.overwrite': 'Marque la casilla de la izquierda para editar los campos',
    'menu.products.overwriteRelations':
        'Marque la casilla de la izquierda para reemplazar todo en lugar de añadir elementos',
    'menu.products.error.alreadyTaken': 'Este producto ya existe',
    'menu.products.error.billingCodeRequired': 'La facturación automática requiere completar este campo',
    'menu.products.add.title': 'Añadir un producto',
    'menu.products.edit.title': 'Editar un producto',
    'menu.products.propagate.title': 'Propagar productos',
    'menu.products.create.title': 'Crear un producto',
    'menu.products.delete.confirm': '¿Está seguro de que desea eliminar {count} producto(s)?',
    'menu.products.form.price': 'Precio IVA incluido',
    'menu.product.form.pricePerkg': 'Precio IVA incluido / kg',
    'menu.products.form.priceType': 'Tipo de precio',
    'menu.products.form.priceType.placeholder': 'Tipo de precio',
    'menu.products.form.priceType.fixed': 'Precio fijo',
    'menu.products.form.priceType.customizablePrice': 'Producto a precio libre',
    'menu.products.form.priceType.customizablePriceAndLabel': 'Producto a precio y etiqueta libre',
    'menu.products.form.measurementUnit': 'Medido por',
    'menu.products.form.measurementUnit.placeholder': 'Medido por',
    'menu.products.form.measurementUnit.unit': 'Unidad',
    'menu.products.form.measurementUnit.kg': 'kg',
    'menu.products.form.kg.channelRestriction': 'Los productos por kg no están disponibles en el canal Terminal.',
    'menu.products.form.availability': 'Disponibilidad por canal',
    'menu.products.form.webAvailability': 'Web',
    'menu.products.form.kioskAvailability': 'Terminal',
    'menu.products.form.servingCount': 'Número de comensales',
    'menu.products.form.barCode': 'Código de barras',
    'menu.products.form.ticketLabel': 'Texto de producción',
    'menu.products.form.ticketLabel.checkbox': 'Tener un texto de producción diferente del nombre del producto',
    'menu.products.form.noVat': 'Producto no sujeto a IVA',
    'menu.products.form.vat': 'IVA por defecto',
    'product.vatGroup': 'Grupo de IVA',
    'product.vatGroup.withHint': 'Grupo de IVA (en local / para llevar / entrega)',
    'product.selectVatGroup': 'Seleccionar un grupo de IVA',
    'product.vatGroup.noOperationZone': 'Ninguna zona de operación configurada para este restaurante',
    'product.vatGroup.eatIn': 'En local',
    'product.vatGroup.takeAway': 'Para llevar',
    'product.vatGroup.delivery': 'Entrega',
    'product.vatGroup.hint':
        'Para cambiar el IVA por modo de consumo, modifique el campo «Grupo de IVA (en local / para llevar / entrega)»',
    'menu.products.form.image.placeholder': 'Imagen',
    'menu.products.form.externalId': 'Código externo',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': 'Elegir un SKU',
    'menu.products.form.sku.noOption': 'Solo se puede crear un nuevo SKU a nivel de la marca',
    'menu.products.form.createSku': 'Crear el SKU "{value}"',
    'menu.products.form.replaceSkuAll':
        'Reemplazar el SKU "{currentSku}" por "{value}" (en todos los productos con el mismo SKU)',
    'menu.products.form.replaceSkuThisProduct':
        'Reemplazar el SKU "{currentSku}" por "{value}" (únicamente en este producto)',
    'menu.products.form.createTag': 'Crear la etiqueta "{value}"',
    'menu.products.form.billingCode': 'Código de factura',
    'menu.products.form.purchasePrice': 'Precio de contrato',
    'menu.products.form.description': 'Descripción',
    'menu.products.form.description.tooLong': 'La descripción no debe superar los 1500 caracteres',
    'menu.products.form.additionalInformation': 'Información adicional',
    'menu.products.form.section.options': 'Opciones',
    'menu.products.form.section.quantity': 'Gestión de existencias',
    'menu.products.form.section.externalData': 'Datos externos',
    'menu.products.form.currentQuantitySwitch': 'Activar la gestión de existencias para el producto',
    'menu.products.form.defaultQuantitySwitch': 'Reinicio diario del stock',
    'menu.products.form.currentQuantityInput': 'Cantidad en stock',
    'menu.products.form.defaultQuantityInput': 'Cantidad al inicio del día',
    'menu.products.form.defaultQuantityHint':
        'Cada día entre las 4h y las 5h de la mañana, la cantidad se restablecerá a la predeterminada',
    'menu.products.form.isEligibleLuncheon': 'Apto para vales de restaurante',
    'menu.products.form.isFinalProduct': 'Producto final',
    'menu.products.form.subsidizable': 'Producto subvencionable',
    'menu.products.form.admissible': 'Producto admisionable',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants':
        'Admisión/Subvención multiplicada en cada adición al carrito',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        'Al activar esta opción, las admisiones (y subvenciones) se multiplicarán en el pedido si el producto se añade varias veces al carrito o si otro producto con la misma opción se añade al carrito. La multiplicación se realiza dentro del límite diario y del techo definidos en el régimen tarifario.',
    'menu.products.form.excludedFromUrssaf': 'No contabilizar en el mínimo urssaf',
    'menu.products.form.section.pos': 'Atributos específicos de las cajas',
    'menu.products.form.minQuantity': 'Cantidad mínima',
    'menu.products.form.alwaysAskForCustomization': 'Solicitar siempre los pasos',
    'menu.products.form.discountable': 'Permitir descuentos en el producto',
    'menu.products.form.isDeposit': 'Producto de tipo depósito',
    'menu.products.form.posPrice': 'Importe del depósito',
    'menu.products.form.vatSitIn': 'IVA en local',
    'menu.products.form.vatDelivery': 'IVA en entrega',
    'menu.products.form.vatTakeAway': 'IVA para llevar',
    'menu.products.form.section.kitchenOptions': 'Opciones de la pantalla de cocina',
    'menu.products.form.isMenu': 'Es un menú',
    'menu.products.form.is_customization': 'Es una personalización',
    'menu.products.form.isProducible': 'Mostrar en el resumen',
    'menu.products.form.no_kitchen': 'No mostrar en la pantalla de cocina',
    'menu.products.form.section.consumptionMode': 'Disponibilidad del producto según el modo de consumo',
    'menu.products.form.consumptionModeType.mode_sit_in': 'En local',
    'menu.products.form.consumptionModeType.mode_delivery': 'En entrega',
    'menu.products.form.consumptionModeType.mode_take_away': 'Para llevar',
    'menu.products.form.consumptionModeType.mode_drive': 'Drive',
    'menu.products.form.tags': 'Etiquetas',
    'menu.products.form.tags.placeholder': 'Buscar la(s) etiqueta(s) a asociar',
    'menu.products.form.steps': 'Pasos',
    'menu.products.form.steps.page': 'Página {pageNumber}',
    'menu.products.form.steps.addToNewPage': 'Añadir a una nueva página',
    'menu.products.form.steps.addEachToNewPage': 'Añadir cada paso a una nueva página',
    'menu.products.form.steps.addToPage': 'Página a la que añadir el paso',
    'menu.products.form.steps.addEmptyPage': 'Añadir una página',
    'menu.products.form.categories': 'Categorías padres',
    'menu.products.form.productType': 'Tipo',
    'menu.products.form.productType.placeholder': 'Tipo de producto',
    'menu.products.form.productType.product': 'Producto',
    'menu.products.form.productType.deposit': 'Depósito',
    'menu.products.form.categories.placeholder': 'Buscar la(s) categoría(s) padre(s)',
    'menu.products.form.externalReference': 'Referencia externa',
    'menu.products.form.externalReference.placeholder': 'Nombre de la referencia',
    'menu.products.form.externalReference.name': 'Nombre',
    'menu.products.form.externalReference.value': 'Valor',
    'menu.products.form.machineCode': 'Código de máquina Nayax del producto',
    'menu.products.form.steps.add': 'Añadir un paso',
    'menu.products.form.steps.addPage': 'Arrastre el paso aquí para crear una nueva página',
    'menu.products.form.steps.column.name': 'Nombre',
    'menu.products.form.steps.column.type': 'Tipo',
    'menu.products.form.steps.column.choices': 'Opciones posibles',
    'menu.products.form.steps.column.position': 'Página',
    'menu.products.form.steps.column.subPosition': 'Posición',
    'menu.products.form.steps.column.min': 'Mín',
    'menu.products.form.steps.column.max': 'Máx',
    'menu.products.form.steps.column.parentsProducts': 'Número de productos padres',
    'menu.products.form.steps.cross-selling.add': 'Añadir una venta adicional',
    'menu.products.form.steps.customization.add': 'Añadir una personalización',
    'menu.products.form.steps.type.cross-selling': 'Venta adicional',
    'menu.products.form.steps.type.customization': 'Personalización',
    'reportGenerationsHistory.title': 'Historial de generaciones',
    'reportGenerationsHistory.subtitle': 'Aquí encontrará el historial de sus generaciones de exportaciones.',
    'reportGenerationsHistory.tableCard.title': 'Exportaciones',
    'reportGenerationsHistory.tableCard.subtitle': 'Lista de exportaciones',
    'reportGenerationsHistory.tableCard.actionLabel': 'Actualizar la página',
    'reportGenerationsHistory.emptyMessage': 'Su historial de generación está vacío',
    'reportGenerationsHistory.tableHeader.createdAt': 'Fecha',
    'reportGenerationsHistory.tableHeader.fileName': 'Nombre del archivo',
    'reportGenerationsHistory.tableHeader.reportType': 'Estado',
    'reportGenerationsHistory.tableHeader.status': 'Avance',
    'reportGenerationsHistory.tableHeader.action': 'Descargar',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': 'Prefacturación',
    'reportGenerationsHistory.tableRow.reportType.orders': 'Pedidos',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': 'Movimientos de tarjetas',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': 'Síntesis financiera',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary':
        'Síntesis financiera por modo de gestión',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': 'Saldo de las tarjetas por cliente',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        'Síntesis financiera por modo de gestión sin IVA',
    'reportGenerationsHistory.tableRow.reportType.ewallet': 'E-wallet',
    'reportGenerationsHistory.tableRow.reportType.accounting': 'Contable',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': 'Informe de ventas mensual',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': 'Completado',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': 'En curso',
    'reportGenerationsHistory.tableRow.generationStatus.failed': 'Error',
    'reportGenerationsHistory.tableRow.action.download': 'Descargar',
    'report.emptyMessage': 'Sin resultados',
    'report.title.monthly_sales_report': 'Informe de ventas mensual',
    'report.selectDateRangeButton.text': 'Del {startDate} al {endDate}',
    'report.calendarModal.dateRage.errorMessage': 'No puede seleccionar más de {maxRangeInDays} días',
    'report.calendarModal.title': 'Elija un período',
    'report.calendarModal.submit': 'Validar',
    'report.filtersButton.text': 'Filtros',
    'report.filtersModal.title': 'Elija los filtros',
    'report.filtersModal.submit': 'Filtrar',
    'report.filtersModal.form.restaurantLabel': 'Restaurantes',
    'report.filtersModal.form.devicesLabel': 'Cajas',
    'report.filtersModal.form.sourcesLabel': 'Canales de pedido',
    'report.filtersModal.form.tagsLabel': 'Etiquetas',
    'report.filtersModal.form.consumptionModesLabel': 'Modos de consumo',
    'report.filtersModal.form.sellersLabel': 'Vendedores',
    'report.filtersModal.form.vatsLabel': 'IVA',
    'report.filtersModal.form.categoriesLabel': 'Categorías',
    'report.filtersModal.form.loyaltyLabel': 'Mostrar únicamente los pedidos pagados con fidelidad',
    'report.filtersModal.form.only_parentsLabel': 'Mostrar las categorías padres',
    'report.filtersModal.saveAs.placeholder': 'Guardar como ...',
    'report.filtersModal.saveAs.save': 'Guardar y Aplicar',
    'report.exportButton.text': 'Exportar',
    'report.exportResultModal.title': 'Exportación CSV',
    'report.exportResultModal.resultSuccess': 'La generación de la exportación está en curso',
    'report.exportResultModal.stayInPage': 'Permanecer en esta página',
    'report.exportResultModal.redirectToGenerationHistory': 'Ver las exportaciones en curso',
    'report.exportResultModal.resultFail': 'A problem has occurred, please try again in a few moments',
    'report.savedFiltersDropdown.placeholder': 'Filtros guardados',
    'report.savedFiltersDropdown.deleteModal.title': 'Atención',
    'report.savedFiltersDropdown.deleteModal.description': '¿Está seguro de que desea eliminar?',
    'salesSummary.tableCard.title': 'Generar una nueva exportación',
    'salesSummary.tableCard.subtitle': 'Seleccione sus criterios y filtros, haga clic en "Generar".',
    'salesSummary.form.choosePeriod': 'Elija un período',
    'salesSummary.form.reportType': 'Formato del informe',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': 'Síntesis financiera por modo de gestión',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax':
        'Síntesis financiera por modo de gestión sin IVA',
    'salesSummary.form.reportType.salesSummary': 'Síntesis financiera',
    'salesSummary.form.restaurants': 'Restaurantes',
    'salesSummary.form.groups': 'Grupos',
    'salesSummary.form.pricingRules': 'Régimen tarifario',
    'salesSummary.form.accountedOrders': 'Pedidos contabilizados',
    'salesSummary.form.accountedOrders.all': 'Pedidos + Contraasientos',
    'salesSummary.form.accountedOrders.ordersOnly': 'Pedidos',
    'salesSummary.form.accountedOrders.contraEntriesOnly': 'Contraasientos',
    'salesSummary.exportResultModal.title': 'Generación de la exportación',
    'shift.default': 'Por defecto',
    'shift.allDays': 'Todos los días',
    'shift.period': 'Del {start} al {end}',
    'shift.days.MON': 'Lunes',
    'shift.days.TUE': 'Martes',
    'shift.days.WED': 'Miércoles',
    'shift.days.THU': 'Jueves',
    'shift.days.FRI': 'Viernes',
    'shift.days.SAT': 'Sábado',
    'shift.days.SUN': 'Domingo',
    'shift.amount.required': 'El importe es obligatorio',
    'shift.amount.positive': 'El importe debe ser positivo',
    'shift.threshold.positive': 'El umbral debe ser positivo',
    'shift.ceiling.required': 'Obligatorio para una subvención en porcentaje',
    'shift.vat.required': 'El IVA es obligatorio',
    'shift.vat.positive': 'El IVA debe ser positivo',
    'brandHistory.tableCard.title': 'Historial',
    'brandHistory.tableCard.subtitle': 'Busque las acciones realizadas en la marca',
    'brandHistory.emptyMessage': 'No se ha encontrado historial',
    'brandHistory.searchPlaceholder': 'Buscar en el historial',
    'brandHistory.entityType': 'Tipo de entidad',
    'brandHistory.entityType.GRANT': 'Subvención',
    'brandHistory.entityType.ENTRANCE_FEE': 'Admisión',
    'brandHistory.entityType.PRICING_RULE': 'Régimen tarifario',
    'brandHistory.entityType.PRODUCT': 'Producto',
    'brandHistory.entityType.STEP': 'Paso',
    'brandHistory.entityType.CATEGORY': 'Categoría',
    'brandHistory.entityType.MENU': 'Menú',
    'brandHistory.entityType.MODULE': 'Módulo',
    'brandHistory.entityType.CUSTOMER': 'Cliente',
    'brandHistory.entityType.CUSTOMERS_IMPORT': 'Importación de clientes',
    'brandHistory.entityType.CUSTOMERS_UPDATE': 'Modificación de clientes',
    'brandHistory.entityType.USER': 'Usuario',
    'brandHistory.entityType.CHANNEL': 'Canal',
    'brandHistory.entityType.CONSUMPTION_MODE': 'Modo de consumo',
    'brandHistory.entityType.ORDER': 'Pedido',
    'brandHistory.entityType.BRAND': 'Marca',
    'brandHistory.entityType.RESTAURANT': 'Restaurante',
    'brandHistory.entityName': 'Nombre de la entidad',
    'brandHistory.restaurant': 'Restaurante',
    'brandHistory.user': 'Usuario',
    'brandHistory.action': 'Acción',
    'brandHistory.eventDate': 'Fecha',
    'brandHistory.action.create': 'Creación',
    'brandHistory.action.open': 'Apertura',
    'brandHistory.action.activate': 'Activación',
    'brandHistory.action.duplicate': 'Duplicación',
    'brandHistory.action.delete': 'Eliminación',
    'brandHistory.action.close': 'Cierre',
    'brandHistory.action.deactivate': 'Desactivación',
    'brandHistory.action.cancel': 'Cancelación',
    'brandHistory.action.update': 'Modificación',
    'brandHistory.action.import': 'Importación',
    'brandHistory.action.unknown': 'Desconocido',
    'brandHistory.modal.title': 'Informe de las acciones realizadas',
    'brandHistory.modal.actions': 'Informe de acciones',
    'brandHistory.modal.logs': 'Informe de registros',
    'brandHistory.modal.informations': 'Información asociada',
    'brandHistory.modal.entityName': 'Nombre de la entidad',
    'brandHistory.modal.user': 'Usuario: ',
    'brandHistory.modal.date': 'Fecha del cambio: ',
    'brandHistory.modal.close': 'Cerrar',
    'brandHistory.modal.empty': 'No se encuentra nada aquí 😰',
    'crossSelling.name': 'Nombre de la página de cross-selling',
    'crossSelling.page.title': 'Cross-selling',
    'crossSelling.page.description': 'Cree y gestione sus páginas de cross-selling',
    'crossSelling.action.newCrossSelling': '+ Nueva página de cross-selling',
    'crossSelling.modal.duplicate.title': 'Duplicar una página de cross-selling',
    'crossSelling.modal.create.title': 'Crear su página de cross-selling',
    'crossSelling.modal.delete.title': 'Eliminar una página de cross-selling',
    'crossSelling.modal.delete.description': '¿Está seguro de que desea eliminar la página: "{crossSellingName}" ?',
    'crossSelling.modal.error.name': 'Introduzca un nombre en el campo correspondiente',
    'crossSelling.modal.menu.name': 'Nombre de la página de cross-selling',
    'crossSelling.page.create.title': 'Crear una página de Cross-selling',
    'crossSelling.page.update.title': 'Modificar la página de Cross-selling "{crossSellingName}"',
    'crossSelling.page.create.description': 'Configuración de la página de Cross-Selling',
    'crossSelling.page.update.description': 'Configuración de la página de Cross-Selling',
    'crossSelling.products.image': 'Imagen',
    'crossSelling.products.name': 'Nombre',
    'crossSelling.products.price': 'Precio',
    'crossSelling.products.vat': 'IVA',
    'crossSelling.products.tags': 'Etiquetas',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': 'Menú',
    'crossSelling.products.menuState': 'Estado del menú',
    'crossSelling.products.restaurantName': 'Restaurante',
    'crossSelling.products.add': 'Añadir productos',
    'crossSelling.products.menuState.enabled': 'Activado',
    'crossSelling.products.menuState.disabled': 'Desactivado',
    'tableLayout.name': 'Nombre del plano de mesas',
    'tableLayout.page.title': 'Planos de mesas',
    'tableLayout.page.description': 'Cree y gestione sus planos de mesas',
    'tableLayout.table.associatedPos': 'Cajas asociadas',
    'tableLayout.action.newTableLayout': '+ Nuevo plano de mesas',
    'tableLayout.modal.create.title': 'Crear un plano de mesas',
    'tableLayout.modal.edit.title': 'Modificar el plano de mesas "{tableLayoutName}"',
    'tableLayout.modal.delete.title': 'Eliminar un plano de mesas',
    'tableLayout.modal.delete.description':
        '¿Está seguro de que desea eliminar el plano de mesas: "{tableLayoutName}" ?',
    'tableLayout.modal.publish.title': 'Publicar un plano de mesas',
    'tableLayout.modal.publish.description':
        '¿Está seguro de que desea publicar el plano de mesas: "{tableLayoutName}" ?',
    'tableLayout.modal.error.name': 'Introduzca un nombre en el campo correspondiente',
    'room.name': 'Nombre de la sala',
    'room.page.title': 'Salas',
    'room.page.description': 'Cree y gestione sus salas',
    'room.action.newRoom': '+ Nueva sala',
    'room.action.publish': 'Publicar el plano de mesas',
    'room.modal.create.title': 'Crear una sala',
    'room.modal.edit.title': 'Modificar la sala "{roomName}"',
    'room.modal.view.title': 'Sala "{roomName}"',
    'room.modal.single': 'Añadir una mesa',
    'room.modal.single.placeholder': 'Mesa principal',
    'room.modal.multiple': 'Añadir varias mesas',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': 'Organizar las mesas',
    'room.modal.delete.title': 'Eliminar una sala',
    'room.modal.delete.description': '¿Está seguro de que desea eliminar la sala: "{roomName}" ?',
    'room.modal.error.name': 'Introduzca un nombre en el campo correspondiente',
    'room.modal.error.new_table_name': 'Introduzca un nombre o número de mesa',
    'room.modal.error.fill_start_and_end': 'Introduzca un valor de inicio y un valor de fin (superior al del inicio)',
    'room.modal.error.max_count_table': 'No puede tener más de {maxCount} mesas por sala.',
    'pos.configuration': 'Configuración',
    'pos.devices': 'Cajas',
    'pos.access': 'Roles y permisos',
    'pos.access.users': 'Usuarios',
    'pos.access.roles': 'Roles',
    'pos.access.groups': 'Grupos',
    'pos.users.page.title': 'Operadores de caja',
    'pos.roles.page.title': 'Roles y permisos de caja',
    'pos.groups.page.title': 'Grupos de acceso de caja',
    'pos.users.page.description':
        'Los operadores de caja permiten definir los usuarios que pueden interactuar con la caja.',
    'pos.roles.page.description': 'Los roles de caja permiten definir grupos de permisos para los usuarios de la caja.',
    'pos.groups.page.description':
        'Los grupos de acceso gestionan los usuarios y su asociación con las cajas del restaurante',
    'pos.users.action.newUser': 'Crear un nuevo operador',
    'posUser.name.form.label': 'Nombre de operador',
    'posUser.name.form.placeholder': 'Nombre de operador de caja',
    'posUser.pinCode.form.label': 'Código PIN de operador',
    'posUser.pinCode.form.placeholder': 'Código PIN de operador de caja',
    'posUser.role.form.label': 'Rol de operador',
    'posGroup.name.form.label': 'Nombre del grupo',
    'posGroup.name.form.placeholder': 'Introduzca el nombre del grupo de acceso',
    'posGroup.users.form.label': 'Operadores',
    'posGroup.users.form.placeholder': 'Seleccione los operadores asociados',
    'posGroup.devices.form.label': 'Cajas',
    'posGroup.devices.form.placeholder': 'Seleccione las cajas asociadas',
    'posUser.create.form.title': 'Crear un nuevo operador de caja',
    'posGroup.create.form.title': 'Crear un nuevo grupo de acceso',
    'posGroup.edit.form.title': 'Modificar el grupo de acceso',
    'posUser.edit.form.title': 'Editar el operador de caja: ',
    'posUser.form.description': 'Indique la información de su operador de caja.',
    'posGroup.form.description': 'Indique la información de su grupo de acceso de caja.',
    'posUser.form.creation': 'Creación de un operador de caja',
    'posUser.form.edit': 'Edición de un operador de caja',
    'posUser.form.update': 'Edición de un operador de caja',
    'posRole.form.title': 'Rol de caja',
    'posRole.form.description': 'Puede actualizar los permisos de su rol de caja desde esta página',
    'posRole.form.creation': 'Creación de un rol de caja',
    'posRole.form.update': 'Edición de un rol de caja',
    'posGroup.form.creation': 'Creación de un grupo de acceso',
    'posGroup.form.update': 'Edición de un grupo de acceso',
    'posRole.form.rolePermissions': 'Permisos para el rol',
    'posRole.form.name.title': 'Nombre del rol',
    'posRole.form.name.placeholder': 'Rol',
    'pos.groups.action.create': 'Crear un nuevo grupo',
    'permissions.permissions': 'Permisos',
    'assiciated.devices': 'Cajas asociadas',
    'assiciated.operators': 'Operadores asociados',
    'posRole.Operator': 'Operador',
    'posRole.Manager': 'Manager',
    'posRole.Owner': 'Gerente',
    'posRole.Auditor': 'Auditor',
    'posRole.Treasurer': 'Tesorero',
    'posRole.Support': 'Soporte',
    'posRole.Trainer': 'Formador',
    'posRole.InCharge': 'Responsable',
    'posRole.OperatorSupervisor': 'Supervisor de operadores',
    'posRole.AssistantOperator': 'Operador asistente',
    'posRole.AssistantToTheRegionalManager': 'Asistente de manager',
    'posRole.CustomOperator1': 'Operador personalizado 1',
    'posRole.CustomOperator2': 'Operador personalizado 2',
    'posRole.CustomOperator3': 'Operador personalizado 3',
    'channels.page.title': 'Lista de canales',
    'channels.page.description':
        'Los canales de pedido le permiten ofrecer funcionalidades como el pedido en línea, el pedido mediante quiosco en punto de venta o la gestión de la fidelidad.',
    'channels.installed': 'Aplicación instalada',
    'channels.button.configure': 'Configurar',
    'channels.button.disable': 'Desactivar',
    'channels.button.enable': 'Activar',
    'channels.kiosk.name': 'Quiosco',
    'channels.kiosk.description': 'Reinvente la experiencia en punto de venta de la mejor manera.',
    'channels.web.name': 'Pedido en línea',
    'channels.web.description': 'Un nuevo punto de venta desde su propio sitio web.',
    'channels.reception.name': 'Recepción',
    'channels.reception.description': 'Una interfaz dedicada para sus pedidos web y quioscos.',
    'channels.pos.name': 'POS',
    'channels.pos.description': 'Su sistema de cobro sencillo e integrado en su entorno.',
    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': 'Dinamice aún más su cocina con una organización perfecta.',
    'channels.loyalty.name': 'Fidelidad',
    'channels.loyalty.description': 'Fidelice y haga que sus clientes vuelvan al punto de venta.',
    'channels.ewallet_kiosk.name': 'Quiosco de recarga E-Wallet',
    'channels.ewallet_kiosk.description': 'El nuevo canal para recargar su E-wallet muy rápidamente.',
    'channels.vending_machine.name': 'Máquina expendedora',
    'channels.vending_machine.description':
        'Ofrezca pago con e-wallet en sus máquinas de café y expendedoras de bebidas.',
    'accessFlags.CAN_ACCESS_BRAND_HISTORY': 'Puede acceder a la página de historial de la enseña',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': 'Puede acceder a la página de Clientes',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION':
        'Puede acceder a la pestaña de Subvenciones y admisiones',
    'accessFlags.CAN_ACCESS_IO_PAY': 'Puede acceder al módulo de Pago',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': 'Puede archivar clientes',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': 'Puede crear pedidos con importe negativo',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE':
        'Puede crear pedidos que dejen el saldo del comensal en negativo',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': 'Puede acreditar el e-wallet de un comensal en post-pago',
    'accessFlags.CAN_EDIT_AREAS': 'Puede editar las zonas de entrega',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': 'Facturación automática: puede modificar el referencial',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': 'Puede editar las credenciales de los clientes',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': 'Puede exportar datos de clientes y acreditar/debitar los E-wallets',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE':
        'Puede obligar a los nuevos clientes a editar sus credenciales proporcionadas por defecto',
    'accessFlags.CAN_MANAGE_BO_USERS': 'Puede gestionar los usuarios del backoffice',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT': 'Puede gestionar el descubierto autorizado a nivel de enseña',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': 'Puede gestionar el descubierto autorizado a nivel de cliente',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME':
        'Solo puede editar el precio y el nombre de los productos y etapas asociadas',
    'accessFlags.CAN_SYNC_SALES': 'Puede sincronizar las ventas',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': 'Puede modificar los planos de mesas',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': 'Puede crear pedidos con un precio personalizado',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS':
        'Puede crear pedidos con un precio personalizado para todos los productos',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': 'Puede crear o eliminar categorías',
    'accessFlags.MENU_CATEGORY_EDIT': 'Puede editar categorías',
    'accessFlags.MENU_CREATE_OR_DELETE': 'Puede crear o eliminar menús',
    'accessFlags.MENU_EDIT': 'Puede editar menús',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': 'Puede crear o eliminar productos',
    'accessFlags.MENU_PRODUCT_EDIT': 'Puede editar productos',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': 'Restringir la edición al precio del producto',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': 'Bloquear únicamente la edición del precio de un producto',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': 'Puede crear o eliminar etapas',
    'accessFlags.MENU_STEP_EDIT': 'Puede editar etapas',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': 'Puede crear o eliminar etiquetas',
    'accessFlags.MENU_TAG_EDIT': 'Puede editar etiquetas',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': 'Puede modificar su contraseña',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': 'Puede cancelar un pedido (contrapartida)',
    'accessFlags.CAN_CREATE_SKU': 'Puede crear SKU',
    'accessFlagsGroups.customers': 'Gestión de Clientes',
    'accessFlagsGroups.financial': 'Gestión Financiera / E-Wallet',
    'accessFlagsGroups.orders': 'Gestión de Pedidos',
    'accessFlagsGroups.catalog': 'Gestión del Catálogo',
    'accessFlagsGroups.subsidies': 'Subvenciones y Admisiones',
    'accessFlagsGroups.configuration': 'Configuración del Restaurante',
    'accessFlagsGroups.administration': 'Administración y Cuenta',
    'accessFlagsGroups.others': 'Otros Permisos',
    'accessFlagsSubsections.categories': 'Categorías',
    'accessFlagsSubsections.menus': 'Menús',
    'accessFlagsSubsections.products': 'Productos',
    'accessFlagsSubsections.steps': 'Etapas',
    'accessFlagsSubsections.tags': 'Etiquetas',
    'accessFlagsControl.expandAll': 'Expandir todo',
    'accessFlagsControl.collapseAll': 'Contraer todo',
    'accessFlagsControl.permission': 'permiso',
    'accessFlagsControl.permissions': 'permisos',
    'userRestaurants.noRestaurants': 'No hay restaurantes disponibles',
    'brandUsers.email': 'Email',
    'brandUsers.lastConnection': 'Última conexión',
    'brandUsers.login': 'Conexión',
    'brandUsers.loginAs': 'Conectarse como',
    'brandUsers.loginAsBrandGroup': 'Cuenta multi-enseña (no conectable)',
    'brandUsers.newUser': '+ Nuevo usuario',
    'brandRestaurants.newRestaurant': '+ Nuevo restaurante',
    'brandRestaurants.create.restaurantInfo': 'Información del restaurante',
    'brandRestaurants.create.restaurantName': 'Nombre del restaurante',
    'brandRestaurants.create.phone': 'Número de teléfono',
    'brandRestaurants.create.address': 'Dirección',
    'brandRestaurants.create.locale': 'Idioma',
    'brandRestaurants.create.currency': 'Divisa',
    'brandRestaurants.create.operationZone': 'Zona de operación',
    'brandRestaurants.create.operationZone.skip': 'Omitir - configurar más tarde',
    'brandRestaurants.create.operationZoneConfigure': 'Configuración de la zona de operación',
    'brandRestaurants.create.operationZone.selectProvider': 'Seleccione el modo de conformidad',
    'brandRestaurants.create.operationZone.currencyMismatch':
        'Esta zona utiliza una moneda diferente a la de la marca. Se requiere una nueva marca para operar en esta moneda.',
    'brandRestaurants.create.manager': 'Gerente',
    'brandRestaurants.create.selectExistingUser': 'Seleccionar un usuario existente',
    'brandRestaurants.create.createNewUser': 'Crear un nuevo usuario',
    'brandRestaurants.create.skipManager': 'Omitir este paso',
    'brandRestaurants.create.letUserChoosePassword': 'Dejar que el usuario elija su contraseña',
    'brandRestaurants.create.done.title': '¡Ha finalizado!',
    'brandRestaurants.create.done.message': 'Está listo para configurar {name}',
    'brandRestaurants.create.done.configure': 'Configurar',
    'user.create.title': 'Cree un nuevo usuario',
    'user.create.firstName': 'Nombre',
    'user.create.lastName': 'Apellidos',
    'user.create.phone': 'Número de teléfono',
    'user.create.email': 'Email',
    'user.create.password': 'Contraseña',
    'user.create.confirmPassword': 'Confirme la contraseña',
    'user.create.letUserChoosePassword': 'Dejar que el usuario elija su contraseña',
    'user.create.error.phone.length': 'El número de teléfono debe contener 10 dígitos.',
    'user.create.error.phone.valid': 'Este número no es válido',
    'user.create.error.password.min': 'Contraseña inválida (mínimo 12 caracteres)',
    'user.create.error.passwordConfirm.sameAsPassword': 'Las dos contraseñas deben ser idénticas',
    'brands.restaurantscount': 'Número de restaurantes',
    'brands.favorite': 'Favorito',
    'brands.create': '+ Nueva enseña',
    'brands.form.title': 'Crear una nueva enseña',
    'brands.form.brandInfo': 'Información de la enseña',
    'brands.form.brandInfo.title': 'Nombre de la enseña',
    'brands.form.selectUser': 'Seleccione un responsable de enseña',
    'brands.form.selectUser.title': 'Crear un responsable de enseña',
    'brands.form.canals': 'Seleccione los canales de pedido de la enseña',
    'brands.form.canals.title': 'Gestionar los canales',
    'brands.form.brandName': 'Nombre',
    'brands.form.region': 'Región e idioma',
    'brands.form.currency': 'Divisa',
    'brands.form.firstName': 'Nombre *',
    'brands.form.lastName': 'Apellidos *',
    'brands.form.phoneNumber': 'Número de teléfono *',
    'brands.form.email': 'Email *',
    'brands.form.password': 'Contraseña *',
    'brands.form.confirmPassword': 'Confirme la contraseña *',
    'brands.form.error.phone.valid': 'Este número no es válido',
    'brands.form.error.password.min': 'Contraseña inválida (mínimo 12 caracteres)',
    'brands.form.error.passwordConfirm.sameAsPassword': 'Las dos contraseñas deben ser idénticas',
    'posPermissions.accessPermissions': 'Permisos de acceso',
    'posPermissions.otherPermissions': 'Otros permisos',
    'posPermissions.ACCESS_CATALOG_SCREEN': 'Catálogo',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': 'Clientes',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': 'Opciones',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': 'Fondo de caja',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': 'Promociones',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': 'Repartidores',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': 'Plano de mesas',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': 'Nuevo pedido',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': 'Seguimiento de pedidos',
    'posPermissions.ACCESS_PARAMETER_SCREEN': 'Parámetros',
    'posPermissions.ACCESS_PRINTER_SCREEN': 'Impresoras',
    'posPermissions.ACCESS_RAZ_SCREEN': 'Informes',
    'posPermissions.ACCESS_TICKET_SCREEN': 'Tickets',
    'posPermissions.ACCESS_USER_SCREEN': 'Usuarios',
    'posPermissions.APPLY_DISCOUNT': 'Aplicar una promoción',
    'posPermissions.CANCEL_ORDER': 'Cancelar el pedido',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': 'Cancelar un producto validado de un pedido',
    'posPermissions.CREATE_GROUP': 'Crear un grupo',
    'posPermissions.CREATE_PRODUCT': 'Crear un producto',
    'posPermissions.DELETE_DEFAULT_PRINTER': 'Eliminar la impresora predeterminada',
    'posPermissions.DISCONNECT': 'Desconectar una caja',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': 'Introducir un descuento al realizar un pedido',
    'posPermissions.EXPORT_ARCHIVE': 'Exportar los archivos',
    'posPermissions.FORCE_ORDER_SHIFT': 'Forzar el servicio de un pedido',
    'posPermissions.GENERATE_ARCHIVE': 'Generar los archivos fiscales',
    'posPermissions.JUSTIFY_ORDERS': 'Justificar los pedidos',
    'posPermissions.LINK_A_BADGE': 'Asociar una tarjeta',
    'posPermissions.MODIFY_FEATURE_OPTIONS': 'Modificar las opciones',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': 'Modificar una función con pulsación prolongada',
    'posPermissions.MODIFY_GROUP_FROM_GRID': 'Modificar un grupo con pulsación prolongada',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': 'Modificar el precio de un producto en el carrito',
    'posPermissions.MODIFY_PASSWORD': 'Modificar la contraseña',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': 'Mostrar la ficha de producto',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE':
        'Modificar código de producto, facturación y precio de facturación',
    'posPermissions.MODIFY_PRODUCT_PRICE': 'Modificar el precio en la ficha de producto',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': 'Modificar las demás propiedades en la ficha de producto',
    'posPermissions.MODIFY_TICKET': 'Modificar el ticket',
    'posPermissions.MODIFY_TICKET_GROUPS': 'Modificar los grupos de los tickets',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': 'Modificar el tipo de pedido de los tickets',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': 'Modificar el estado de pedido de los tickets',
    'posPermissions.MODIFY_TICKET_QUANTITY': 'Modificar las cantidades de los tickets',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': 'Modificar un producto validado de un pedido',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': 'Ofrecer un producto',
    'posPermissions.OPEN_CASH_DRAWER': 'Abrir el cajón de caja',
    'posPermissions.PRINT_VALID_TICKET': 'Imprimir los tickets validados',
    'posPermissions.REFUND_CLIENT': 'Reembolsar a un cliente',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': 'Eliminar un producto del catálogo',
    'posPermissions.REOPEN_ORDER': 'Reabrir un pedido',
    'posPermissions.SEARCH_CLIENT': 'Buscar un cliente manualmente',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': 'Mostrar el botón Comida Forzada en la pantalla de nuevo pase',
    'posPermissions.SYNC_ARCHIVE': 'Sincronizar los archivos',
    'posPermissions.VIEW_AUDIT_TRAIL': 'Ver la pista de auditoría',
    'posPermissions.VIEW_FEATURE_OPTIONS': 'Ver las opciones',
    'posPermissions.VIEW_ORDER_AUDIT': 'Ver las auditorías de pedidos',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': 'Mostrar el volumen de negocio en los informes',
    'posPermissions.VIEW_TICKET_AUDIT': 'Ver las auditorías de tickets',
    'posPermissions.VIEW_TICKET_TEMPLATE': 'Ver las plantillas de tickets',
    'posPermissions.MODIFY_TICKET_PRINTER': 'Modificar la impresora de tickets',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': 'Validar las operaciones TPE',
    'multiBrand.user': 'Usuario',
    'badgeReader.empty': 'Ningún lector de tarjetas configurado',
    'badgeReader.notConfigured': 'Parece que no tiene ningún lector de tarjetas configurado. Diríjase a nuestra',
    'badgeReader.help': 'sección de ayuda.',
    'badgeReader.create': 'Crear un lector de tarjetas',
    'badgeReader.table.title': 'Lectores de tarjetas',
    'badgeReader.table.name': 'Nombre del lector',
    'badgeReader.table.deviceUuid': 'UUID del lector',
    'badgeReader.table.driver': 'Tecnología del lector',
    'badgeReader.table.driverConfigs': 'Variables de la tecnología',
    'badgeReader.table.readingConditions': 'Reglas de lectura',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': 'Condición #{index}:',
    'badgeReader.readingCondition.stringLength': '• Si longitud = {stringLength} carácter(es)',
    'badgeReader.readingCondition.convertBefore.none': '• No se realiza conversión',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• Se convierte a decimales = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• Se convierte a ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• Se convierte a hexadecimal = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• Se eliminan los ceros',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• Se invierten los caracteres',
    'badgeReader.readingCondition.convertBefore.prefix':
        '• Se añade prefijo con el carácter {prefix} hasta {substrLength} caracteres',
    'badgeReader.readingCondition.substrPositionStart': '• Se lee a partir del carácter {substrPositionStart}',
    'badgeReader.readingCondition.substrLength': '• Se leen {substrLength} carácter(es)',
    'badgeReader.readingCondition.convertAfter.none': '• No se convierten estos {substrLength} carácter(es)',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• Se convierten estos caracteres decimales a {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex':
        '• Se convierten estos caracteres hexadecimales a {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• Se convierten estos caracteres ASCII a {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• Se eliminan los ceros',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• Se invierten estos {substrLength} caracteres',
    'badgeReader.delete.confirmation': '¿Está seguro de que desea eliminar?',
    'badgeReader.delete.warning': 'Atención',
    'badgeReader.cancel.confirmation': '¿Está seguro de que desea cancelar la configuración?',
    'badgeReader.cancel.warning': 'Atención',
    'badgeReader.driver.keyboard': 'Salida de teclado',
    'badgeReader.driver.serial': 'Protocolo serie (RS232)',
    'badgeReader.driver.toqla': 'Toqla',
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    'badgeReader.convertion.none': 'sin conversión',
    'badgeReader.convertion.hex-dec': 'hexadecimal a decimales',
    'badgeReader.convertion.hex-ascii': 'hexadecimal a ASCII',
    'badgeReader.convertion.dec-hex': 'decimales a hexadecimal',
    'badgeReader.step.information': 'Creación de lector',
    'badgeReader.step.driverConfigs': 'Variables de tecnología',
    'badgeReader.step.readingCondition': 'Reglas de lectura',
    'badgeReader.form.name': 'Nombre del lector',
    'badgeReader.form.deviceId': 'Identificador USB del lector',
    'badgeReader.form.deviceUuid': 'UUID del lector',
    'badgeReader.form.driver': 'Tecnología del lector',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': 'Disposición del teclado',
    'badgeReader.form.readingCondition.order': 'Condición n.°',
    'badgeReader.form.readingCondition.stringLength': 'Longitud',
    'badgeReader.form.readingCondition.convertBefore': '¿Conversión antes?',
    'badgeReader.form.readingCondition.substrPositionStart': 'Inicio / Prefijo',
    'badgeReader.form.readingCondition.substrLength': 'Longitud',
    'badgeReader.form.readingCondition.convertAfter': '¿Conversión después?',
    'badgeReader.step.readingCondition.add': 'Añadir +',
    'badgeReader.form.convertion.none': 'Desactivado',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': 'Eliminar los ceros',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': 'Hexadecimal invertido bit a bit',
    'badgeReader.form.convertion.prefix': 'Prefijo',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',
    'posDevice.catalogHistory.title': 'Historial de catálogos',
    'posDevice.catalogHistory.table.hash': 'Hash',
    'posDevice.catalogHistory.table.date': 'Fecha de creación',
    'posDevice.catalogHistory.table.actions': 'Acciones',
    'posDevice.catalogHistory.button.download': 'Descargar',
    'passwordUpdate.title': 'Actualización de contraseña',
    'passwordUpdate.currentPassword': 'Contraseña actual',
    'passwordUpdate.newPassword': 'Nueva contraseña',
    'passwordUpdate.confirmPassword': 'Confirme la nueva contraseña',
    'passwordUpdate.update': 'Guardar',
    'passwordUpdate.passwordMismatch': 'La nueva contraseña y la confirmación no coinciden.',
    'passwordUpdate.passwordMinLength': 'La contraseña debe contener al menos 12 caracteres.',
    'passwordUpdate.success': 'Contraseña actualizada correctamente',
    'notification.guestHierarchy.title': 'Nuevo',
    'notification.guestHierarchy.content': 'La configuración de la jerarquía de cuentas está evolucionando.',
    'notification.guestHierarchy.link': 'Haga clic para saber más',
    'guestHierarchyTraining.page1.title': 'Bienvenido al encuadramiento de recorridos de clientes',
    'guestHierarchyTraining.page1.content':
        'El encuadramiento de recorridos de clientes permite una configuración estricta de las cuentas de comensales en el Back-Office (BO). Se basa en una jerarquía en <b>Grupo → Sección → Subsección</b> y la asignación de <b>regímenes tarifarios</b> a estos elementos. Esta estructuración garantiza una gestión optimizada y coherente.',
    'guestHierarchyTraining.page2.title': 'Acceder a la Jerarquización',
    'guestHierarchyTraining.page2.content':
        'Abra la nueva pestaña <b>Jerarquización</b>. Este espacio permite <b>crear y modificar</b> los grupos, secciones y subsecciones.',
    'guestHierarchyTraining.page3.title': 'Crear o modificar un Grupo',
    'guestHierarchyTraining.page3.content':
        '• Acceda a <b>Jerarquización > Grupos.</b> {br}• Haga clic en <b>"Crear un grupo"</b> o modifique uno existente. {br}• Un grupo tiene un <b>nombre único</b> (1) {br}• Defina los <b>regímenes tarifarios autorizados</b> para los comensales vinculados a este grupo (2)',
    'guestHierarchyTraining.page4.title': 'Crear o modificar una Sección',
    'guestHierarchyTraining.page4.content':
        '• Acceda a <b>Jerarquización > Secciones.</b> {br}• Haga clic en <b>"Crear una sección"</b> o modifique una existente. {br}• Asigne una sección a un <b>grupo existente</b>. (1) {br}• Se requiere un nombre único. (2) {br} • Defina los <b>regímenes tarifarios autorizados</b> para los comensales vinculados a esta sección (3)',
    'guestHierarchyTraining.page5.title': 'Crear o modificar una Subsección',
    'guestHierarchyTraining.page5.content':
        '• Acceda a <b>Jerarquización > Subsecciones.</b> {br}• Haga clic en <b>"Crear una subsección"</b> o modifique una existente. {br}• Asigne una subsección a una <b>sección existente</b>. (1 y 2) {br}• Se requiere un nombre único. (3) {br} • Defina los <b>regímenes tarifarios autorizados</b> para los comensales vinculados a esta subsección (4)',
    'guestHierarchyInfo.title': 'Creación de comensales',
    'guestHierarchyInfo.content':
        'Al crear un comensal, los regímenes tarifarios propuestos se filtran automáticamente en función del grupo, la sección o la subsección seleccionada.',
    'loyalty.features.title': 'Funcionalidades activadas',
    'loyalty.features.MultiRewardSelection': 'Selección múltiple de recompensas',
    'loyalty.features.Promocode': 'Códigos promocionales',
    'loyalty.features.Deals': 'Ofertas',
    'loyalty.features.PointPayment': 'Pago por puntos',
    'splio.title': 'Integración - Fidelidad Splio',
    'splio.integrationEnabled': 'Integración activada desde {date}',
    'splio.description':
        'Introduzca la clave API en el siguiente campo para asociar su programa Splio con su restaurante y sus productos Innovorder.\nEsta clave API debe obtenerse desde su interfaz Splio.',
    'splio.apiKey.placeholder': 'Introduzca su clave API Splio',
    'splio.apiKey': 'Clave API Splio',
    'splio.programId': 'Programa de fidelidad',
    'splio.allowCustomerRewardUsage': 'Autorizar el uso de recompensas por parte de los clientes',
    'splio.formLink': 'Enlace al formulario de inscripción',
    'splio.optIn': 'OptIn asociado al boletín de marketing',
    'splio.memberIdentifier': 'Identificador para la creación de cuenta',
    'splio.useCasualTone': 'Activar el tuteo',
    'splio.authenticationMethods': 'Métodos de autenticación de fidelidad autorizados',
    'splio.registerMethods': 'Métodos de inscripción de fidelidad autorizados',
    'splio.methods.email': 'E-mail',
    'splio.methods.phone': 'Teléfono',
    'splio.methods.externalId': 'Identificador de fidelidad',
    'splio.update.success': 'Integración Splio actualizada correctamente',
    'splio.subscriptionToMarketingNewsletter': 'Suscripción al boletín de marketing',
    'splio.subscriptionToLoyaltyNewsletter': 'Suscripción al boletín de fidelidad',
    'splio.deleteModal.title': 'Eliminación de la integración Splio',
    'splio.deleteModal.text': '¿Está seguro de que desea eliminar la integración Splio?',
    'splio.error.formLinkInvalid': 'Enlace de formulario inválido',
    'splio.error.changeProvider':
        'Ya hay una integración de fidelidad configurada para este restaurante, elimínela primero',
    'pickupPoint.page.title': 'Puntos de recogida',
    'pickupPoint.page.description': 'Cree y gestione sus puntos de recogida',
    'pickupPoint.action.create': 'Crear un punto de recogida',
    'pickupPoint.modal.createPickupPoint': 'Creación de un punto de recogida',
    'pickupPoint.modal.editPickupPoint': 'Modificación de un punto de recogida',
    'pickupPoint.modal.deletePickupPoint': 'Eliminación de un punto de recogida',
    'pickupPoint.modal.delete.title': 'Eliminar un punto de recogida',
    'pickupPoint.modal.delete.description': '¿Está seguro de que desea eliminar el punto de recogida "{name}"?',
    'pickupPoint.modal.pickupPoint.name': 'Nombre',
    'pickupPoint.modal.pickupPoint.address': 'Dirección',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': 'Complemento de dirección',
    'pickupPoint.modal.pickupPoint.name.placeholder': 'Nombre del punto de recogida',
    'pickupPoint.modal.pickupPoint.address.placeholder': 'Dirección del punto de recogida',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': 'Complemento de dirección del punto de recogida',
    'pickupPoint.modal.warn.shift.title': 'Atención',
    'pickupPoint.modal.warn.shift.text':
        'Asegúrese de que no haya ningún pedido en curso antes de eliminar este punto de recogida. Una vez eliminado, dejará de ser visible para los clientes y los pedidos en curso se perderán.',
    'pickupPoint.modal.warn.shift.button': 'Entendido',
    'como.title': 'Integración - Fidelidad Como',
    'como.description':
        'Introduzca la clave API en el siguiente campo para asociar su programa Como con su restaurante y sus productos Innovorder.\nEsta clave API debe obtenerse desde su interfaz Como.',
    'como.apiKey': 'Clave API Como',
    'como.integrationEnabled': 'Integración activada desde {date}',
    'como.apiKey.placeholder': 'Introduzca su clave API Como',
    'como.formLink': 'Enlace al formulario de inscripción',
    'como.useCasualTone': 'Activar el tuteo',
    'como.authenticationMethods': 'Métodos de autenticación de fidelidad autorizados',
    'como.registerMethods': 'Métodos de inscripción de fidelidad autorizados',
    'como.methods.email': 'E-mail',
    'como.methods.phone': 'Teléfono',
    'como.methods.externalId': 'Identificador de fidelidad',
    'como.error.formLinkInvalid': 'Enlace de formulario inválido',
    'como.update.success': 'Integración Como actualizada correctamente',
    'como.deleteModal.title': 'Eliminación de la integración Como',
    'como.deleteModal.text': '¿Está seguro de que desea eliminar la integración Como?',
    'como.error.changeProvider':
        'Ya hay una integración de fidelidad configurada para este restaurante, elimínela primero',
    'como.error.invalidApiKey': 'La clave API introducida no es válida.',
    'zerosix.title': 'Integración - Fidelidad Zerosix',
    'zerosix.description':
        'Introduzca la clave API en el siguiente campo para asociar su programa Zerosix con su restaurante y sus productos Innovorder.\nEsta clave API debe obtenerse desde su interfaz Zerosix.',
    'zerosix.apiKey': 'Clave API Zerosix',
    'zerosix.integrationEnabled': 'Integración activada desde {date}',
    'zerosix.apiKey.placeholder': 'Introduzca su clave API Zerosix',
    'zerosix.formLink': 'Enlace al formulario de inscripción',
    'zerosix.useCasualTone': 'Activar el tuteo',
    'zerosix.authenticationMethods': 'Métodos de autenticación de fidelidad autorizados',
    'zerosix.registerMethods': 'Métodos de inscripción de fidelidad autorizados',
    'zerosix.methods.email': 'E-mail',
    'zerosix.methods.phone': 'Teléfono',
    'zerosix.methods.externalId': 'Identificador de fidelidad',
    'zerosix.error.formLinkInvalid': 'Enlace de formulario inválido',
    'zerosix.update.success': 'Integración Zerosix actualizada correctamente',
    'zerosix.deleteModal.title': 'Eliminación de la integración Zerosix',
    'zerosix.deleteModal.text': '¿Está seguro de que desea eliminar la integración Zerosix?',
    'zerosix.error.changeProvider':
        'Ya hay una integración de fidelidad configurada para este restaurante, elimínela primero',
    'zerosix.error.invalidApiKey': 'La clave API introducida no es válida.',
    'restaurantInfo.title': 'Información del restaurante',
    'restaurantInfo.information.title': 'Acerca del restaurante',
    'restaurantInfo.name': 'Nombre del restaurante',
    'restaurantInfo.address': 'Dirección del restaurante',
    'restaurantInfo.contactName': 'Nombre del contacto',
    'restaurantInfo.contactEmail': 'Dirección de email',
    'restaurantInfo.contactPhone': 'Número de teléfono',
    'restaurantInfo.externalId': 'Identificador externo',
    'restaurantInfo.tag': 'Etiqueta del restaurante',
    'restaurantInfo.families': 'Familias del restaurante',
    'restaurantInfo.searchFamilies': 'Buscar una familia',
    'restaurantInfo.image': 'Imagen del restaurante',
    'restaurantInfo.legal.title': 'Información legal',
    'restaurantInfo.legal.description':
        'Esta información se utiliza para generar las condiciones generales de venta y los avisos legales de los canales de pedido',
    'restaurantInfo.legal.socialReason': 'Razón social',
    'restaurantInfo.legal.organizationType': 'Tipo de organización',
    'restaurantInfo.legal.capital': 'Capital social',
    'restaurantInfo.legal.commerceRegistryCity': 'Ciudad de registro en el RCS',
    'restaurantInfo.legal.siren': 'Siren',
    'restaurantInfo.legal.taxNumber': 'Número de IVA',
    'restaurantInfo.legal.industryClassificationCode': 'Código NAF',
    'restaurantInfo.legal.publicationDirectorName': 'Nombre del director de publicación',
    'restaurantInfo.legal.publicationDirectorFunction': 'Función del director de publicación',
    'restaurantInfo.legal.webmasterName': 'Nombre del webmaster',
    'restaurantInfo.legal.webmasterEmail': 'Email del webmaster',
    'restaurantInfo.ewalletMinimum.title': 'Configuración del saldo mínimo de e-wallet autorizado en el Scan Plateau',
    'restaurantInfo.ewalletMinimum.inputTitle': 'IMPORTE MÍNIMO',
    'restaurantInfo.ewalletMinimum.caseZero':
        'Para no establecer un mínimo de tarjeta, indique 0 en el campo y guarde.',
    'restaurantInfo.delete.title': 'Eliminación de restaurante',
    'restaurantInfo.delete.description': 'Este restaurante existe desde el',
    'restaurantInfo.delete.button': 'Eliminar este restaurante',
    'restaurantInfo.save.error': 'Se ha producido un error al guardar, inténtelo de nuevo.',
    'restaurantInfo.delete.error': 'Se ha producido un error, vuelva a realizar su configuración.',
    'restaurantInfo.delete.confirmTitle': 'Eliminación de restaurante',
    'restaurantInfo.delete.confirmDescription':
        '¿Está seguro de que desea eliminar este restaurante? Esta acción es irreversible.',
    'restaurantInfo.schedule.title': 'Horarios de recogida autorizados',
    'restaurantInfo.schedule.manualEdit': 'Edición manual',
    'restaurantInfo.schedule.autoEdit': 'Edición automática',
    'restaurantInfo.schedule.autoEditDescription': 'Permite crear franjas horarias rápidamente.',
    'restaurantInfo.schedule.description':
        'Puede configurar diferentes horarios de recogida autorizados para su restaurante. Estos horarios corresponden a los horarios de apertura de su restaurante, durante los cuales sus clientes podrán recoger sus pedidos realizados en línea.',
    'restaurantInfo.schedule.open': 'Abierto',
    'restaurantInfo.schedule.closed': 'Cerrado',
    'restaurantInfo.schedule.day.mon': 'Lun',
    'restaurantInfo.schedule.day.tue': 'Mar',
    'restaurantInfo.schedule.day.wed': 'Mié',
    'restaurantInfo.schedule.day.thu': 'Jue',
    'restaurantInfo.schedule.day.fri': 'Vie',
    'restaurantInfo.schedule.day.sat': 'Sáb',
    'restaurantInfo.schedule.day.sun': 'Dom',
    'restaurantInfo.schedule.mass.startHour': 'Hora de inicio',
    'restaurantInfo.schedule.mass.endHour': 'Hora de fin',
    'restaurantInfo.schedule.mass.granularity': 'Intervalo',
    'restaurantInfo.schedule.mass.15min': '15 min',
    'restaurantInfo.schedule.mass.30min': '30 min',
    'restaurantInfo.schedule.mass.1h': '1 hora',
    'restaurantInfo.schedule.mass.overwrite': 'Sobrescribir los horarios existentes',
    'restaurantInfo.schedule.mass.apply': 'Aplicar',
    'restaurantInfo.schedule.mass.noDays': 'Seleccione al menos un día.',
    'restaurantInfo.schedule.mass.midnight': 'medianoche',
    'order.customer.loyalty.anonymous': 'Anónimo {email}',
    'route.vatRatesMatrix': 'Referencial de IVA',
    'vatRatesMatrix.title': 'Referencial de IVA Global',
    'vatRatesMatrix.subtitle':
        'Fuente única de verdad para la fiscalidad de todos los productos Innovorder. Las modificaciones se aplican automáticamente a los nuevos productos.',
    'vatRatesMatrix.vatGroup': 'Familia de IVA',
    'vatRatesMatrix.codeLabel': 'Código',
    'vatRatesMatrix.eatIn': 'En local',
    'vatRatesMatrix.takeAway': 'Para llevar',
    'vatRatesMatrix.delivery': 'Entrega',
    'vatRatesMatrix.exportCsv': 'Exportar CSV',
    'vatRatesMatrix.exportError': 'Se ha producido un error al exportar el CSV. Inténtelo de nuevo.',
    'vatRatesMatrix.filterByZone': 'Filtrar por zona',
    'vatRatesMatrix.filterByGroup': 'Filtrar por familia',
    'vatRatesMatrix.filterByMode': 'Filtrar por modo',
    'vatRatesMatrix.loading': 'Cargando...',
    'vatRatesMatrix.error': 'Error al cargar los datos.',
    'vatRatesMatrix.family.FOOD': 'Alimentación',
    'vatRatesMatrix.family.NON_ALCOHOL': 'Sin alcohol',
    'vatRatesMatrix.family.ALCOHOL': 'Alcohol',
    'vatRatesMatrix.family.NORMAL': 'Normal',
    'vatRatesMatrix.family.NONE': 'Ninguna',
    'route.promotionalBanners': 'Banners promocionales',
    'promotionalBanner.page.title': 'Gestión de banners',
    'promotionalBanner.page.subtitle': 'Cree y gestione sus banners promocionales para mostrarlos en su quiosco.',
    'promotionalBanner.page.emptyState':
        'Cree un banner promocional para promocionar sus productos y categorías en su quiosco.',
    'promotionalBanner.page.emptyStateCta': 'Crear un banner',
    'promotionalBanner.page.noActiveMenu.title': 'Ningún menú de quiosco activo',
    'promotionalBanner.page.noActiveMenu.desc':
        '👉 Active un menú de quiosco para acceder a la configuración de los banners.',
    'promotionalBanner.page.noActiveMenu.cta': 'Gestionar mis menús',
    'promotionalBanner.action.create': 'Crear un banner',
    'promotionalBanner.action.edit': 'Modificar',
    'promotionalBanner.action.view': 'Ver',
    'promotionalBanner.action.delete': 'Eliminar',
    'promotionalBanner.action.activate': 'Activar',
    'promotionalBanner.action.deactivate': 'Desactivar',
    'promotionalBanner.table.listTitle': 'Lista de banners promocionales',
    'promotionalBanner.modal.createTitle': 'Crear un banner',
    'promotionalBanner.modal.editTitle': 'Modificar el banner',
    'promotionalBanner.modal.viewTitle': 'Ver el banner',
    'promotionalBanner.modal.close': 'Cerrar',
    'promotionalBanner.modal.name': 'Nombre',
    'promotionalBanner.modal.channel': 'Canal',
    'promotionalBanner.modal.image': 'Imagen',
    'promotionalBanner.modal.linkType': 'Tipo de enlace',
    'promotionalBanner.modal.linkTarget': 'Destino',
    'promotionalBanner.modal.activateAndSave': 'Activar y guardar',
    'promotionalBanner.modal.saveAsDraft': 'Guardar como borrador',
    'promotionalBanner.modal.updateBanner': 'Actualizar el banner',
    'promotionalBanner.modal.deactivateBanner': 'Desactivar el banner',
    'promotionalBanner.modal.imageSizeError': 'La imagen no debe superar 5 MB',
    'promotionalBanner.modal.nameHelper': 'Este nombre solo es visible en el backoffice.',
    'promotionalBanner.modal.nameLabel': 'Nombre del banner',
    'promotionalBanner.modal.channelLabel': 'Canal objetivo',
    'promotionalBanner.modal.channelKiosk': 'Quiosco',
    'promotionalBanner.modal.channelKioskDesc': 'Muestra el banner al inicio del recorrido de pedido en el quiosco.',
    'promotionalBanner.modal.channelWeb': 'CEL',
    'promotionalBanner.modal.channelWebDesc': 'Visualización en el recorrido de pedido en línea.',
    'promotionalBanner.modal.channelWebDisabled': 'Disponible próximamente.',
    'promotionalBanner.modal.imageLabel': 'Imagen del banner',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · Máx 5 MB · Formato 3:1',
    'promotionalBanner.modal.image.error.ratio': 'El formato debe ser 3:1',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': 'Tipo de enlace',
    'promotionalBanner.modal.linkNone': 'Ningún enlace',
    'promotionalBanner.modal.linkNoneDesc': 'Es informativo y no es clicable.',
    'promotionalBanner.modal.linkProduct': 'Producto',
    'promotionalBanner.modal.linkProductDesc': 'Redirige a la ficha de producto si se hace clic.',
    'promotionalBanner.modal.linkCategory': 'Categoría',
    'promotionalBanner.modal.linkCategoryDesc': 'Redirige a la categoría si se hace clic.',
    'promotionalBanner.modal.activateBanner': 'Activar el banner',
    'promotionalBanner.modal.replace': 'Reemplazar',
    'promotionalBanner.modal.searchCategory': 'Buscar una categoría...',
    'promotionalBanner.modal.searchProduct': 'Buscar un producto por nombre o SKU...',
    'promotionalBanner.table.name': 'Nombre',
    'promotionalBanner.table.status': 'Estado',
    'promotionalBanner.table.source': 'Fuente',
    'promotionalBanner.table.linkType': 'Tipo de enlace',
    'promotionalBanner.table.actions': 'Acciones',
    'promotionalBanner.table.sourceRestaurant': 'Restaurante',
    'promotionalBanner.table.sourceBrand': 'Enseña',
    'promotionalBanner.table.linkNone': 'Ningún enlace',
    'promotionalBanner.table.linkCategory': 'Categoría',
    'promotionalBanner.table.linkProduct': 'Producto',
    'promotionalBanner.table.statusActive': 'Activo',
    'promotionalBanner.table.statusInactive': 'Inactivo',
    'promotionalBanner.table.linkDeleted': 'eliminado',
    'promotionalBanner.confirm.title': 'Hay un servicio en curso',
    'promotionalBanner.confirm.message':
        'Esta acción recargará todos los quioscos e interrumpirá los pedidos en curso.',
    'promotionalBanner.confirm.confirm': 'Confirmar',
    'promotionalBanner.confirm.cancel': 'Cancelar',
    'promotionalBanner.delete.title': 'Eliminar el banner',
    'promotionalBanner.delete.description': '¿Está seguro de que desea eliminar este banner?',
    'promotionalBanner.confirm.message.bulk':
        'Esta acción recargará los quioscos de {count} restaurantes e interrumpirá los pedidos en curso.',
    'promotionalBanner.action.duplicate': 'Duplicar',
    'promotionalBanner.duplicate.fallback.title': 'Banner duplicado sin enlace',
    'promotionalBanner.duplicate.fallback.product':
        'La copia de «{sourceName}» se ha creado sin enlace: el SKU no se ha encontrado en su menú de quiosco activo.',
    'promotionalBanner.duplicate.fallback.category':
        'La copia de «{sourceName}» se ha creado sin enlace: la categoría no se ha encontrado en su menú de quiosco activo.',
    'promotionalBanner.duplicate.fallback.dismiss': 'Entendido',
    'route.brand.promotionalBanners': 'Banners promocionales',
    'brandPromotionalBanner.page.title': 'Banners promocionales de enseña',
    'brandPromotionalBanner.page.subtitle': 'Configure y propague los banners en los restaurantes de la enseña.',
    'brandPromotionalBanner.page.empty': 'Aún no hay ningún banner.',
    'brandPromotionalBanner.action.create': 'Crear un banner',
    'brandPromotionalBanner.table.name': 'Nombre',
    'brandPromotionalBanner.table.status': 'Estado',
    'brandPromotionalBanner.table.source': 'Fuente',
    'brandPromotionalBanner.table.link': 'SKU o categoría',
    'brandPromotionalBanner.table.activeRestaurants': '{count} restaurantes activos',
    'brandPromotionalBanner.table.actions': 'Acciones',
    'brandPromotionalBanner.modal.createTitle': 'Crear un banner de enseña',
    'brandPromotionalBanner.modal.editTitle': 'Modificar el banner',
    'brandPromotionalBanner.modal.name.label': 'Nombre del banner',
    'brandPromotionalBanner.modal.image.label': 'Imagen',
    'brandPromotionalBanner.modal.image.hint': 'Formato 3:1, máx 5 MB',
    'brandPromotionalBanner.modal.image.error.ratio': 'El formato debe ser 3:1',
    'brandPromotionalBanner.modal.image.error.size': 'La imagen supera 5 MB',
    'brandPromotionalBanner.modal.channel.label': 'Canal',
    'brandPromotionalBanner.modal.channel.comingSoon': 'Próximamente disponible',
    'brandPromotionalBanner.modal.link.label': 'Tipo de enlace',
    'brandPromotionalBanner.modal.link.none': 'Ningún enlace',
    'brandPromotionalBanner.modal.link.product': 'Producto (SKU)',
    'brandPromotionalBanner.modal.link.category': 'Categoría',
    'brandPromotionalBanner.modal.link.product.hint':
        'Si el SKU no se encuentra en el menú de quiosco activo de un restaurante, el banner se mostrará sin enlace en ese restaurante.',
    'brandPromotionalBanner.modal.link.category.hint':
        'Si la categoría no se encuentra en el menú de quiosco activo de un restaurante, el banner se mostrará sin enlace en ese restaurante.',
    'brandPromotionalBanner.modal.restaurants.label': 'Restaurantes objetivo',
    'brandPromotionalBanner.modal.restaurants.empty': 'Seleccione al menos un restaurante',
    'brandPromotionalBanner.modal.button.cancel': 'Cancelar',
    'brandPromotionalBanner.modal.button.saveDraft': 'Guardar como borrador',
    'brandPromotionalBanner.modal.button.activate': 'Activar el banner',
    'brandPromotionalBanner.modal.button.deactivate': 'Desactivar el banner',
    'brandPromotionalBanner.modal.button.update': 'Actualizar el banner',
    'brandPromotionalBanner.delete.title': '¿Eliminar el banner?',
    'brandPromotionalBanner.delete.message': 'El banner se retirará de todos los restaurantes asociados.',
    'brandPromotionalBanner.carousel.title': 'Tiempo de visualización entre dos banners',
    'brandPromotionalBanner.carousel.description': 'Defina el tiempo de visualización entre dos banners activos.',
    'brandPromotionalBanner.carousel.helper': 'Tiempo de espera entre la visualización de dos banners activos.',
    'brandPromotionalBanner.carousel.seconds': 'segundos',
    'brandPromotionalBanner.carousel.save': 'Guardar',
    'brandPromotionalBanner.carousel.saved': 'Tiempo actualizado',
    'brandPromotionalBanner.carousel.help':
        'Este tiempo se aplicará a todos los restaurantes de la enseña en la próxima recarga de los quioscos.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel': 'Este restaurante no tiene el quiosco activado.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu':
        'Este restaurante no tiene un menú de quiosco activo.',

    // Shifts (servicios horarios) — pestaña enseña
    'shift.tableCard.title': 'Servicios',
    'shift.tableCard.subtitle': 'Cree y gestione los servicios (franjas horarias) de sus restaurantes.',
    'shift.tableCard.action': '+ Añadir un servicio',
    'shift.emptyMessage': 'Ningún servicio configurado para este restaurante.',
    'shift.selectRestaurantPrompt': 'Seleccione un restaurante para ver sus servicios.',
    'shift.search': 'Buscar un servicio',
    'shift.adminOnly': 'Esta página solo es accesible para administradores.',
    'shift.restaurantSelector': 'Restaurante',
    'shift.restaurantSelector.placeholder': 'Seleccione un restaurante',
    'shift.column.name': 'Nombre',
    'shift.column.restaurant': 'Restaurante',
    'shift.column.daysOfWeek': 'Días',
    'shift.column.hours': 'Horarios',
    'shift.column.isEnabled': 'Activado',
    'shift.column.isDefault': 'Predeterminado',
    'shift.column.action': 'Acción',
    'shift.badge.enabled': 'Activado',
    'shift.badge.disabled': 'Desactivado',
    'shift.badge.default': 'Predeterminado',
    'shift.day.MON': 'Lun',
    'shift.day.TUE': 'Mar',
    'shift.day.WED': 'Mié',
    'shift.day.THU': 'Jue',
    'shift.day.FRI': 'Vie',
    'shift.day.SAT': 'Sáb',
    'shift.day.SUN': 'Dom',
    'shift.form.title.create': 'Nuevo servicio',
    'shift.form.title.edit': 'Editar servicio',
    'shift.form.subtitle': 'Defina los días, horarios y opciones del servicio.',
    'shift.field.name': 'Nombre',
    'shift.field.name.placeholder': 'Ej. Servicio de almuerzo',
    'shift.field.restaurant': 'Restaurante',
    'shift.field.restaurant.placeholder': 'Seleccione un restaurante',
    'shift.field.restaurant.hint.edit': 'El restaurante no se puede modificar después de la creación.',
    'shift.field.daysOfWeek': 'Días de la semana',
    'shift.field.daysOfWeek.placeholder': 'Seleccione los días',
    'shift.field.start': 'Inicio',
    'shift.field.end': 'Fin',
    'shift.field.endsTomorrow': 'Termina al día siguiente',
    'shift.field.color': 'Color',
    'shift.field.isEnabled': 'Servicio activo',
    'shift.field.isDefault': 'Servicio predeterminado',
    'shift.field.isDefault.hint': 'El servicio predeterminado no se puede modificar después de la creación.',
    'shift.error.daysOfWeek.required': 'Seleccione al menos un día.',
    'shift.error.hours.format': 'Formato no válido (HH:mm).',
    'shift.error.hours.inconsistency': 'La hora de fin debe ser posterior a la hora de inicio.',
    'shift.error.color.format': 'Color no válido.',
    'shift.delete.modal.warning': 'Atención',
    'shift.delete.modal.confirmDelete': '¿Está seguro de que desea eliminar este servicio?',
    'shift.delete.modal.title': 'Eliminación no permitida',
    'shift.delete.modal.defaultBlocked': 'El servicio predeterminado no se puede eliminar.',
    'shift.api.error.shift_cannot_delete_default': 'El servicio predeterminado no se puede eliminar.',
    'shift.api.error.shift_overlap': 'El servicio se solapa con un servicio existente.',
    'shift.api.error.shift_default_already_exists': 'Ya existe un servicio predeterminado para este restaurante.',
    'shift.api.error.shift_wrong_days_of_week_format': 'Formato de días no válido.',
    'shift.api.error.shift_wrong_hours_format': 'Formato de horas no válido.',
    'shift.api.error.shift_hours_inconsistency': 'La hora de inicio debe ser inferior a la hora de fin.',
    'shift.api.error.shift_cannot_edit_default': 'El servicio predeterminado no se puede editar.',
};

export default translationEs;
